export default {
  en: {
    maxBonusAmount: 'Max Bonus Amount',
    minDepositAmount: 'Min Deposit Amount',
    maxRedeemAmount: 'Max Redeem Amount',
    minBetAmount: 'Min Bet Amount',
    contributionPercent: 'Contribution, %',
    cashbackPercent: 'Cashback, %',
    currencies: 'Currencies',
    triggerPeriod: 'Trigger Period',
    activationPeriod: 'Activation Period',
    playthrough: 'Playthrough',
    wageringPeriod: 'Wagering Period',
    issueBonus: 'Issue Bonus',
    bonusId: 'Bonus ID',
    promoName: 'Promo Name',
    promoCode: 'Promo Code',
    promoCodeType: 'Promo Code Type',
    lPromoCode: 'promo code',
    maxUseCount: 'Max Use Count',
    dateUsed: 'Date Used',
    promotionEndDate: 'Promotion End Date',
    issuedBy: 'Issued By',
    canceledBy: 'Canceled By',
    mobileVerified: 'Mobile Verified',
    identityVerified: 'Identity Verified',
    emailVerified: 'Email Verified',
    disconnectedBy: 'Disconnected By',
    disconnectTrigger: 'Disconnect Trigger',
    turnoverAmount: 'Turnover Amount',
    remainingTurnover: 'Remaining Turnover',
    bonusStatus: 'Bonus Status',
    triggeredDate: 'Triggered Date',
    providerMayDisabled: 'Provider may has been disabled.',
    gameMayDisabled: 'Game may has been disabled.',
    maxCashbackAmount: 'Max Cashback Amount',
    cashbackId: 'Cashback ID',
    cashbackName: 'Cashback Name',
    cashbackType: 'Cashback Type',
    calculationTime: 'Calculation Time',
    transferType: 'Transfer Type',
    platforms: 'Platforms',
    platform: 'Platform',
    restrictedPlayers: 'Restricted Players',
    restrictedCountries: 'Restricted Countries',
    totalBet: 'Total Bet',
    totalWin: 'Total Win',
    accumulated: 'Accumulated',
    accumulatedCashBack: 'Accumulated CashBack',
    transferredCashBack: 'Transferred CashBack',
    commission: 'Commission',
    commissions: 'Commissions',
    lCommissions: 'Commissions',
    commissionPercent: 'Commission, %',
    manageLimits: 'Manage Limits',
    referees: 'Referees',
    setCommissions: 'Set Commissions',
    referralBonusId: 'Referral Bonus ID',
    lReferralBonus: 'referral bonus',
    referralBonus: 'Referral Bonus',
    calculationPeriodTime: 'Calculation Period Time',
    commissionFrom: 'Commission From',
    referrerId: 'Referrer ID',
    accumulatedCommission: 'Accumulated Commission',
    nextCalculationDate: 'Next Calculation Date',
    transferredCommission: 'Transferred Commission',
    commissioningAmount: 'Commissioning Amount',
    convertedTo: 'Converted To',
    convertedAmount: 'Converted Amount',
    redeemedAmount: 'Redeemed Amount',
    winAmount: 'Win Amount',
    lossAmount: 'Loss Amount',
    cashbackAmount: 'Cashback Amount',
    includeActiveBonuses: 'Include Active Bonuses',
    lBonus: 'bonus',
    bonus: 'Bonus',
    casino: 'Casino',
    invalidPlayerCount: 'Invalid player count in report',
    totalPlayersUpdated: 'Total players that will be updated',
    lBonusTemplate: 'bonus template',
    bonusTemplate: 'Bonus Template',
    invalidKeys: 'Invalid Keys',
    playersMissingCurrencyReason: "The player's account currency is not configured",
    playersRestrictedReason: 'The player has restricted account status',
    missingCurrency: 'Missing Currency',
    missingCurrencyReason: "The player's account currency is not configured",
    issue: 'Issue',
    platformType: 'Platform Type',
    amountConfig: 'Amount Config',
    paymentMethods: 'Payment Methods',
    first: 'First',
    second: 'Second',
    third: 'Third',
    fourth: 'Fourth',
    fifth: 'Fifth',
    fromDepositAmount: '% from Deposit Amount',
    fromDeposit: '% from Deposit',
    betType: 'Bet Type',
    minWageringOdd: 'Min Wagering Odd',
    minWageringOddType: 'Min Wagering Odd Type',
    bonusTemplateName: 'Bonus Template Name',
    bonusTemplateId: 'Bonus Template ID',
    categories: 'Categories',
    bonusOptionsDesc: 'A sign up bonus is a sum of money paid to a new player',
    bonusOptionsDesc1: 'Players will get bonuses for all deposits in the trigger period',
    bonusOptionsDesc2: 'User can choose for how many deposits in the trigger period players to get bonuses',
    bonusOptionsDesc3: 'Players will get bonuses for first deposit of each day in trigger period',
    bonusOptionsDesc4: 'Players will get bonuses for total bets made in a specific time period',
    createNewTemplate: 'Create a New Template',
    selectBonusType: 'SELECT A BONUS TYPE',
    selectBonusTrigger: 'SELECT A BONUS TRIGGER',
    numberOfDeposits: 'Number Of Deposits',
    fixedAmount: 'Fixed Amount',
    sport: 'Sport',
    rules: 'Rules',
    rule: 'Rule',
    noRules: 'No Rules to Show',
    relatedBonusId: 'Related Bonus ID',
    endDateTime: 'End Date/Time',
    noEndDate: 'No End Date',
    selectGames: 'Select Games',
    activities: 'Activities',
    discardAccumulatedCommissions: 'Discard accumulated commissions',
    playersInAnotherReferral: 'Players already in another Referral Bonus',
    allPlayersSelected: 'All players are selected',
    datesAndPlayers: 'Dates and Players',
    special: 'Special',
    highRisk: 'High Risk',
    mediumRisk: 'Medium Risk',
    countOfReferees: 'Count Of referees',
    playerFromParticipants: 'player from participants',
    signUp: 'Sign Up',
    bonusNameExternal: 'Bonus Name (External)',
    noEndData: 'No End Date',
    minNumberOfSelections: 'Min Number Of Selections',
    dateTriggered: 'Date Triggered',
    referralBonusName: 'Referral Bonus Name',
    refereesId: 'Referees ID',
    refereeId: 'Referee ID',
    realWallet: 'Real Wallet',
    details: 'Details',
    numberOfDepositsInfo: 'Select the deposits that players must receive bonuses for in the trigger period.',
    numberOfDepositsTabIndex: {
      1: 'st',
      2: 'nd',
      3: 'rd',
      default: 'th',
    },
    cloneUnit: 'Clone Unit',
    cloneBonus: 'Clone Bonus',
    cloneSettingsTo: 'Clone Settings To',
    balanceConfig: 'Balance Config',
    usedCount: 'Used Count',
    lRule: 'rule',
    referralParticipants: 'Referral participants',
    theCashback: 'The cashback',
    playersCashBack: 'Players cashback',
    theBonus: 'The bonus',
    wageringTurnover: 'Wagering Turnover',
    playersWontBeAble: "Players won't be able to withdraw or bet on P2P games the issued bonus amount.",
    calculationFrom: 'CALCULATION FROM',
    lCalculationFrom: 'Calculation From',
    createNewCashback: 'Create New Cashback',
    cashbackFromBetsDesc: 'Provides cashback on the positive difference of bet - win in the calculation period.',
    cashbackNetDepositsDesc: 'Provides cashback on the positive difference of deposits - withdrawals in the calculation period.',
    netDepositAmount: 'Net Deposit Amount',
    participateRule: 'Participate Rule',
    totalDeposit: 'Total Deposit',
    totalWithdrawal: 'Total Withdrawal',
    totalBonuses: 'Total Bonuses',
    manageParticipation: 'Manage Participation',
    restrictionFor: 'Restricted For',
    availableFor: 'Available For',
    sportWageringBonuses: 'Sport Wagering Bonuses',
    casinoWageringBonuses: 'Casino Wagering Bonuses',
    otherBonuses: 'Other Bonuses',
    finishedBonusesCount: 'Count Of Finished Bonuses',
    totalRedeemBonuses: 'Total Redeem Bonuses',
    referralCommission: 'Referral Commission',
    maxPossibleTransfer: 'Max Possible Transfer',
    playThroughRequired: ' Playthrough Required',
    matchingRegistrationIP: 'The referrer has referees with matching registration IPs',
    sameRegistrationIP: 'Referrer and referee has the same registration IP',
    amountColumnInfo: 'The range includes the left column value, up to but not including the right column value',
    selectedGames: 'Selected Games',
    minAmount: 'Min. Amount',
    step: 'Step',
    gamesInfo: 'Provider allows to select {{type}} games',
    lSingle: 'single',
    lMultiple: 'multiple',
    allowWithdrawal: 'Allow Withdrawal',
    campaignName: 'Campaign Name',
    noTrigger: 'No Trigger',
    cancelBonusWhenWithdrawal: 'Cancel Bonus (When Withdrawal)',
    number: 'Number',
    participant: 'Participant',
    depositsAmountConfigInfo: 'In this area, we configure Bonus Amount and set limitations per currency',
    bonusBetConfig: 'Bonus Bet Config',
    single: 'Single',
    ranges: 'Ranges',
    nextValue: 'Next value',
    lPrevValue: 'previous value',
    addRanges: 'Add Ranges',
    lifetimePeriod: 'Lifetime Period',
    resetRanges: 'Reset Ranges',
    lCampaign: 'campaign',
    multi: 'Multi',
    option: 'Option',
    triggers: 'Triggers',
    viewRanges: 'View Ranges',
    depositNumber: 'Deposit Number',
    bonusResultAreaDesc: 'You can see the Bonuses after adding and configuring them from the side area.',
    participantsResultAreaDesc: 'You can see the Participants after adding and configuring them from the side area.',
    editTriggerDisabled: 'You cant edit trigger now',
    multiOrSingleBonus: 'Multi and single bonus description',
    editParticipantsDisabled: 'You cant edit participants now',
    configureParticipants: 'Configure participants',
    sidebarBonusesDescription: 'Here we can choose Sport, Spins, Casino, and Special available bonus types and add to the campaign',
    selectTriggerParticipantsBonuses: 'Select The Trigger, Choose Participants, Configure Bonuses',
    toMakeSureCampaignSuccessful: 'To make sure your campaign successful',
    participantType: 'Participant Type',
    triggerType: 'Trigger Type',
    cancelPromotion: 'Cancel Promotion',
    createCampaign: 'Create Campaign',
    multiOrSinglePromocodeType: 'Multi and single promocode type description',
    missingAmount: 'Missing Amount',
    multiSelectionNum: 'Multi Selection Num',
    playThroughRequiredDesc: 'In case this option is turned on the Playthrough field value should be equal to the set number, if it’s turned off it should be equal or greater then',
    playThroughInputDesc: 'Allows defining whether a player must wager the bonus as many times as defined in the playthrough config to be able to finish the bonus (besides 0 in the turnover)',
    cancelBonusWhenWithdrawalDesc: 'Allows to cancel the bonus automatically if the player will do the withdrawal transaction during the bonus activation and expiration periods',
    triggerOption: 'Trigger Option',
    campaign: 'Campaign',
    periodDescription: 'Here we can set in which period to define the deposit’s number',
    singleCountTypeDesc: 'Allows to set only one bonus but with different amounts for every deposit number, usable in cases when we don’t need to configure several bonuses with the same bonus type',
    multiCountTypeDesc:
      'Allows setting different types of bonuses with different amount configurations for every deposit’s number. In this case, we choose the deposit number (possible values 1, …, 100) for every bonus type',
    disconnectTriggerDesc:
      "If this functionality is activated and the player received at least one bonus but doesn't satisfy bonus conditions, then the system will disconnect him from the campaign, and the player will no longer get new bonuses",
    participantsPlayerDesc: 'Allows to include players by uploading CSV or manually',
    participantsPlayerListAmountsDesc: 'Allows to include players with individual bonus amounts by uploading the players’ list',
    participantsPromoCodeDesc: 'Allows to include players by using generated promo code',
    promoCodeTypes: {
      0: 'Allows manually filling promo code',
      1: 'Allows the system to generate unique codes',
      2: 'Allows manually add external promo codes. The system automatically will exclude the duplicate codes and the codes which are not between 3-25 length from the uploaded list, the check will be done between all bonus campaigns',
    },
    countryConditionDesc: 'Checks players’ country',
    verifyConditionDesc: 'Checks players’ verification level',
    weekDaysConditionDesc: 'Checks the players’ on specific days',
    accountStatusConditionDesc: 'Checks players’ account statuses',
    sportStatusConditionDesc: 'Checks players’ statuses on Sportsbook',
    segmentConditionDesc: 'Checks the segments players are parts of',
    tagConditionDesc: 'Checks the tags assigned to players',
    paymentsConditionDesc: 'Checks the players’ transaction payments',
    configModeAlreadyOpened: 'You already opened the configuration mode',
    bonusBetConfigInfo: 'Allows configuring bonus bets. Bet should match saved criteria to be considered as a bonus bet',
    amountConfigSingleDesc: 'Allow setting single amounts config per currency',
    amountConfigRangesDesc: 'Allow setting multi ranges amounts config for every currency',
    depositAmountConfigFixedAmountDesc:
      'Allows providing a bonus amount that is fixed for each currency (By currency). In the case of a Fixed Amount, we can configure the Deposit conditions using Single or Range options',
    amountConfigFromDepositDesc: 'Allows to count bonus amount as a percent from the deposit (General for all currencies)',
    expirationPeriod: 'Expiration period',
    noDataAlt: 'No Trigger, Participants, Bonuses selected',
    successPlayers: 'Players are able to get bonus',
    errorPlayers: 'Missing Currency',
    amountConfigAreaInfo: 'In this area, we configure Bonus Amount and set limitations per currency',
    availableCount: 'Available Count',
    availablePromoCodes: 'Available Promo Codes',
    downloadAvailableCodes: 'Download Available Codes',
    lengthOfCodes: 'Length Of Codes',
    lNextValue: 'next value',
    freeSpinAmountConfigInfo: 'Select provider and line count to get amount restrictions',
    freeSpinRequiredAllGames: 'This provider supports free spin on all games',
    maxWinAmount: 'Max Win Amount',
    line: 'Line',
    casinoBonus: 'Casino Bonus',
    campaignStatus: 'Campaign Status',
    participantsAllPlayersDesc: 'Allows to include all players as a participant when the trigger is executed',
    participantsAllPlayersMainAreaDesc: 'The system will include all players after executing the trigger as a participant.',
    spinsAmount: 'Spins Amount',
    chipCount: 'Chip Count',
    chipAmount: 'Chip Amount',
    maxTriggerCount: 'Maximum Trigger Count',
    maxTriggerCountInfo: 'This field will allow setting the maximum successful trigger count per player',
    freeSpinCurrencyInfo: 'The system includes currencies supported by brand and chosen provider',
    amountRanges: 'Amount Range (From - To)',
    amountRangesHint: "The amount in the 'From' field of the 'Amount Range' is included in that range, whereas the amount in the 'To' field is not included in the range.",
    numberOfPlayers: 'Number Of Players (From - To)',
    numberOfPlayersHint: "The number in the 'From' field of the 'Number Of Players' is included in that range, whereas the number in the 'To' field is not included in the range.",
    numberOfReferees: 'Number Of Referees (From - To)',
    numberOfRefereesHint: "The number in the 'From' field of the 'Number Of Referees' is included in that range, whereas the number in the 'To' field is not included in the range.",
    campaignStatistics: 'Campaign Statistics',
    maxLimitAmount: 'Max Limit Amount',
    netDepositAmountHint: "The number in the 'From' field of the 'Net Deposit Amount' is included in that range, whereas the number in the 'To' field is not included in the range.",
    gameSegmentInfo: 'Changes in the game segment will not affect on already created entity',
    lCashbackAmounts: 'cashback amounts',
    usedPromoCodes: 'Used Promo Codes',
    createCrossPlatformCampaign: 'Create Cross-Platform Campaign',
    amountConfigAreaCrossCampaignInfo: 'In this area, we set limitations per currency',
    selectAndConfigureBonuses: 'Select and configure bonuses',
    cashbackStatistics: 'CashBack Statistics',
    freeSpinAmountConfigInfoForSingle: 'Select provider, line count and game to get amount restrictions',
    minMaxProviderLimit: 'Min-Max Provider Limit',
    spinTotalAmount: 'Spin Total Amount',
    minMaxProviderLimitInfo: 'The Spin Total Amount generated from spins count multiplied by spins amount should be between the mentioned limits',
    maxWageringOddType: 'Max Wagering Odd Type',
    maxWageringOdd: 'Max Wagering Odd',
    wageringOdd: 'Wagering Odd',
    winAmountTransferTo: 'Win Amount Transfer To',
    allowCashout: 'Allow Cashout',
    allowCashoutInfo: 'Allows players to use cashout/partial cashout functionalities for this bonus',
    bonusAbuse: 'Bonus Abuse',
    bonusAbuseInfo: {
      0: 'After activating this checkbox, the players will not be able to make a bet from the Bonus Balance on the same event more than once',
      1: 'After activating this checkbox, the players will not be able to make a bet from the Bonus Balance on the same event more than once',
      2: 'After activating this checkbox, the players will not be able to make a bet from the Bonus Balance on the same event more than once. In the case of Real Wager Bonus, if the player makes a bet from the Real Balance more than once on the same event that meets the bonus requirements, the second bet should not reduce the wagering turnover',
    },
    oneTimeBet: 'One Time Bet',
    oneTimeBetInfo: 'Requires players to use the bonus fully',
    minBetAmountPerCategory: 'Min Bet Amount Per Category',
    periodDescriptionEvery: "Here we can set in which period to define the Maximum Trigger Count, if it's not configured the system will not limit the trigger work for a player",
    totalBets: 'Total Bets',
    totalWins: 'Total Wins',
    subMethod: 'Sub-Method',
    paymentConditionPropertiesInfo: 'Submethods menu is visible only for the payment methods for which the submethods list is provided by the aggregator.',
    verificationTriggerInfo: 'Condition will work if all selected options are verified, trigger field verification is also included',
    promoCodesUploadFormatMsg: 'You can upload promo codes. Only CSV format is acceptable',
    amountConfigDepositSingleDesc: 'Allow setting single % config per currency',
    amountConfigDepositRangesDesc: 'Allow setting multi ranges % config for every currency',
    canceller: 'Canceller',
    awardedBonusesDetails: 'Awarded Bonuses Details',
    bonusLowestAmount: 'Lowest Bonus Amounts',
    bonusHighestAmount: 'Highest Bonus Amounts',
    totalBonusAmount: 'Bonus Total Amounts',
    checkTheListOfRecipients: 'Please check the final list of the recipients',
    allGames: 'All Games',
    allGamesDesc: "Allows to set bonus raffle on brand's all games, all changes on the brand games will be considered",
    selectGamesDesc: 'Allows to set bonus raffle on specific providers and games',
    contribution: 'Contribution, %',
    addPlayersNote: 'It is possible to add only new participants. Otherwise, they will be automatically excluded from the participants list',
    campaignParticipants: 'Campaign participants',
    autoActivation: 'Autoactivation',
    autoActivationDesc:
      'Allows to allocate the bonus already activated to the player. It is recommended to configure one bonus from each bonus type (Casino, Sport, Free Spin) in case of autoactivation usage. Otherwise, bonuses will be activated randomly',
    promoCodeCaseSensitiveInfo: 'Allows to configure the promo code for players. The codes are not key sensitive for players and will be converted to uppercase format',
    supportPlayerCancellationGamesInfo: "Provider allows to select {{type}} games and doesn't allow to cancel the bonus after activation",
    referralStatistics: 'Referral Statistics',
    campaignWillBeSavedInBgInfo: "As the Campaign data is bigger, it will be saved in the background mode and it is available in the Campaigns' list.",
    contentAndNotification: 'Content And Notification',
    contentAndNotificationConfigsRemovedDesc: 'All Bonus Content and Notification configs were removed, after saving you will lose all previous configs.',
    cloneContentFrom: 'Clone <0>{{bonusName}}</0> bonus content To',
    contentLanguages: 'Content Languages',
    notificationInfo: 'In this area, we configure a notification for the players about bonus allocation, if no template is selected the players will not be notified with brand communication channels.',
    notificationInfoProductSelectionEnabled:
      "After selecting a bonus, the available notification templates for that bonus will be displayed. If no template is configured, players will not receive a notification through the brand's communication channels.",
    contentInfo:
      "In this area, we configure images and bonus related content with the brand's languages, which will be visible to players. If the content is not configured the system will use the default content.",
    editContent: 'Edit Content',
    bonusStatistics: 'Bonus Statistics',
    sportBonus: 'Sport Bonus',
    manageContentAndNotification: 'Manage Content and Notification',
    minCashbackAmount: 'Min Cashback Amount',
    triggerDeviceTypeDesc: 'Checks the device type of the trigger',
    signUpDeviceTypeDesc: 'Checks the device type through which the player was registered',
    viewContentAndNotifications: 'View Content and Notifications',
    winType: 'Win Type',
    winOptions: 'Win Amount Type',
    realMoney: 'Real Money',
    availableBonus: 'Available Bonus',
    wageringBonus: 'Wagering Bonus',
    pauseBonus: 'Pause Bonus',
    pauseBonusDesc: 'By enabling the option, player will be able to pause the received bonus and later resume it',
    pausedDate: 'Paused Date',
    resumedDate: 'Resumed Date',
    sidebarParticipantsDescription: 'Here we can choose campaign participants’ selection conditions: Player list, Player list – Amounts, Promo Code, Conditions',
    participantsJoinDesc: "Allows to include players as participants through the 'Join' action on the website",
    contentAndNotificationSidebarNoBonuses: {
      text1: "Campaign content configuration is mandatory if the participation method is 'Join'. Otherwise, it is optional.",
      text2: 'The Bonus content and notification configuration will become active after configuring and saving bonuses.',
    },
    sidebarTriggerDescription: 'Here we can set campaign trigger configurations: No Trigger, Deposit, Sign Up, Verify',
    contentAndNotificationSidebarDesc: 'Here we can choose configured bonuses and add bonus specific content and notification',
    contentAndNotificationResultAreaDesc: 'You can see the Content and Notification for bonuses after adding and configuring them from the side area.',
    campaignContent: 'Campaign Content',
    bonusContent: 'Bonus Content',
    campaignContentTabInfo:
      "In this area, we configure images and campaign related content with the brand's languages, which will be visible to players. It is necessary to configure the content with the brand's main language",
    signInDate: 'Sign In Date',
    remainingBonusAmount: 'Remaining Bonus Amount',
    configAlreadySaved: 'You already have configured bonuses or participants, remove them to be able to edit',
    triggerConditionsResultAreaDesc: 'You can see the Trigger Condition after adding and configuring them from the side area.',
    triggerConditions: 'Trigger Conditions',
    websiteImage: 'Website Image',
    sidebarTriggerConditionDescription: 'Here we can choose campaign trigger specific’ conditions',
    mobileImage: 'Mobile Image',
    specificTimePeriod: 'Specific Time Period',
    weekDays: 'Weekdays',
    monthlyDatesConditionDesc: 'Checks the players’ on specific date',
    dates: 'Dates',
    monthlyDates: 'Monthly Dates',
    sourceId: 'Source ID',
    sourceName: 'Source Name',
    participationGroupsNote: 'You can see the Participation Groups after adding and configuring them from the side area.',
    participationGroupsDesc: 'You can see the Participation Conditions after adding and configuring them from the side area.',
    lParticipationGroups: 'participation groups',
    playerListDesc: 'Allows to include players by uploading CSV or manually',
    playerListAmountDesc: 'Allows to include players with individual bonus amounts by uploading the players’ list',
    allPlayersDesc: 'Allows to include all players as a participant when the trigger is executed',
    promoCodeDesc: 'Allows to include players by using generated promo code',
    additionalConditions: 'Additional Conditions',
    participationGroups: 'Participation Groups',
    participationGroup: 'Participation Group',
    lParticipationGroup: 'participation group',
    playersAreParticipants: 'Players are included as participants',
    bonusesDesc: 'You can see the Bonuses after adding and configuring them from the side area.',
    gameConfig: 'Game Config',
    recurringConditionDesc: "Checks the players' triggers on specific days or monthly dates",
    conditionTypes: 'Condition Types',
    lTriggerCondition: 'trigger condition',
    bonusAbuseInfoNote: 'After activating this checkbox, the players will not be able to make a bet from the Bonus Balance on the same event more than once',
    productSelection: 'Product Selection',
    casinoGameConfig: 'Casino Game Config',
    contents: 'Contents',
    lCampaignContent: 'campaign content',
    lBonusContent: 'bonus content',
    units: 'Units',
    triggerCondition: 'Trigger Condition',
    wageringLogic: 'Wagering Logic',
    wageringBaseAmount: 'Wagering Base Amount',
    wageringCoefficient: 'Wagering Coefficient',
    wageringCount: 'Wagering Count',
    calculationLogic: 'Calculation Logic',
    wageringParticipation: 'Wagering Participation',
    firstWalletDebited: '1st Wallet Debited',
    lockAmount: 'Lock Amount',
    allowNonMatchingBets: 'Allow Non-matching Bets',
    triggerBasedConfig: 'Trigger Based Config',
    lUnit: 'unit',
    unitsDesc: 'You can see the Units after adding and configuring them from the side area.',
    navigationItemsDisabledInfo: 'The navigation items will become active after saving the Campaign General section.',
    sidebarTriggerConditionInfo: 'You can see the Trigger Conditions after adding and configuring them from the side area',
    summary: 'Summary',
    offers: 'Offers',
    offersContentTabInfo:
      "In this area, we configure images and campaign related content with the brand's languages, which will be visible to players. It is necessary to configure the content with the brand's main language",
    sidebarUnitInfo: 'You can see the Units after adding and configuring them from the side area',
    lContent: 'content',
    offersContent: 'Units(Offers) Content',
    lOfferContent: 'offer content',
    unit: 'Unit',
    totalOdds: 'Total Odds',
    minTotalOdd: 'Min Total Odd',
    maxTotalOdd: 'Max Total Odd',
    sportEventConfig: 'Sport Event Config',
    lockType: 'Lock Type',
    gamesConditionDesc: 'Checks the launched games for the trigger',
    transactionAmount: 'Transaction Amount',
    unitName: 'Unit Name',
    productType: 'Product Type',
    isUsedInUnit: 'Used in unit',
    minBetTriggerAmount: 'Min Bet Trigger Amount',
    bonusAmount: 'Bonus Amount',
    point: 'Point',
    contributedFrom: 'Contributed From',
    contributedFromDescription: 'Here we can set which bets should participate in the cumulative bet turnover',
    sportBetsConditionDesc: "Checks the players' bets on specific sport events",
    casinoBetsConditionDesc: "Checks the players' bets on specific casino games",
    betAmountConfigFixedAmountDesc:
      'Allows providing a bonus amount that is fixed for each currency (By currency). In the case of a Fixed Amount, we can configure the Bet conditions using Single or Range options',
    amountConfigFromBetDesc: 'Allows to count bonus amount as a percent from the bet (General for all currencies)',
    fromBet: '% from Bet',
    bonusOptionsDesc5: 'Players will get bonuses for all bets in the trigger period',
    gameInfo: 'Selected game support type(s): <0>{{type}}</0>',
    freeGameType: 'Free Game Type',
    combinations: 'Combinations',
    involvement: 'Involvement',
    sports: 'Sports',
    tournaments: 'Tournaments',
    events: 'Events',
    markets: 'Markets',
    allEventsAreSelected: 'All events are selected',
    allMarketsAreSelected: 'All markets are selected',
    customSelection: 'Custom Selection',
    live: 'Live',
    lEvents: 'events',
    lMarkets: 'markets',
    lMarket: 'market',
    lEvent: 'event',
    lTournaments: 'tournaments',
    entitiesLimitInfo: 'Max entities(tournaments, events, markets) count is {{count}}. Selection is counting in case of custom selection.',
    fromBetAmount: '% from Bet Amount',
    gamesCount: 'Games Count',
    freeSpinGamesInfo: 'Select provider to get games',
    previousUnit: 'Previous Unit',
    previousUnitInfo: "The current unit will be allocated once the selected unit's bonus is finished. This is only applicable to units within the same participant group",
    eventType: 'Event Type',
    complainer: 'Complainer',
    hashtagDescription: 'Description of the hashtag',
    lPlayerBonus: 'player bonus',
    lPlayersBonuses: 'players bonuses',
    playerBonus: 'Player bonus',
    playersBonuses: 'Players bonuses',
    eligibleBets: 'Eligible Bets',
    eligibleBetsStatus: 'Eligible Bets Status',
    betBuilder: 'Bet Builder',
    betBuilderTotalOdds: 'Bet Builder Total Odds',
    betBuilderMultiSelectionNum: 'Bet Builder Multi Selection Num',
    minBetBuilderTotalOdd: 'Min Bet Builder Total Odd',
    maxBetBuilderTotalOdd: 'Max Bet Builder Total Odd',
    lUnitBonuses: 'unit bonuses',
    partialCancel: 'Partial Cancel',
    addPlayers: 'Add Players',
    pointEnhancement: 'Point Enhancement',
    pointEnhancementInfo: 'Enable the option to set a required number of bets for earning each point bonus.',
    betCount: 'Bet Count',
    bonusOptionsDesc6: 'Players will get bonuses for meeting the minimum bet and count requirements within a single point and a set time period.',
    lobbyWidgetGameSegmentInfo: 'Changes in the game segment will not affect on already created entity.Only those games will appear on the list which are common for selected segment and lobby',
    wageringParticipationInfo: 'The Cashout type bets will not be included in the turnover calculation.',
    code: 'Code',
    dynamicDesc: 'Enables commission generation based on financial indicators either per individual referee or collectively from all referees',
    progressiveDesc: 'Enables setting specific commission ranges based on the number of referred players',
    prizeDesc: 'Enables setting commission ranges to grant a one-time fixed reward for newly referred players who complete the required conditions.',
    supportPlayerCancellationGameInfo1: 'The provider allows player cancellation',
    supportPlayerCancellationGameInfo2: 'The provider does not allow player cancellation',
    bonusContentDesc: 'You can see the {{type}} for bonuses after adding and configuring them from the side area.',
    noUnitWithEmptyContentForLanguage: 'There is no unit with empty content in this language.',
    noBonusWithEmptyContent: 'There is no bonus with empty content.',
    currentStage: 'Current Stage',
    inProcess: 'In Process',
    placedBetAmount: 'Placed Bet Amount',
    totalBetCount: 'Total Bet Count',
    placedBetCount: 'Placed Bet Count',
    periodDate: 'Period Date',
    grantBonus: 'Grant Bonus',
    bonusWillBeGrantedAfterWageringCompleted: 'The selected bonus will be granted once the current bonus wagering is completed',
    infoMaxRedeemAmount: 'Max Redeem Amount is {{value}}',
    infoSpinsAmount: 'Spins Amount is {{value}}',
    infoCombinationValues: 'Combination values are {{value}}',
    participationType: 'Participation Type',
    resetToDefault: 'Reset to default',
    amountRange: 'Amount Range',
    considerAsBTag: 'Consider As BTAG',
    considerAsBTagInfo: 'This option will override the btag field if the promo code matches the one entered by the player',
    byPlayerID: 'By Player ID',
    byTags: 'By Tags',
    bySegments: 'By Segments',
    dynamicSelection: 'Dynamic Selection',
    staticSelection: 'Static Selection',
    deleted: 'Deleted',
    onJoinUnitInfo: 'Specifies whether this configuration uses its own join settings or not',
    riskyGameExclusionInfo: 'Changes in the game risks will not affect on already created entity',
    conditionsInfo: 'Only newly referred players are eligible. Each referred player must complete all selected conditions to generate a commission for the referrer.',
    minWithdrawalAmount: 'Min Withdrawal Amount',
    withdrawalAmountConfigFixedAmountDesc:
      'Allows providing a bonus amount that is fixed for each currency (By currency). In the case of a Fixed Amount, we can configure the Withdrawal conditions using Single or Range options',
    fromWithdrawal: '% from Withdrawal',
    amountConfigFromWithdrawalDesc: 'Allows to count bonus amount as a percent from the withdrawal (General for all currencies)',
    fromWithdrawalAmount: '% from Withdrawal Amount',
    sourceTypes: 'Source Types',
    unitsAllocation: 'Units Allocation',
    unitsAllocationInfo:
      'Select One trigger-All Units if you want the player to get all the created units with one trigger. Make sure to set the conditions for each unit similarly, so they are all allocated at the same time passing all the checks.',
    recurrence: 'Recurrence',
    recurrenceSetupRules: 'Recurrence setup rules',
    oneResetWeek: 'One reset/week - Rejoin day: each Monday, - <0>Trigger days: Monday → Monday</0> (set automatically)',
    oneResetWeekWithJoin: 'One reset/week with extended join window - <0>Rejoin days: Monday → Tuesday</0> (one row), Trigger days: Monday → Monday (set automatically)',
    rejoinDays: 'Rejoin Days',
    rejoinDaysInfo: 'Each row you set will become the reset date for your campaign, and player has to re-claim the campaign to participate.',
    triggerDays: 'Trigger Days',
    triggerDaysInfo: 'Specify days during which the triggers will be considered eligible. Skip this column in case you dont need any specific restrictions.',
    triggerTime: 'Trigger Time',
    recurringType: 'Recurring Type',
    registrationDateDesc: 'Checks players’ registration date',
    bTagDesc: 'Checks players’ BTAG value',
    allowOptOut: 'Allow Opt Out',
    allowOptOutInfo: 'Allow to cancel the participation in the campaign',
    optOutDate: 'Opt Out Date',
    providers: 'Providers',
    dynamicSegmentsInfo: 'Any changes in segments will apply dinamically within the campaign.',
    crossPlatformCampaign: 'Cross Platform Campaign',
    playerCurrencyIsNotFilled: "Player's currency is not filled out",
    unitIsCancelled: 'Unit is cancelled',
    playerIsAlreadyParticipant: 'Player is already a participant',
    noAvailableUnits: 'No available units',
    frequency: 'Frequency (%)',
    frequencyInfo: 'Defines the probability for the trigger. For example, 10% means approximately 1 in 10 withdrawal attempts will show the bonus offer',
    unitIsFinished: 'Unit is finished',
    notAvailableParticipationType: 'Not available for this participation type',
    missingProduct: 'Missing Product',
    uploadPlayersFileContainer: 'Upload Players File Container',
    depositType: 'Deposit Type',
    singleEventOdds: 'Single Event Odds',
    minSingleEventOdd: 'Min Single Event Odd',
    maxSingleEventOdd: 'Max Single Event Odd',
    multiEventOdds: 'Multi Event Odds',
    minMultiEventOdd: 'Min Multi Event Odd',
    maxMultiEventOdd: 'Max Multi Event Odd',
    decimal: 'Decimal',
    genderConditionDesc: 'Include or exclude players based on their Gender value',
    rewardType: 'Reward Type',
    operatorInfo: "Select 'In' if at least one selection from a selected Sport / Tournament / Event is enough to consider the bet valid. Leave 'All' for all stake validations in a standard behavior.",
    cashbackNotificationInfo: 'After creating a cashback bonus, the available notification templates for the cashback bonus will be displayed. If no template is configured, players will not receive notifications through the brand’s communication channels.',
    availableUnit: 'Available Unit',
    percentage: 'Percentage',
    accumulatedAmount: 'Accumulated Amount',
    adjustedAmount: 'Adjusted Amount',
    infoChipsAmount: 'Chips Amount is {{value}}',
    unitStatus: 'Unit Status',
    unitId: 'Unit ID',
    bonusItemGrantedCount: 'Bonus Item Granted count',
    grantedAmount: 'Granted Amount',
    cancelledAmount: 'Cancelled Amount',
    expiredAmount: 'Expired Amount',
    amountCashedOut: 'Amount Cashed out',
    amountUsedUp: 'Amount Used up',
    bonusCost: 'Bonus Cost',
    totalContributingBets: 'Total Contributing Bets',
    totalWinFromContributingBets: 'Total win from contributing bets',
    gameWinFromContributingBets: 'Game Win From Contributing bets',
    netResult: 'Net Result',
    uniquePlayerCount: 'Unique Player Count',
    playerReceivedMoreThanOneBonus: 'Player Received more than one bonus',
    cashedOutBonusCount: 'Cashed out Bonus count',
    activeBonusItemCount: 'Active Bonus item count',
    cancelledBonusItemCount: 'Cancelled Bonus item count',
    bonusUsedUpCount: 'Bonus Used up count',
    bonusExpiredItemCount: 'Bonus Expired item count',
    maxBonusWinDeductionAmount: 'Max Bonus Win Deduction Amount',
    avgCostPerGrantedBonus: 'Avg Cost Per Granted Bonus',
    avgCostPerCashedOutBonus: 'Avg Cost Per Cashed Out Bonus',
    static: 'Static',
    byTagsSegments: 'By Tags/Segments',
    staticTagsSegmentsInfo: 'Includes only the players available in the selected Segments or Tags at the time of selection. Future updates will not affect the recipient list.',
    dynamicTagsSegmentsInfo: 'Automatically reflects updates to the selected Segments or Tags, including players who are added or removed.',
    preConditions: 'Pre-Conditions',
    turnoverProgress: 'Turnover Progress %',
    requireCompletionInOrder: 'Require Completion In order',
    requireCompletionInOrderInfo: 'Use this configuration to create strict sequential flow for referees, otherwise the steps can be done independently',
    totalReferees: 'Total Referees',
    totalBonusCountReceived: 'Total Bonus Count Received',
    totalBonusAmountReceived: 'Total Bonus Amount Received',
    triggersCompleted: 'Triggers Completed',
    totalAccumulatedCommission: 'Total Accumulated Commission',
    totalTransferredCommission: 'Total Transferred Commission',
    refereesCount: 'Referees Count',
    bonusPrizeDesc: 'Enables setting rewards for referred players who complete the required conditions based on configurations.',
    turningProgress: 'Turning Progress %',
  },
  es: {
    maxBonusAmount: 'Importe máx. de bono',
    minDepositAmount: 'Importe mín. de depósito',
    maxRedeemAmount: 'Importe máx. de canjeo',
    minBetAmount: 'Importe mín. de apuesta',
    contributionPercent: 'Contribución, %',
    cashbackPercent: 'Devolución de efectivo, %',
    bonusType: 'Tipo de bono',
    currencies: 'Monedas',
    triggerPeriod: 'Periodo de activación',
    activationPeriod: 'Periodo de activación',
    playthrough: 'Requisitos de Apuesta',
    wageringPeriod: 'Periodo de Apuestas',
    issueBonus: 'Emisión de bono',
    bonusId: 'ID de Bono',
    promoName: 'Nombre de promoción',
    promoCode: 'Código de promoción',
    promoCodeType: 'Tipo de código de promoción',
    lPromoCode: 'código de promoción',
    maxUseCount: 'Recuento de usos máx.',
    dateUsed: 'Fecha de uso',
    promotionEndDate: 'Fecha de finalización de la promoción',
    issuedBy: 'Emitido por',
    canceledBy: 'Cancelado por',
    mobileVerified: 'Móvil verificado',
    identityVerified: 'Identidad verificada',
    emailVerified: 'Correo electrónico verificado',
    disconnectedBy: 'Desconectado por',
    disconnectTrigger: 'Desencadenante de la desconexión',
    turnoverAmount: 'Monto de facturación',
    remainingTurnover: 'Requisitos de apuesta restantes',
    bonusStatus: 'Estado del bono',
    triggeredDate: 'Fecha de activación',
    providerMayDisabled: 'Puede que el proveedor haya sido inhabilitado.',
    gameMayDisabled: 'Puede que el juego haya sido inhabilitado.',
    maxCashbackAmount: 'Importe máx. de devolución de efectivo',
    cashbackId: 'ID de devolución de efectivo',
    cashbackName: 'Nombre de devolución de efectivo',
    cashbackType: 'Tipo de devolución de efectivo',
    calculationTime: 'Tiempo de cálculo',
    transferType: 'Tipo de transferencia',
    platforms: 'Plataformas',
    platform: 'Plataforma',
    restrictedPlayers: 'Jugadores restringidos',
    restrictedCountries: 'Países restringidos',
    totalBet: 'Apuesta total',
    totalWin: 'Ganancias totales',
    accumulated: 'Acumulado',
    accumulatedCashBack: 'Devolución de efectivo acumulada',
    transferredCashBack: 'Devolución de efectivo transferida',
    commission: 'Comisión',
    commissions: 'Comisiones',
    lCommissions: 'Comisiones',
    commissionPercent: 'Comisión, %',
    manageLimits: 'Gestionar límites',
    referees: 'Referencias',
    setCommissions: 'Definir comisiones',
    referralBonusId: 'ID del bono por recomendación',
    lReferralBonus: 'bono por recomendación',
    referralBonus: 'Bono por recomendación',
    calculationPeriodTime: 'Tiempo del periodo de cálculo',
    commissionFrom: 'Comisión de',
    referrerId: 'ID de recomendador',
    accumulatedCommission: 'Comisión acumulada',
    nextCalculationDate: 'Próxima fecha de cálculo',
    transferredCommission: 'Comisión transferida',
    commissioningAmount: 'Importe de la comisión',
    convertedTo: 'Convertido a',
    convertedAmount: 'Importe convertido',
    redeemedAmount: 'Importe canjeado',
    winAmount: 'Importe de las ganancias',
    lossAmount: 'Importe de las pérdidas',
    cashbackAmount: 'Importe de devolución de efectivo',
    includeActiveBonuses: 'Incluir bonos activos',
    lBonus: 'bono',
    bonus: 'Bono',
    casino: 'Casino',
    invalidPlayerCount: 'Recuento de jugadores no válido en el informe',
    totalPlayersUpdated: 'Total de jugadores que se van a actualizar',
    lBonusTemplate: 'plantilla de bono',
    bonusTemplate: 'Plantilla de bono',
    invalidKeys: 'Claves inválidas',
    playersMissingCurrencyReason: 'No se ha configurado la moneda de la cuenta del jugador',
    playersRestrictedReason: 'El jugador tiene un estado de cuenta restringido',
    missingCurrency: 'Falta la moneda',
    missingCurrencyReason: 'No se ha configurado la moneda de la cuenta del jugador',
    issue: 'Publicar',
    platformType: 'Tipo de plataforma',
    amountConfig: 'Configuración del importe',
    paymentMethods: 'Métodos de pago',
    first: 'Primero',
    second: 'Segundo',
    third: 'Tercero',
    fourth: 'Cuarto',
    fifth: 'Quinto',
    fromDepositAmount: '% de importe de depósito',
    fromDeposit: '% de depósito',
    betType: 'Tipo de apuesta',
    minWageringOdd: 'Cuota mín. de apuesta',
    minWageringOddType: 'Tipo de cuota mín. de apuesta',
    bonusTemplateName: 'Nombre de plantilla de bono',
    bonusTemplateId: 'ID de plantilla de bono',
    categories: 'Categorías',
    bonusOptionsDesc: 'El bono de registro es una suma de dinero que se paga a un nuevo jugador',
    bonusOptionsDesc1: 'Los jugadores obtendrán bonos por todos sus depósitos durante el periodo de activación',
    bonusOptionsDesc2: 'El usuario puede elegir el número de depósitos por los que el jugador obtendrá bonos durante el periodo de activación',
    bonusOptionsDesc3: 'Los jugadores obtendrán bonos por el primer depósito que realicen cada día durante el periodo de activación',
    createNewTemplate: 'Crear nueva plantilla',
    selectBonusType: 'SELECCIONAR TIPO DE BONO',
    selectBonusTrigger: 'SELECCIONAR ACTIVADOR DE BONO',
    numberOfDeposits: 'Número de depósitos',
    fixedAmount: 'Importe fijo',
    sport: 'Deporte',
    rules: 'Reglas',
    rule: 'Regla',
    noRules: 'No hay reglas que mostrar',
    relatedBonusId: 'ID de bono relacionado',
    endDateTime: 'Fecha/hora de finalización',
    noEndDate: 'No hay fecha de finalización',
    selectGames: 'Seleccionar juegos',
    activities: 'Actividades',
    discardAccumulatedCommissions: 'Descartar comisiones acumuladas',
    playersInAnotherReferral: 'Los jugadores ya tienen otro bono por recomendación',
    allPlayersSelected: 'Se han seleccionado todos los jugadores',
    datesAndPlayers: 'Fechas y jugadores',
    special: 'Especial',
    highRisk: 'Riesgo alto',
    mediumRisk: 'Riesgo medio',
    countOfReferees: 'Recuento de referencias',
    playerFromParticipants: 'jugador de los participantes',
    signUp: 'Registrarse',
    bonusNameExternal: 'Nombre de bono (externo)',
    noEndData: 'No hay fecha de finalización',
    minNumberOfSelections: 'Número mín. de selecciones',
    dateTriggered: 'Fecha de activación',
    referralBonusName: 'Nombre del bono por recomendación',
    refereesId: 'IDs de referencias',
    refereeId: 'ID de referencia',
    realWallet: 'Monedero real',
    details: 'Detalles',
    numberOfDepositsInfo: 'Selecciona los depósitos por los que los jugadores deben recibir bonos durante el periodo de activación.',
    numberOfDepositsTabIndex: {
      1: 'º',
      2: 'º',
      3: 'º',
      default: 'º',
    },
    cloneUnit: 'Unidad de clonación',
    cloneBonus: 'Bonificación de clonación',
    cloneSettingsTo: 'Clonar configuración a',
    balanceConfig: 'Configurar saldo',
    usedCount: 'Recuento utilizado',
    lRule: 'regla',
    referralParticipants: 'Participantes recomendados',
    theCashback: 'La devolución de efectivo',
    playersCashBack: 'Devolución de efectivo de los jugadores',
    theBonus: 'El bono',
    wageringTurnover: 'Requisitos de apuesta',
    playersWontBeAble: 'Los jugadores no podrán retirar ni apostar el importe del bono emitido en juegos P2P.',
    calculationFrom: 'CÁLCULO DE',
    lCalculationFrom: 'Cálculo de',
    createNewCashback: 'Crear nueva devolución de efectivo',
    cashbackFromBetsDesc: 'Proporciona una devolución de efectivo por la diferencia positiva entre apuestas - ganancias durante el periodo de cálculo.',
    cashbackNetDepositsDesc: 'Proporciona una devolución de efectivo por la diferencia positiva entre depósitos - retiradas durante el periodo de cálculo.',
    netDepositAmount: 'Importe neto de depósito',
    participateRule: 'Regla de participación',
    totalDeposit: 'Depósito total',
    totalWithdrawal: 'Retirada total',
    totalBonuses: 'Bonos totales',
    manageParticipation: 'Gestionar participación',
    restrictionFor: 'Restringido para',
    availableFor: 'Disponible para',
    sportWageringBonuses: 'Bonos de apuestas deportivas',
    casinoWageringBonuses: 'Bonos de apuestas reales',
    otherBonuses: 'Otros bonos',
    finishedBonusesCount: 'Recuento de bonos finalizados',
    totalRedeemBonuses: 'Total de bonos canjeados',
    referralCommission: 'Comisión por recomendación',
    maxPossibleTransfer: 'Transferencia máx. posible',
    playThroughRequired: ' Se requiere requisito de apuesta',
    matchingRegistrationIP: 'El recomendador tiene referencias con IPs de registro coincidentes',
    sameRegistrationIP: 'El recomendador y la referencia tienen la misma IP de registro',
    expirationPeriod: 'Período de caducidad',
    lengthOfCodes: 'Longitud de los códigos',
    amountColumnInfo: 'El rango incluye desde el valor de la columna de la izquierda hasta el valor de la columna de la derecha, pero sin incluirlo',
    selectedGames: 'Juegos seleccionados',
    minAmount: 'Importe Min. ',
    step: 'Paso',
    gamesInfo: 'El proveedor permite seleccionar juegos de {{type}}',
    lSingle: 'individual',
    lMultiple: 'multiple',
    allowWithdrawal: 'Permitir la retirada',
    campaignName: 'Nombre de la campaña',
    noTrigger: 'No Trigger',
    cancelBonusWhenWithdrawal: 'Cancelación de la bonificación al retirar el dinero',
    number: 'Número',
    participant: 'Participante',
    depositsAmountConfigInfo: 'En esta área, configuramos el importe de la bonificación y establecemos las limitaciones por moneda',
    bonusBetConfig: 'Configuración de la apuesta de bonificación',
    single: 'individual',
    ranges: 'Rango',
    nextValue: 'Siguiente Valor',
    lPrevValue: 'valor anterior',
    addRanges: 'Añadir rangos',
    lifetimePeriod: 'Período de vida',
    resetRanges: 'Restablecer rangos',
    lCampaign: 'campaña',
    multi: 'Multi',
    option: 'Opcion',
    triggers: 'Triggers',
    viewRanges: 'Ver rangos',
    depositNumber: 'Número del Deposito',
    bonusResultAreaDesc: 'Puedes ver los Bonos después de añadirlos y configurarlos desde el área lateral.',
    participantsResultAreaDesc: 'Puedes ver los Participantes después de añadirlos y configurarlos desde el área lateral.',
    multiOrSingleBonus: 'Descripción de las bonificaciones múltiples e individuales',
    editParticipantsDisabled: 'Ahora no se puede editar a los participantes',
    configureParticipants: 'Configurar los participantes',
    selectTriggerParticipantsBonuses: 'Seleccione el trigger, elija los participantes, configure las bonificaciones',
    toMakeSureCampaignSuccessful: 'Para garantizar el éxito de su campaña',
    participantType: 'Tipo de participante',
    triggerType: 'Tipo de Trigger',
    cancelPromotion: 'Cancelar la promoción',
    createCampaign: 'Crear campaña',
    multiOrSinglePromocodeType: 'Descripción del tipo de promocode múltiple e individual',
    missingAmount: 'Importe Perdido',
    multiSelectionNum: 'Número de selección múltiple',
    playThroughRequiredDesc: 'Si esta opción está activada, el valor del campo Playthrough debe ser igual al número establecido, si está desactivada debe ser igual o mayor que',
    playThroughInputDesc:
      'Permite definir si un jugador debe apostar la bonificación tantas veces como se defina en la configuración del playthrough para poder terminar la bonificación (además de 0 en la facturación)',
    cancelBonusWhenWithdrawalDesc: 'Descripción de la cancelación de la bonificación cuando se retira',
    triggerOption: 'Opcion de Trigger',
    campaign: 'Campaña',
    periodDescription: 'Aquí podemos establecer en qué periodo definir el número del depósito',
    singleCountTypeDesc:
      'Permite configurar un solo bono pero con diferentes importes para cada número de depósito, utilizable en los casos en que no necesitemos configurar varios bonos con el mismo tipo de bono',
    multiCountTypeDesc:
      'Permite establecer diferentes tipos de bonificaciones con diferentes configuraciones de importe para cada número de depósito. En este caso, elegimos el número de depósito (valores posibles 1, ..., 100) para cada tipo de bono',
    disconnectTriggerDesc:
      'Si esta funcionalidad está activada y el jugador ha recibido al menos una bonificación pero no satisface las condiciones de bonificación, el sistema lo desconectará de la campaña y el jugador ya no obtendrá nuevas bonificaciones',
    participantsPlayerDesc: 'Permite incluir a los jugadores cargando un CSV o manualmente',
    participantsPlayerListAmountsDesc: 'Permite incluir a los jugadores con importes de bonificación individuales cargando la lista de jugadores',
    participantsPromoCodeDesc: 'Permite incluir a los jugadores mediante un código de promoción generado',
    countryConditionDesc: 'Verifica el país de los jugadores',
    verifyConditionDesc: 'Comprueba el nivel de verificación de los jugadores',
    weekDaysConditionDesc: 'Controla a los jugadores en días específicos',
    accountStatusConditionDesc: 'Comprueba el estado de las cuentas de los jugadores',
    sportStatusConditionDesc: 'Comprueba el estado de los jugadores en Sportsbook',
    segmentConditionDesc: 'Comprueba los segmentos de los que forman parte los jugadores',
    tagConditionDesc: 'Comprueba las etiquetas que tienen los jugadores',
    paymentsConditionDesc: 'Comprueba los pagos de las transacciones de los jugadores',
    configModeAlreadyOpened: 'Ya has abierto el modo de configuración',
    bonusBetConfigInfo: 'Permite configurar las apuestas de bonificación. La apuesta debe coincidir con los criterios guardados para ser considerada como una apuesta de bonificación',
    amountConfigSingleDesc: 'Permitir la configuración de importes individuales por moneda',
    amountConfigRangesDesc: 'Permitir la configuración de cantidades de varios rangos para cada moneda',
    depositAmountConfigFixedAmountDesc:
      'Permite proporcionar un importe de bonificación que es fijo para cada moneda (Por moneda). En el caso de un Importe Fijo, podemos configurar las condiciones de Depósito utilizando las opciones de Individual o Rango',
    amountConfigFromDepositDesc: 'Permite contabilizar el importe de la bonificación como un porcentaje del depósito (general para todas las monedas)',
    noDataAlt: 'Sin Trigger, Participantes, Bonos seleccionados',
    successPlayers: 'Los jugadores pueden obtener bonificaciones',
    errorPlayers: 'Falta de divisas',
    amountConfigAreaInfo: 'En esta área, configuramos el importe de la bonificación y establecemos las limitaciones por moneda',
    availableCount: 'Recuento disponible',
    availablePromoCodes: 'Códigos promocionales disponibles',
    downloadAvailableCodes: 'Descargar los códigos disponibles',
    lNextValue: 'siguiente valor',
    participantsAllPlayersDesc: 'Permite incluir a todos los jugadores como participantes cuando se ejecute el trigger',
    participantsAllPlayersMainAreaDesc: 'El sistema incluirá a todos los jugadores como participantes tras ejecutar el trigger.',
    freeSpinAmountConfigInfo: 'Seleccione el proveedor y el número de líneas para obtener las restricciones de importe',
    freeSpinRequiredAllGames: 'Este proveedor admite giros gratis en todos los juegos',
    maxWinAmount: 'Importe Máx Ganado',
    line: 'Línea',
    casinoBonus: 'Bonos de Casinos',
    campaignStatus: 'Estado de la Campaña',
    spinsAmount: 'Cantidad de Spins',
    maxTriggerCount: 'Número Máximo de Disparos',
    maxTriggerCountInfo: 'Este campo permitirá establecer el número máximo de disparos con éxito por jugador',
    freeSpinCurrencyInfo: 'El sistema incluye las divisas admitidas por la marca y el proveedor elegido',
    amountRanges: 'Rango de Importe ( Desde - Hasta)',
    amountRangesHint: 'El importe del campo " Desde " del " Rango de Importes " se incluye en ese rango, mientras que el importe del campo " Hasta " no se incluye en el rango.',
    numberOfPlayers: 'Número de Jugadores ( Desde - Hasta )',
    numberOfPlayersHint: 'El número del campo "Desde" del "Número de Jugadores" se incluye en ese intervalo, mientras que el número del campo "Hasta" no se incluye en el intervalo.',
    numberOfReferees: 'Número de Árbitros ( Desde - Hasta)',
    numberOfRefereesHint: 'El número del campo " Desde " del " Número de Árbitros " se incluye en ese intervalo, mientras que el número del campo " Hasta " no se incluye en el intervalo.',
    campaignStatistics: 'Estadísticas de la Campaña',
    maxLimitAmount: 'Importe Límite Máx.',
    netDepositAmountHint: 'El número del campo " Desde " del " Importe Neto del Depósito " se incluye en ese intervalo, mientras que el número del campo " Hasta " no se incluye en el intervalo.',
    gameSegmentInfo: 'Los cambios en el segmento de juego no afectarán a las entidades ya creadas.',
    lCashbackAmounts: 'importes de cashback',
    usedPromoCodes: 'Códigos Promocionales Usados',
    createCrossPlatformCampaign: 'Crear una Campaña Multiplataforma',
    amountConfigAreaCrossCampaignInfo: 'En este ámbito, establecemos limitaciones por divisa',
    selectAndConfigureBonuses: 'Seleccionar y configurar las bonificaciones',
    cashbackStatistics: 'Estadísticas CashBack',
    freeSpinAmountConfigInfoForSingle: 'Seleccione proveedor, número de líneas y juego para obtener restricciones de importe',
    minMaxProviderLimit: 'Límite de Proveedor Mín-Máx',
    spinTotalAmount: 'Importe Total de Spin',
    minMaxProviderLimitInfo: 'El Importe Total de Spin generado a partir del recuento de spins multiplicado por el importe de spins debe estar entre los límites mencionados.',
    maxWageringOddType: 'Tipo Máx. de la Cuota de Wagering',
    maxWageringOdd: 'Máx. Cuota de Wagering',
    wageringOdd: 'Cuota Wagering',
    winAmountTransferTo: 'Transferir el Importe de la Ganancia',
    allowCashout: 'Permitir Cashout',
    allowCashoutInfo: 'Permite a los jugadores utilizar las funcionalidades de retiro de efectivo/retiro parcial para este bono.',
    editTriggerDisabled: 'No se puede editar el trigger ahora',
    bonusAbuse: 'Bonificación Abuso',
    minBetAmountPerCategory: 'Importe Mínimo de Apuesta por Categoría',
    periodDescriptionEvery: 'Aquí podemos establecer en qué periodo definir el Recuento Máximo de Disparos, si no está configurado el sistema no limitará el trabajo de disparo para un jugador',
    totalBets: 'Apuestas Totales',
    totalWins: 'Victorias Totales',
    subMethod: 'Submétodo',
    paymentConditionPropertiesInfo: 'El menú de submétodos sólo es visible para los métodos de pago para los que el agregador proporciona la lista de submétodos.',
    verificationTriggerInfo: 'La condición funcionará si se verifican todas las opciones seleccionadas, también se incluye la verificación del campo de activación',
    promoCodesUploadFormatMsg: 'Puede cargar códigos promocionales. Sólo se acepta el formato CSV',
    amountConfigDepositSingleDesc: 'Permitir la configuración de un % por moneda',
    amountConfigDepositRangesDesc: 'Permitir la configuración de múltiples rangos % para cada moneda',
    canceller: 'Anulador',
    awardedBonusesDetails: 'Detalles de las bonificaciones concedidas',
    bonusLowestAmount: 'Bonificaciones más bajas',
    bonusHighestAmount: 'Bonificaciones más elevadas',
    totalBonusAmount: 'Importe Total de la Bonificación',
    checkTheListOfRecipients: 'Consulte la lista definitiva de destinatarios',
    allGames: 'Todos los Juegos',
    allGamesDesc: 'Permite establecer el sorteo de bonificaciones en todos los juegos de la marca, se tendrán en cuenta todos los cambios en los juegos de la marca.',
    selectGamesDesc: 'Permite establecer sorteos de bonificaciones en proveedores y juegos específicos',
    contribution: 'Contribución, %.',
    addPlayersNote: 'Sólo es posible añadir nuevos participantes. De lo contrario, quedarán automáticamente excluidos de la lista de participantes',
    campaignParticipants: 'Participantes en la campaña',
    autoActivation: 'Autoactivación',
    autoActivationDesc:
      'Permite asignar el bono ya activado al jugador. Se recomienda configurar un bono de cada tipo de bono (Casino, Deporte, Free Spin) en caso de uso de autoactivación. De lo contrario, los bonos se activarán aleatoriamente',
    promoCodeCaseSensitiveInfo: 'Permite configurar el código promocional para los jugadores. Los códigos no son sensibles a la clave para los jugadores y se convertirán a formato mayúsculas',
    supportPlayerCancellationGamesInfo: 'El proveedor permite seleccionar {{tipo}} de juegos y no permite cancelar el bono después de la activación',
    referralStatistics: 'Estadísticas de remisión',
    campaignWillBeSavedInBgInfo: 'A medida que los datos de la Campaña sean mayores, se guardarán en segundo plano y estarán disponibles en la lista de Campañas.',
    contentAndNotification: 'Contenido y Notificación',
    contentAndNotificationConfigsRemovedDesc: 'Todas las configuraciones de Contenido Extra y Notificación fueron removidas, trás guardar se perderán todas las configuraciones previas.',
    cloneContentFrom: 'Clonar <0>{{bonusName}}</0> contenido de bonificación A',
    contentLanguages: 'Idioma de los contenidos',
    notificationInfo: 'En esta área, configuramos una notificación para los jugadores sobre la asignación de bonificaciones, si no se selecciona ninguna plantilla los jugadores no serán notificados con canales de comunicación de la marca.',
    contentInfo:
      'En esta área se configuran las imágenes y el contenido relacionado con los bonos con los idiomas de la marca, que serán visibles para los jugadores. Si el contenido no está configurado el sistema utilizará el contenido por defecto.',
    editContent: 'Editar Contenido',
    bonusStatistics: 'Estadísticas adicionales',
    sportBonus: 'Bonificación Deportiva',
    manageContentAndNotification: 'Gestionar Contenidos y Notificaciones',
    minCashbackAmount: 'Importe mín. del Cashback',
    triggerDeviceTypeDesc: 'Comprueba el tipo de dispositivo del disparador',
    signUpDeviceTypeDesc: 'Comprueba el tipo de dispositivo a través del cual se registró el reproductor',
    viewContentAndNotifications: 'Ver Contenidos y Notificaciones',
    winType: 'Tipo de Ganancia',
    winOptions: 'Tipo de Ganancia',
    realMoney: 'Dinero Real',
    availableBonus: 'Bono Disponible',
    wageringBonus: 'Bono Wagering',
    pauseBonus: 'Bonificación del Bono ',
    pauseBonusDesc: 'Al activar esta opción, el jugador podrá pausar la bonificación recibida y reanudarla más tarde.',
    pausedDate: 'Fecha de pausa',
    resumedDate: 'Fecha de reanudación',
    sidebarParticipantsDescription:
      'Aquí podemos elegir las condiciones de selección de los participantes de la campaña: Lista de jugadores, Lista de jugadores - Importes, Código de promoción, Condiciones',
    contentAndNotificationSidebarNoBonuses: {
      text1: '',
      text2: 'El área de contenidos y notificaciones se activará tras configurar y guardar las bonificaciones',
    },
    sidebarTriggerDescription: 'Aquí podemos establecer las configuraciones de activación de la campaña: Sin activación, Depósito, Inscripción, Verificación',
    contentAndNotificationSidebarDesc: 'Aquí podemos elegir las bonificaciones configuradas y añadir contenido y notificaciones específicos de las bonificaciones.',
    contentAndNotificationResultAreaDesc: 'Puede ver el Contenido y la Notificación de las bonificaciones después de añadirlas y configurarlas desde el área lateral.',
    configAlreadySaved: 'Si ya tienes configurados los bonos o los participantes, elimínalos para poder editar',
    oneTimeBet: 'Apuesta Única',
    oneTimeBetInfo: 'Requiere que los jugadores utilicen el bono por completo',
    triggerConditionsResultAreaDesc: 'Puedes ver la Condición de Activación después de añadirlas y configurarlas desde el área lateral.',
    triggerConditions: 'Condiciones de Activación',
    websiteImage: 'Imagen del Sitio Web',
    sidebarTriggerConditionDescription: 'Aquí podemos elegir las condiciones específicas para activar la campaña.',
    mobileImage: 'Imagen Móvil',
    specificTimePeriod: 'Período de Tiempo Específico',
    weekDays: 'Días Laborables',
    monthlyDatesConditionDesc: 'Verifica a los jugadores en fechas específicas.',
    dates: 'Fechas',
    monthlyDates: 'Fechas Mensuales',
    sourceId: 'ID de Fuente',
    sourceName: 'Nombre de Fuente',
    participationGroupsNote: 'Puedes ver los Grupos de Participación después de añadirlos y configurarlos desde el área lateral.',
    participationGroupsDesc: 'Puedes ver las Condiciones de Participación después de añadirlas y configurarlas desde el área lateral.',
    lParticipationGroups: 'Grupos de Participación',
    playerListDesc: 'Permite incluir jugadores subiendo un archivo CSV o manualmente.',
    playerListAmountDesc: 'Permite incluir jugadores con montos individuales de bono subiendo la lista de jugadores.',
    allPlayersDesc: 'Permite incluir a todos los jugadores como participantes cuando se ejecuta el disparador.',
    promoCodeDesc: 'Permite incluir jugadores usando un código promocional generado.',
    additionalConditions: 'Condiciones Adicionales',
    participationGroups: 'Grupos de Participación',
    participationGroup: 'Grupo de Participación',
    lParticipationGroup: 'Grupo de Participación',
    playersAreParticipants: 'Los jugadores son incluidos como participantes.',
    bonusesDesc: 'Puedes ver los Bonos después de añadirlos y configurarlos desde el área lateral.',
    gameConfig: 'Configuración de Juego',
    recurringConditionDesc: 'Verifica los disparadores de los jugadores en días específicos o fechas mensuales.',
    conditionTypes: 'Tipos de Condición',
    lTriggerCondition: 'condición de activación',
    bonusAbuseInfoNote: 'Después de activar esta casilla, los jugadores no podrán apostar desde el saldo de bono en el mismo evento más de una vez.',
    productSelection: 'Selección de Producto',
    casinoGameConfig: 'Configuración de Juegos de Casino',
    contents: 'Contenidos',
    lCampaignContent: 'contenido de campaña',
    lBonusContent: 'contenido de bono',
    units: 'Unidades',
    triggerCondition: 'Condición de Activación',
    wageringLogic: 'Lógica de Wagering',
    wageringBaseAmount: 'Monto Base para Wagering',
    wageringCoefficient: 'Coeficiente de Wagering',
    wageringCount: 'Conteo de Wagering',
    calculationLogic: 'Lógica de Cálculo',
    wageringParticipation: 'Participación en Wagering',
    firstWalletDebited: 'Se debita la 1ª billetera',
    lockAmount: 'Monto Bloqueado',
    allowNonMatchingBets: 'Permitir apuestas no coincidentes',
    triggerBasedConfig: 'Configuración basada en Trigger',
    lUnit: 'unidad',
    unitsDesc: 'Puedes ver las Unidades después de añadirlas y configurarlas desde el área lateral.',
    navigationItemsDisabledInfo: 'Los elementos de navegación se activarán después de guardar la sección General de la Campaña.',
    sidebarTriggerConditionInfo: 'Puedes ver las Condiciones de Activación después de añadirlas y configurarlas desde el área lateral.',
    summary: 'Resumen',
    offers: 'Ofertas',
    offersContentTabInfo:
      'En esta área configuramos las imágenes y contenido relacionados con la campaña en los idiomas de la marca, que serán visibles para los jugadores. Es necesario configurar el contenido con el idioma principal de la marca.',
    sidebarUnitInfo: 'Puedes ver las Unidades después de añadirlas y configurarlas desde el área lateral.',
    lContent: 'contenido',
    offersContent: 'Contenido de Unidades (Ofertas)',
    lOfferContent: 'contenido de oferta',
    unit: 'Unidad',
    totalOdds: 'Cuota Total',
    minTotalOdd: 'Cuota mínima Total',
    maxTotalOdd: 'Cuota máxima Total',
    sportEventConfig: 'Configuración de Evento Deportivo',
    lockType: 'Tipo de Bloqueo',
    gamesConditionDesc: 'Verifica los juegos lanzados para activar el Trigger',
    transactionAmount: 'Monto de la Transacción',
    unitName: 'Nombre de Unidad',
    productType: 'Tipo de Producto',
    isUsedInUnit: 'Usado en unidad',
    minBetTriggerAmount: 'Monto mínimo para activar apuesta',
    bonusAmount: 'Monto de bono',
    point: 'Punto',
    contributedFrom: 'Contribuido desde',
    contributedFromDescription: 'Aquí podemos establecer qué apuestas deben participar en la facturación de turnover de apuestas',
    sportBetsConditionDesc: 'Verifica las apuestas de los jugadores en eventos deportivos específicos',
    casinoBetsConditionDesc: 'Verifica las apuestas de los jugadores en juegos de casino específicos',
    betAmountConfigFixedAmountDesc:
      'Permite proporcionar un monto fijo de bono para cada moneda (por moneda). En el caso de un monto fijo, podemos configurar las condiciones de apuesta usando opciones de única o rango.',
    amountConfigFromBetDesc: 'Permite contar el monto del bono como un porcentaje de la apuesta (general para todas las monedas)\n% de la apuesta',
    fromBet: '% de la apuesta',
    bonusOptionsDesc5: 'Los jugadores recibirán bonos por todas las apuestas durante el período del trigger',
    gameInfo: 'Tipo(s) de soporte de juego seleccionado(s): <0>{{type}}</0>',
    freeGameType: 'Tipo de Juego Gratis',
    combinations: 'Combinaciones',
    involvement: 'Participación',
    sports: 'Deportes',
    tournaments: 'Torneos',
    events: 'Eventos',
    markets: 'Mercados',
    allEventsAreSelected: 'Todos los eventos están seleccionados',
    allMarketsAreSelected: 'Todos los mercados están seleccionados',
    customSelection: 'Selección personalizada',
    live: 'En vivo',
    lEvents: 'eventos',
    lMarkets: 'mercados',
    lMarket: 'mercado',
    lEvent: 'evento',
    lTournaments: 'torneos',
    entitiesLimitInfo: 'El número máximo de entidades (torneos, eventos, mercados) es {{count}}. La selección se cuenta en caso de selección personalizada.',
    fromBetAmount: '% del Monto de Apuesta',
    gamesCount: 'Cantidad de Juegos',
    freeSpinGamesInfo: 'Selecciona proveedor para obtener juegos',
    previousUnit: 'Unidad Anterior',
    previousUnitInfo: 'La unidad actual se asignará una vez que el bono de la unidad seleccionada termine. Esto es aplicable solo a unidades dentro del mismo grupo de participantes.',
    eventType: 'Tipo de Evento',
    complainer: 'Denunciante',
    hashtagDescription: 'Descripción del hashtag',
    lPlayerBonus: 'bono para jugador',
    lPlayersBonuses: 'bonos para jugadores',
    playerBonus: 'Bono para jugador',
    playersBonuses: 'Bonos para jugadores',
    eligibleBets: 'Apuestas Elegibles',
    eligibleBetsStatus: 'Estado de Apuestas Elegibles',
    betBuilder: 'Bet Builder',
    betBuilderTotalOdds: 'Cuota Total de Bet Builder',
    betBuilderMultiSelectionNum: 'Número de Multi-selección de Bet Bulder',
    minBetBuilderTotalOdd: 'Cuota mínima total de Bet Builder',
    maxBetBuilderTotalOdd: 'Cuota máxima total de Bet Builder',
    lUnitBonuses: 'bonos de unidad',
    partialCancel: 'Cancelación Parcial',
    addPlayers: 'Agregar Jugadores',
    pointEnhancement: 'Mejora de Puntos',
    pointEnhancementInfo: 'Activa la opción para establecer un número requerido de apuestas para ganar cada bono por puntos.',
    betCount: 'Conteo de Apuestas',
    bonusOptionsDesc6: 'Los jugadores recibirán bonos por cumplir los requisitos mínimos de apuesta y conteo dentro de un solo punto y un período de tiempo definido.',
    lobbyWidgetGameSegmentInfo:
      'Los cambios en el segmento de juego no afectarán a las entidades ya creadas. Solo aparecerán en la lista los juegos que sean comunes para el segmento seleccionado y el lobby.',
    wageringParticipationInfo: 'Las apuestas del tipo Cashout no se incluirán en el cálculo del volumen de apuestas.',
    bonusOptionsDesc4: 'Los jugadores recibirán bonificaciones por el total de apuestas realizadas en un período de tiempo específico.',
    sidebarBonusesDescription: 'Aquí podemos elegir los tipos de bonificación disponibles: Sport, Spins, Casino y Special, y agregarlos a la campaña.',
    participantsJoinDesc: 'Permite incluir a los jugadores como participantes mediante la acción "Unirse" en el sitio web.',
    campaignContent: 'Contenido de la Campaña',
    bonusContent: 'Contenido del Bono',
    campaignContentTabInfo:
      'En esta sección, configuramos las imágenes y el contenido relacionado con la campaña en los idiomas de la marca, que serán visibles para los jugadores. Es necesario configurar el contenido en el idioma principal de la marca.',
    signInDate: 'Fecha de Registro',
    remainingBonusAmount: 'Cantidad de Bono Restante',
    bonusAbuseInfo: {
      1: 'Al activar esta casilla, los jugadores no podrán realizar más de una apuesta desde el saldo de bono en el mismo evento',
      2: 'Al activar esta casilla, los jugadores no podrán realizar más de una apuesta desde el saldo de bono en el mismo evento.'
          + ' En el caso de un bono con requisito de apuesta real, si el jugador realiza más de una apuesta desde el saldo real en el mismo evento que cumple las condiciones del bono, la segunda apuesta no reducirá el requisito de apuesta',
    },
    code: 'Código',
    dynamicDesc: 'Permite generar comisiones basadas en indicadores financieros, ya sea por referido individual o de forma conjunta por todos los referidos',
    progressiveDesc: 'Permite establecer rangos de comisión específicos según el número de jugadores referidos',
    prizeDesc: 'Permite establecer rangos de comisión para otorgar una recompensa fija única a los nuevos referidos que cumplan las condiciones requeridas',
    supportPlayerCancellationGameInfo1: 'El proveedor permite la cancelación por parte del jugador',
    supportPlayerCancellationGameInfo2: 'El proveedor no permite la cancelación por parte del jugador',
    bonusContentDesc: 'Puedes ver el {{type}} de los bonos después de añadirlos y configurarlos desde el panel lateral',
    noUnitWithEmptyContentForLanguage: 'No hay unidades con contenido vacío en este idioma',
    noBonusWithEmptyContent: 'No hay bonos con contenido vacío',
    currentStage: 'Etapa actual',
    inProcess: 'En proceso',
    placedBetAmount: 'Importe de apuestas realizadas',
    totalBetCount: 'Número total de apuestas',
    placedBetCount: 'Número de apuestas realizadas',
    periodDate: 'Fecha del período',
    grantBonus: 'Otorgar bono',
    bonusWillBeGrantedAfterWageringCompleted: 'El bono seleccionado se otorgará una vez se complete el requisito de apuesta del bono actual',
    infoMaxRedeemAmount: 'El importe máximo a canjear es {{value}}',
    infoSpinsAmount: 'La cantidad de tiradas es {{value}}',
    infoCombinationValues: 'Los valores de combinación son {{value}}',
    participationType: 'Tipo de participación',
    resetToDefault: 'Restablecer a valores predeterminados',
    amountRange: 'Rango de importe',
    considerAsBTag: 'Considerar como BTAG',
    considerAsBTagInfo: 'Esta opción sobrescribirá el campo btag si el código promocional coincide con el introducido por el jugador',
    byPlayerID: 'Por ID de jugador',
    byTags: 'Por etiquetas',
    bySegments: 'Por segmentos',
    dynamicSelection: 'Selección dinámica',
    staticSelection: 'Selección estática',
    deleted: 'Eliminado',
    onJoinUnitInfo: 'Especifica si esta configuración utiliza sus propios ajustes de unión o no',
    riskyGameExclusionInfo: 'Los cambios en los riesgos del juego no afectarán a las entidades ya creadas',
    conditionsInfo: 'Solo los nuevos jugadores referidos son elegibles. Cada jugador referido debe cumplir todas las condiciones seleccionadas para generar una comisión para el referidor',
    minWithdrawalAmount: 'Importe mínimo de retirada',
    withdrawalAmountConfigFixedAmountDesc: 'Permite asignar un importe de bono fijo para cada moneda (por moneda). En el caso de un importe fijo, se pueden configurar las condiciones de retirada mediante opciones únicas o por rango',
    fromWithdrawal: '% de la retirada',
    amountConfigFromWithdrawalDesc: 'Permite calcular el importe del bono como un porcentaje de la retirada (general para todas las monedas)',
    fromWithdrawalAmount: '% del importe de retirada',
    sourceTypes: 'Tipos de origen',
    unitsAllocation: 'Asignación de unidades',
    unitsAllocationInfo: 'Selecciona un único trigger - Todas las unidades si deseas que el jugador reciba todas las unidades creadas con un solo trigger. Asegúrate de establecer las condiciones de cada unidad de forma similar, para que se asignen al mismo tiempo al cumplir todos los requisitos',
    providers: 'Proveedores',
  },
  tr: {
    maxBonusAmount: 'Maksimum Bonus Tutarı',
    minDepositAmount: 'Minimum Para Yatırma Tutarı',
    maxRedeemAmount: 'Maksimum Aktarılacak Tutar',
    minBetAmount: 'Minimum  Bahis Tutarı',
    contributionPercent: 'Katkı %',
    cashbackPercent: 'Cashback  %',
    currencies: 'Para Birimleri',
    triggerPeriod: 'Tetikleme Dönemi',
    activationPeriod: 'Aktivasyon Dönemi',
    playthrough: 'En Başından Oyna',
    wageringPeriod: 'Çevrim Süresi',
    issueBonus: 'Bonus Verme',
    bonusId: 'Bonus ID',
    promoName: 'Promosyon Adı',
    promoCode: 'Promosyon Kodu',
    promoCodeType: 'Promosyon Kodu Türü',
    lPromoCode: 'Promosyon Kodu',
    maxUseCount: 'Maksimum Kullanım Sayısı',
    dateUsed: 'Kullanıldığı Tarih',
    promotionEndDate: 'Promosyon Bitiş Tarihi',
    issuedBy: 'Veren',
    canceledBy: 'İptal Eden',
    mobileVerified: 'Cep Telefonu Onaylandı',
    identityVerified: 'Kimlik Doğrulandı',
    emailVerified: 'E-posta Doğrulandı',
    disconnectedBy: 'Bağlantıyı Kesen',
    disconnectTrigger: 'Tetikleyici Bağlantısını Kes',
    turnoverAmount: 'Ciro Tutarı',
    remainingTurnover: 'Kalan çevirim',
    bonusStatus: 'Bonus Durumu',
    triggeredDate: 'Tetiklendiği Tarihi',
    providerMayDisabled: 'Sağlayıcı devre dışı bırakılmış olabilir.',
    gameMayDisabled: 'Oyun devre dışı bırakılmış olabilir.',
    maxCashbackAmount: 'Maksimum Cashback Tutarı',
    cashbackId: 'Cashback ID',
    cashbackName: 'Cashback Adı',
    cashbackType: 'Cashback Türü',
    calculationTime: 'Hesaplama Süresi',
    transferType: 'Transfer Türü',
    platforms: 'Platformlar',
    platform: 'Platform',
    restrictedPlayers: 'Yasaklı Oyuncular',
    restrictedCountries: 'Yasaklı Ülkeler',
    totalBet: 'Toplam Bahis',
    totalWin: 'Toplam Kazanç',
    accumulated: 'Birikmiş',
    accumulatedCashBack: 'Akümülatör Kayıp Bonusu',
    transferredCashBack: 'Aktarılan CashBack',
    commission: 'Komisyon',
    commissions: 'Komisyonlar',
    lCommissions: 'Komisyonlar',
    commissionPercent: 'Komisyon %',
    manageLimits: 'Limitleri Yönet',
    referees: 'Referans Olunanlar',
    setCommissions: 'Komisyonları Ayarla',
    referralBonusId: 'Referans Bonus ID',
    lReferralBonus: 'IReferans bonusu',
    referralBonus: 'Referans Bonusu',
    calculationPeriodTime: 'Hesaplama Dönemi Zamanı',
    commissionFrom: 'Komisyon ',
    referrerId: 'Referans ID',
    accumulatedCommission: 'Akümülatör Komisyonu',
    nextCalculationDate: 'Sonraki Hesaplama Tarihi',
    transferredCommission: 'Transfer edilen Komisyon',
    commissioningAmount: 'Alınan Komisyon',
    convertedTo: 'Dönüştürüldü',
    convertedAmount: 'Dönüştürülen Tutar',
    redeemedAmount: 'Aktarılan Tutar',
    winAmount: 'Kazanç Tutarı',
    lossAmount: 'Kayıp Tutarı',
    cashbackAmount: 'Cashback Tutarı',
    includeActiveBonuses: 'Aktif Bonusları Dahil Et',
    lBonus: 'Bonus',
    bonus: 'Bonus',
    casino: 'Casino',
    invalidPlayerCount: 'Geçersiz Oyuncu Sayısı',
    totalPlayersUpdated: 'Güncellenecek toplam oyuncu sayısı',
    lBonusTemplate: 'Bonus şablonu',
    bonusTemplate: 'Bonus Şablonu',
    invalidKeys: 'Geçersiz Anahtarlar',
    playersMissingCurrencyReason: 'Oyuncunun hesap para birimi yapılandırılmamış',
    playersRestrictedReason: 'Oyuncunun hesap durumu yasaklı ',
    missingCurrency: 'Eksik Para Birimi',
    missingCurrencyReason: 'Oyuncunun hesap para birimi yapılandırılmamış',
    issue: 'Oluştur',
    platformType: 'Platform Türü',
    amountConfig: 'Tutar Yapılandırması',
    paymentMethods: 'Ödeme Yöntemleri',
    first: 'Birinci',
    second: 'İkinci',
    third: 'Üçüncü',
    fourth: 'Dördüncü',
    fifth: 'Beşinci',
    fromDepositAmount: 'Yatırılan Tutardan %',
    fromDeposit: 'Yatırılandan %',
    betType: 'Bahis Türü',
    minWageringOdd: 'Min Çevrim Oranı',
    minWageringOddType: 'Min Çevrim Oran Türü',
    bonusTemplateName: 'Bonus Şablon Adı',
    bonusTemplateId: 'Bonus Şablon ID',
    categories: 'Kategoriler',
    bonusOptionsDesc: 'Kaydolma bonusu, yeni bir oyuncuya ödenen paranın toplamıdır.',
    bonusOptionsDesc1: 'Oyuncular tetikleme dönemindeki tüm para yatırma işlemleri için bonus alacaklar',
    bonusOptionsDesc2: 'Kullanıcı, oyuncuların tetikleme döneminde kaç para yatırma işlemi için bonus alacağını seçebilir',
    bonusOptionsDesc3: 'Oyuncular, tetikleme döneminde her gün ilk para yatırma işlemleri için bonus alırlar.',
    createNewTemplate: 'Yeni Şablon Oluştur',
    selectBonusType: 'BONUS TÜRÜ SEÇİN',
    selectBonusTrigger: 'BONUS TETİKLEYİCİSİ SEÇİN',
    numberOfDeposits: 'Para Yatırma Sayısı',
    fixedAmount: 'Sabit Tutar',
    sport: 'Spor',
    rules: 'Kurallar',
    rule: 'Kural',
    noRules: 'Gösterilecek Kural Yok',
    relatedBonusId: 'İlgili Bonus ID',
    endDateTime: 'Bitiş Tarihi/Saati',
    noEndDate: 'Bitiş Tarihi Yok',
    selectGames: 'Oyun Seç',
    activities: 'Faaliyetler',
    discardAccumulatedCommissions: 'Akümülatör komisyonlarını yok say',
    playersInAnotherReferral: 'Başka bir Referans Bonusunda yer alan oyuncular',
    allPlayersSelected: 'Tüm oyuncular seçildi',
    datesAndPlayers: 'Tarihler ve Oyuncular',
    special: 'Özel',
    highRisk: 'Yüksek Risk',
    mediumRisk: 'Orta Risk',
    countOfReferees: 'Referans Sayısı',
    playerFromParticipants: 'katılımcılar arasından oyuncu',
    signUp: 'Kayıt ol',
    bonusNameExternal: 'Bonus Adı (Harici)',
    noEndData: 'Bitiş Tarihi Yok',
    minNumberOfSelections: 'Min Seçim Sayısı',
    dateTriggered: 'Tetikleme Tarihi',
    referralBonusName: 'Referans Bonusu Adı',
    refereesId: 'Referans Olunanlar ID',
    refereeId: 'Referans ID',
    realWallet: 'Gerçek Cüzdan',
    details: 'Detaylar',
    numberOfDepositsInfo: 'Tetikleme döneminde oyuncuların bonus alması gereken para yatırma işlemlerini seçin.',
    numberOfDepositsTabIndex: {
      1: 'Para Yatırma Sayısı TabIndex__1',
      2: 'Para Yatırma Sayısı TabIndex__2',
      3: 'Para Yatırma Sayısı TabIndex__3',
      default: 'Para Yatırma Sayısı TabIndex__varsayılan',
    },
    cloneUnit: 'Klon Birimi',
    cloneBonus: 'Klon Bonusu',
    cloneSettingsTo: 'Ayarları Klonla',
    balanceConfig: 'Bakiye Yapılandırması',
    usedCount: 'Kullanılan Sayı',
    lRule: 'kural',
    referralParticipants: 'Referans katılımcıları',
    theCashback: 'Cashback',
    playersCashBack: 'Oyuncuların cashback’leri',
    theBonus: 'Bonus',
    wageringTurnover: 'Bahis çevrimi',
    playersWontBeAble: 'Oyuncular, verilen bonus tutarını çekemez veya P2P oyunlarına bahis yapamaz.',
    calculationFrom: 'HESAPLAMA',
    lCalculationFrom: 'Hesaplama',
    createNewCashback: 'Yeni Cashback Oluştur',
    cashbackFromBetsDesc: 'Hesaplama döneminde bahis - kazanç arasındaki pozitif fark üzerinden cashback sağlar.',
    cashbackNetDepositsDesc: 'Hesaplama dönemindeki para yatırma - para çekme arasındaki pozitif fark üzerinden cashback sağlar.',
    netDepositAmount: 'Net Para Yatırma Tutarı',
    participateRule: 'Katılım Kuralı',
    totalDeposit: 'Toplam Para Yatırma',
    totalWithdrawal: 'Toplam Para Çekme',
    totalBonuses: 'Toplam Bonuslar',
    manageParticipation: 'Katılımı Yönet',
    restrictionFor: 'Yasaklanmış',
    availableFor: 'Uygun ',
    sportWageringBonuses: 'Spor Çevrim Bonusları',
    casinoWageringBonuses: 'Casino Çevrim Bonusları',
    otherBonuses: 'Diğer Bonuslar',
    finishedBonusesCount: 'Biten Bonus Sayısı',
    totalRedeemBonuses: 'Toplam Aktarılacak Bonuslar',
    referralCommission: 'Referans Komisyonu',
    maxPossibleTransfer: 'Maksimum Olası Transfer',
    playThroughRequired: ' Baştan Sona Oynama Gerekli',
    matchingRegistrationIP: "Referans olan kişinin eşleşen kayıt IP'lerine sahip referansları var",
    sameRegistrationIP: "Referans olan kişi ve referans aynı kayıt IP'sine sahip",
    expirationPeriod: 'Son kullanma dönemi',
    lengthOfCodes: 'Kod Uzunluğu',
    amountColumnInfo: 'Aralık, sol sütun değerini, sağ sütun değerine kadar içerir ancak bu değeri içermez',
    selectedGames: 'Seçili Oyunlar',
    minAmount: 'Min. Tutar',
    step: 'Adım',
    gamesInfo: 'Sağlayıcı {{type}} oyunları seçmeye izin verir',
    lSingle: 'Tekli',
    lMultiple: 'Kombine',
    allowWithdrawal: 'Para Çekmeye İzin Ver',
    campaignName: 'Kampanya Adı',
    noTrigger: 'Tetikleyici Yok ',
    cancelBonusWhenWithdrawal: 'Para Çekerken Bonusu İptal Et',
    number: 'Sayı ',
    participant: 'Katılımcı',
    depositsAmountConfigInfo: 'Bu alanda, Bonus Tutarını yapılandırır ve para birimine göre limitleri koyarız  ',
    bonusBetConfig: 'Bonus Bahis Yapılandırması',
    single: 'Tekli',
    ranges: 'Aralıklar',
    nextValue: 'Sonraki değer',
    lPrevValue: 'önceki değer',
    addRanges: 'Aralık Ekle',
    lifetimePeriod: 'Ömürboyu Süre  ',
    resetRanges: 'Aralıkları Sıfırla',
    lCampaign: 'kampanya',
    multi: 'Kombine',
    option: 'Seçenek',
    triggers: 'Tetikleyiciler',
    viewRanges: 'Aralıkları Görüntüle',
    depositNumber: 'Para Yatırma Numarası',
    bonusResultAreaDesc: 'Bonusları ekledikten ve yapılandırdıktan sonra yan alandan görebilirsiniz.',
    participantsResultAreaDesc: 'Katılımcıları ekledikten ve yapılandırdıktan sonra yan alandan görebilirsiniz.',
    editTriggerDisabled: 'Artık tetikleyiciyi düzenleyemezsiniz',
    multiOrSingleBonus: 'Kombine ve Tekli Bonus tanımı',
    editParticipantsDisabled: 'Artık katılımcıları düzenleyemezsiniz',
    configureParticipants: 'Katılımcıları yapılandır',
    selectTriggerParticipantsBonuses: 'Tetikleyiciyi Seçin, Katılımcıları Seçin, Bonusları Yapılandırın',
    toMakeSureCampaignSuccessful: 'Kampanyanızın başarılı olması için',
    participantType: 'Katılımcı Türü',
    triggerType: 'Tetikleyici Türü',
    cancelPromotion: 'Promosyonu İptal Et',
    createCampaign: 'Kampanya Oluştur',
    multiOrSinglePromocodeType: 'Kombine ve tekli promosyon kodu türü tanımı',
    missingAmount: 'Eksik Tutar',
    multiSelectionNum: 'Çoklu Seçim Numarası',
    playThroughRequiredDesc: 'Bu seçeneğin açık olması durumunda, Playthrough alan değeri ayarlanan sayıya eşit olmalı, kapalı olması durumunda ise eşit veya daha büyük olmalıdır.',
    playThroughInputDesc: 'Bir oyuncunun bonusu tamamlayabilmesi için bonus yapılandırmasında tanımlanan sayıda bonus bahsi oynaması gerekip gerekmediğini tanımlama sağlar (0 çevirimin dışında )',
    cancelBonusWhenWithdrawalDesc: 'Para Çekiminde Bonusu İptali Tanımı',
    triggerOption: 'Tetikleyici Seçenekleri',
    campaign: 'Kampanya',
    periodDescription: 'Burada para yatırma numarasının hangi dönemde tanımlanacağını ayarlayabiliriz',
    singleCountTypeDesc:
      'Sadece bir bonus ayarlamaya izin verir, ancak her para yatırma numarası için farklı tutarlarda, aynı bonus türüne sahip birkaç bonus yapılandırmak gerekmediği durumlarda kullanılabilir',
    multiCountTypeDesc:
      'Her para yatırma numarası için farklı tutar konfigürasyonlarına sahip farklı bonus türlerinin ayarlanmasına izin verir. Bu durumda, her bonus türü için para yatırma numarasını (olası değerler 1, ..., 100) seçiyoruz',
    disconnectTriggerDesc:
      'Bu fonksiyon etkinleştirilirse ve oyuncu en az bir bonus aldıysa ancak bonus koşullarını karşılamıyorsa, sistem oyuncunun kampanya ile bağlantısını kesecek ve oyuncu artık yeni bonuslar alamayacaktır',
    participantsPlayerDesc: 'CSV yükleyerek veya manuel olarak oyuncuları dahil etmeye izin verir',
    participantsPlayerListAmountsDesc: 'Oyuncu listesini yükleyerek bireysel bonus tutarlarına sahip oyuncuları dahil etmeye izin verir',
    participantsPromoCodeDesc: 'Oluşturulmuş promosyon kodunu kullanarak oyuncuları dahil etmeye izin verir',
    countryConditionDesc: 'Oyuncuların ülkesini kontrol eder',
    verifyConditionDesc: 'Oyuncuların doğrulama seviyesini kontrol eder',
    weekDaysConditionDesc: 'Oyuncuları belirli günlerde kontrol eder',
    accountStatusConditionDesc: 'Oyuncuların hesap durumlarını kontrol eder',
    sportStatusConditionDesc: "Oyuncuların Sportsbook'taki durumlarını kontrol eder",
    segmentConditionDesc: 'Oyuncuların dahil olduğu segmentleri kontrol eder',
    tagConditionDesc: 'Oyuncuların sahip olduğu etiketleri kontrol eder',
    paymentsConditionDesc: 'Oyuncuların ödeme işlemlerini kontrol eder',
    configModeAlreadyOpened: 'Yapılandırma modunu zaten açık',
    bonusBetConfigInfo: 'Bonus bahislerin yapılandırılmasına izin verir. Bahis, bonus bahis olarak kabul edilmek için kayıtlı kriterlerle eşleşmelidir',
    amountConfigSingleDesc: 'Para birimi başına tek tutar yapılandırmasının ayarlanmasına izin ver',
    amountConfigRangesDesc: 'Her para birimi için çok aralıklı tutar yapılandırması ayarlamaya izin ver',
    depositAmountConfigFixedAmountDesc:
      'Her para birimi için sabit bir bonus tutarı sağlamaya izin verir (Para birimine göre). Sabit Tutar durumunda, Tek veya Aralık seçeneklerini kullanarak Para Yatırma koşullarını yapılandırabiliriz',
    amountConfigFromDepositDesc: 'Bonus tutarını para yatırma işleminden yüzde olarak saymaya izin verir (genel tüm para birimleri için )',
    noDataAlt: 'Tetikleyici yok, Katılımcılar, Bonuslar seçildi',
    successPlayers: 'Oyuncular bonus kazanabilir',
    errorPlayers: 'Eksik Para Birimi',
    amountConfigAreaInfo: 'Bu alanda, Bonus Tutarını yapılandırır ve para birimi başına limit koyarız',
    availableCount: 'Kullanılabilir Sayı',
    availablePromoCodes: 'Kullanılabilir Promosyon Kodları',
    downloadAvailableCodes: 'Kullanılabilir Kodları İndir',
    lNextValue: 'sonraki değer',
    participantsAllPlayersDesc: 'Tetikleyici çalıştırıldığında tüm oyuncuların katılımcı olarak dahil edilmesine izin verir',
    participantsAllPlayersMainAreaDesc: 'Tetikleyici çalıştırıldıktan sonra sistem tüm oyuncuları katılımcı olarak dahil edecektir.',
    campaignStatus: 'Kampanya Durumu',
    freeSpinAmountConfigInfo: 'Tutar sınırlaması için sağlayıcıyı ve satır sayısını seçin',
    freeSpinRequiredAllGames: "Bu sağlayıcı tüm oyunlarda free spin'i destekler",
    maxWinAmount: 'Maksimum Kazanç Tutarı',
    line: 'Satır',
    casinoBonus: 'Casino Bonusu',
    spinsAmount: 'Spin Tutarı',
    maxTriggerCount: 'Maksimum Tetikleme Sayısı',
    maxTriggerCountInfo: 'Bu alan, oyuncu başına maksimum başarılı tetikleme sayısının ayarlanmasına izin verir',
    freeSpinCurrencyInfo: 'Sistem, marka ve seçilen sağlayıcı tarafından desteklenen para birimlerini içerir',
    amountRanges: 'Tutar Aralığı (Tutardan - Tutara)',
    amountRangesHint: "Tutar Aralığı'nın 'Tutardan' alanındaki tutar bu aralığa dahil edilir ancak 'Tutara' alanındaki tutar aralığa dahil edilmez.",
    numberOfPlayers: 'Oyuncu Sayısı (Sayıdan - Sayıya)',
    numberOfPlayersHint: "Oyuncu Sayısı'nın 'Sayıdan' alanındaki sayı bu aralığa dahil edilir ancak 'Sayıya' alanındaki sayı aralığa dahil edilmez.",
    numberOfReferees: 'Referans Sayısı (Sayıdan - Sayıya)',
    numberOfRefereesHint: "Referans Sayısı'nın 'Sayıdan' alanındaki sayı bu aralığa dahil edilir ancak  'Sayıya' alanındaki sayı aralığa dahil edilmez.",
    campaignStatistics: 'Kampanya İstatistikleri',
    maxLimitAmount: 'Maksimum Limit Tutarı',
    netDepositAmountHint: "Net Para Yatırma Tutarı'nın 'Tutardan' alanındaki sayı bu aralığa dahil edilir ancak 'Tutara' alanındaki sayı aralığa dahil edilmez.",
    gameSegmentInfo: 'Oyun segmentindeki değişiklikler önceden oluşturulan öğeyi etkilemez',
    lCashbackAmounts: 'Cashback Tutarı',
    usedPromoCodes: 'Kullanılan Promosyon Kodları',
    createCrossPlatformCampaign: 'Çapraz Platform Kampanyası Oluşturun',
    amountConfigAreaCrossCampaignInfo: 'Bu alanda, para birimi başına limit koyabiliriz',
    selectAndConfigureBonuses: 'Bonusları seçin ve yapılandırın',
    cashbackStatistics: 'CashBack İstatistikleri',
    freeSpinAmountConfigInfoForSingle: 'Tutar sınırlamaları için sağlayıcı, sıra numarası ve oyun seçin',
    minMaxProviderLimit: 'Min-Maks Sağlayıcı Limiti',
    spinTotalAmount: 'Spin Toplam Tutar',
    minMaxProviderLimitInfo: 'Spin sayısı ile spin tutarının çarpımından elde edilen Spin Toplam Tutarı belirtilen limitler arasında olmalıdır',
    maxWageringOddType: 'Maksimum Çevrim Oran Türü',
    maxWageringOdd: 'Maksimum Çevrim Oranı',
    wageringOdd: 'Çevrim Oranı',
    winAmountTransferTo: 'Kazanç Tutarını Transfer Et',
    allowCashout: "Cashout'a İzin Ver",
    allowCashoutInfo: 'Oyuncuların bu bonus için cashout / kısmi cashout işlevlerini kullanmalarına izin verir',
    sidebarBonusesDescription: 'Burada Spor, Spinler, Casino ve Özel bonus türlerini seçebilir ve kampanyaya ekleyebiliriz',
    bonusAbuse: 'Bonus Suistimal',
    oneTimeBet: 'Tek Seferlik Bahis',
    oneTimeBetInfo: 'Oyuncuların bonusu tamamen kullanması gerekir',
    minBetAmountPerCategory: 'Kategori Bazında Minimum Bahis Tutarı',
    periodDescriptionEvery: 'Burada Maksimum Tetikleme Sayısını hangi dönem için tanımlayacağımızı ayarlayabiliriz, eğer yapılandırılmamışsa sistem bir oyuncu için tetiklemeyi sınırlamaz',
    totalBets: 'Toplam Bahisler',
    totalWins: 'Toplam Kazanç',
    subMethod: 'Alt Yöntem',
    paymentConditionPropertiesInfo: 'Alt yöntem menüsü yalnızca toplayıcı tarafından alt yöntemler listesi sağlanan ödeme yöntemleri için görünür.',
    verificationTriggerInfo: 'Seçili tüm seçenekler doğrulanırsa koşul çalışır, tetikleme alanı doğrulaması da buna dahildir',
    promoCodesUploadFormatMsg: 'Promosyon kodlarını yükleyebilirsiniz. Sadece CSV formatında kabul edilir',
    amountConfigDepositSingleDesc: 'Para birimi başına tek bir % yapılandırması ayarlamaya izin verir',
    amountConfigDepositRangesDesc: 'Her para birimi için çok aralıklı % yapılandırması ayarlamaya izin verir',
    canceller: 'İptal Edici',
    awardedBonusesDetails: 'Ödüllendirilmiş Bonus Detayları',
    bonusLowestAmount: 'En Düşük Bonus Tutarı',
    bonusHighestAmount: 'En Yüksek Bonus Tutarı',
    totalBonusAmount: 'Toplam Bonus Tutarı',
    checkTheListOfRecipients: 'Lütfen alıcıların son listesini kontrol edin',
    allGames: 'Tüm Oyunlar',
    allGamesDesc: 'Markanın tüm oyunlarında bonus çekilişi ayarlamaya izin verir, marka oyunlarındaki tüm değişiklikler dikkate alınır',
    selectGamesDesc: 'Belirli sağlayıcılar ve oyunlar için bonus çekilişi ayarlamaya izin verir',
    contribution: 'Katılım, %',
    addPlayersNote: 'Yalnızca yeni katılımcılar eklemek mümkündür. Aksi takdirde, katılımcılar listesinden otomatik olarak çıkarılırlar',
    campaignParticipants: 'Kampanya katılımcıları',
    autoActivation: 'Otomatik Etkinleştirme',
    autoActivationDesc:
      'Önceden etkinleştirilen bonusun oyuncuya verilmesine izin verir. Otomatik etkinleştirme kullanımı durumunda her bonus türünden (Casino, Spor, Free Spin) bir bonus yapılandırılması önerilir. Aksi takdirde, bonuslar rastgele etkinleştirilecektir',
    promoCodeCaseSensitiveInfo: 'Oyuncular için promosyon kodunu yapılandırmaya izin verir. Kodlar oyuncular için büyük/küçük harfe duyarlı değildir ve büyük harf formatına dönüştürülecektir',
    supportPlayerCancellationGamesInfo: 'Sağlayıcı {{type}} türünde oyunların seçilmesine izin verir ve etkinleştirme sonrasında bonusun iptal edilmesine izin vermez',
    referralStatistics: 'Yönlendirme İstatistikleri',
    campaignWillBeSavedInBgInfo: 'Kampanya verileri büyüdükçe, arka plan modunda kaydedilir ve Kampanyalar listesinde bulunur.',
    contentAndNotification: 'İçerik ve Bildirim',
    contentAndNotificationConfigsRemovedDesc: 'Tüm Bonus İçerik ve Bildirim konfigürasyonları kaldırıldı, kaydettikten sonra önceki tüm yapılandırmaları kaybedeceksiniz.',
    cloneContentFrom: 'Bonus içeriğine <0>{{bonusName}}</0> klonla',
    contentLanguages: 'İçerik Dilleri',
    notificationInfo: 'Bu alanda, oyuncular için bonus dağıtımı hakkında bir bildirim yapılandırılır, herhangi bir şablon seçilmezse oyuncular marka iletişim kanalları ile bilgilendirilmez.',
    contentInfo: 'Bu alanda, oyuncular tarafından görülebilecek görselleri ve bonusla ilgili içeriği markanın dilleriyle yapılandırırız. İçerik yapılandırılmazsa, sistem varsayılan içeriği kullanır.',
    editContent: 'İçeriği Düzenle',
    bonusStatistics: 'Bonus İstatistikleri',
    sportBonus: 'Spor Bonusu',
    manageContentAndNotification: 'İçeriği ve Bildirimi Yönet',
    minCashbackAmount: 'Min Cashback Tutarı',
    triggerDeviceTypeDesc: 'Tetikleyicinin cihaz türünü kontrol eder',
    signUpDeviceTypeDesc: 'Oyuncunun kaydedildiği cihaz türünü kontrol eder',
    viewContentAndNotifications: 'İçeriği ve Bildirimleri Görüntüle',
    winType: 'Kazanç Türü',
    winOptions: 'Kazanç Tutarı Türü',
    realMoney: 'Real Money',
    availableBonus: 'Kullanılabilir Bonus',
    wageringBonus: 'Çevrim Bonusu',
    pauseBonus: 'Bonusu Duraklat',
    pauseBonusDesc: 'Seçeneği etkinleştirerek, oyuncu aldığı bonusu duraklatabilir ve daha sonra yeniden başlatabilir',
    pausedDate: 'Duraklatıldığı Tarih',
    resumedDate: 'Yeniden Başlatıldığı Tarih',
    sidebarParticipantsDescription: 'Burada kampanya katılımcılarının seçim koşullarını belirleyebiliriz: Oyuncu listesi, Oyuncu listesi - Tutarlar, Promosyon Kodu, Koşullar',
    contentAndNotificationSidebarNoBonuses: {
      text1: '',
      text2: 'Bonusları yapılandırıp kaydettikten sonra İçerik ve Bildirim alanı etkin hale gelecektir',
    },
    sidebarTriggerDescription: 'Burada kampanya tetikleyici konfigürasyonlarını ayarlayabiliriz: Tetikleyici Yok, Para Yatırma, Kaydolma, Doğrulama',
    contentAndNotificationSidebarDesc: 'Burada yapılandırılmış bonusları seçebilir ve bonusa özel içerik ve bildirim ekleyebilirsiniz',
    contentAndNotificationResultAreaDesc: 'Yan alandan ekleyip yapılandırdıktan sonra bonuslar için İçerik ve Bildirimi görebilirsiniz.',
    configAlreadySaved: 'Bonusları veya katılımcıları zaten yapılandırdıysanız, düzenleyebilmek için bunları kaldırın',
  },
  ru: {
    maxBonusAmount: 'Макс. сумма бонуса',
    minDepositAmount: 'Мин. сумма депозита',
    maxRedeemAmount: 'Макс. сумма использования',
    minBetAmount: 'Мин. сумма ставки',
    contributionPercent: 'Взнос (%)',
    cashbackPercent: 'Кешбэк (%)',
    bonusType: 'Тип бонуса',
    currencies: 'Валюты',
    triggerPeriod: 'Период триггера',
    activationPeriod: 'Период активации',
    playthrough: 'Прохождение',
    wageringPeriod: 'Период вейджеринга',
    issueBonus: 'Выдать бонус',
    bonusId: 'ID бонуса',
    promoName: 'Название промоакции',
    promoCode: 'Промокод',
    promoCodeType: 'Тип промокода',
    lPromoCode: 'промокод',
    maxUseCount: 'Сколько раз можно использовать (макс.)',
    dateUsed: 'Дата использования',
    promotionEndDate: 'Дата окончания промоакции',
    issuedBy: 'Кем выдан',
    canceledBy: 'Кем отменен',
    mobileVerified: 'Верифицировано для мобильных устройств',
    identityVerified: 'Личность подтверждена',
    emailVerified: 'Адрес эл. почты подтвержден',
    disconnectedBy: 'Кем отключен',
    disconnectTrigger: 'Отключить триггер',
    turnoverAmount: 'Сумма оборота',
    remainingTurnover: 'Остаток оборота',
    bonusStatus: 'Статус бонуса',
    triggeredDate: 'Дата запуска триггера',
    providerMayDisabled: 'Провайдер может быть отключен.',
    gameMayDisabled: 'Игра может быть отключена.',
    maxCashbackAmount: 'Макс. сумма кешбэка',
    cashbackId: 'ID кешбэка',
    cashbackName: 'Название кешбэка',
    cashbackType: 'Тип кешбэка',
    calculationTime: 'Время расчета',
    transferType: 'Тип перевода',
    platforms: 'Платформы',
    platform: 'Платформа',
    restrictedPlayers: 'Игроки с ограниченным доступом',
    restrictedCountries: 'Запрещенные страны',
    totalBet: 'Общая ставка',
    totalWin: 'Общий выигрыш',
    accumulated: 'Накоплено',
    accumulatedCashBack: 'Накопленный кешбэк',
    transferredCashBack: 'Переведенный кешбэк',
    commission: 'Комиссия',
    commissions: 'Комиссии',
    lCommissions: 'Комиссии',
    commissionPercent: 'Комиссия (%)',
    manageLimits: 'Управление лимитами',
    referees: 'Рефералы',
    setCommissions: 'Установить комиссии',
    referralBonusId: 'ID реферального бонуса',
    lReferralBonus: 'реферальный бонус',
    referralBonus: 'Реферальный бонус',
    calculationPeriodTime: 'Время периода расчета',
    commissionFrom: 'Комиссия от',
    referrerId: 'ID реферера',
    accumulatedCommission: 'Накопленная комиссия',
    nextCalculationDate: 'Следующая дата расчета',
    transferredCommission: 'Переведенная комиссия',
    commissioningAmount: 'Сумма комиссии',
    convertedTo: 'Конвертировано в',
    convertedAmount: 'Конвертированная сумма',
    redeemedAmount: 'Использованная сумма',
    winAmount: 'Сумма выигрыша',
    lossAmount: 'Сумма проигрыша',
    cashbackAmount: 'Сумма кешбэка',
    includeActiveBonuses: 'Включить активные бонусы',
    lBonus: 'бонус',
    bonus: 'Бонус',
    casino: 'Казино',
    invalidPlayerCount: 'Неверное количество игроков в отчете',
    totalPlayersUpdated: 'Всего игроков, которые будут обновлены',
    lBonusTemplate: 'шаблон бонуса',
    bonusTemplate: 'Шаблон бонуса',
    invalidKeys: 'Недействительные ключи',
    playersMissingCurrencyReason: 'Валюта счета игрока не задана',
    playersRestrictedReason: 'Игрок ограничил статус учетной записи',
    missingCurrency: 'Валюта не указана',
    missingCurrencyReason: 'Валюта аккаунта игрока не задана',
    issue: 'Выпуск',
    platformType: 'Тип платформы',
    amountConfig: 'Конфигурация учетной записи',
    paymentMethods: 'Методы оплаты',
    first: 'Первый',
    second: 'Второй',
    third: 'Третий',
    fourth: 'Четвертый',
    fifth: 'Пятый',
    fromDepositAmount: '% от суммы депозита',
    fromDeposit: '% от депозита',
    betType: 'Тип ставки',
    minWageringOdd: 'Мин. коэффициент вейджера',
    minWageringOddType: 'Тип мин. коэффициента вейджера',
    bonusTemplateName: 'Название шаблона бонуса',
    bonusTemplateId: 'ID шаблона бонуса',
    categories: 'Категории',
    bonusOptionsDesc: 'Бонус за регистрацию — это сумма, выплачиваемая новому игроку',
    bonusOptionsDesc1: 'Игроки получат бонусы за все депозиты, внесенные в период акции',
    bonusOptionsDesc2: 'Пользователь может выбрать за сколько депозитов, внесенных в период акции, игроки получат бонусы',
    bonusOptionsDesc3: 'Игроки получат бонусы за первый депозит каждого дня в течение акции',
    createNewTemplate: 'Создать новый шаблон',
    selectBonusType: 'ВЫБРАТЬ ТИП БОНУСА',
    selectBonusTrigger: 'ВЫБРАТЬ ТРИГГЕР БОНУСА',
    numberOfDeposits: 'Количество депозитов',
    fixedAmount: 'Фиксированная сумма',
    sport: 'Спорт',
    rules: 'Правила',
    rule: 'Правило',
    noRules: 'Нет правил для показа',
    relatedBonusId: 'ID связанного бонуса',
    endDateTime: 'Дата/время завершения',
    noEndDate: 'Нет даты завершения',
    selectGames: 'Выбрать игры',
    activities: 'Действия',
    discardAccumulatedCommissions: 'Отменить накопленные комиссии',
    playersInAnotherReferral: 'Игроки уже участвуют в другой Реферальной бонусной программе',
    allPlayersSelected: 'Выбраны все игроки',
    datesAndPlayers: 'Даты и игроки',
    special: 'Эксклюзивный',
    highRisk: 'Высокий риск',
    mediumRisk: 'Средний риск',
    countOfReferees: 'Количество рефералов',
    playerFromParticipants: 'игрок из числа участников',
    signUp: 'Зарегистрироваться',
    bonusNameExternal: 'Название бонуса (Внешнего)',
    noEndData: 'Нет даты завершения',
    minNumberOfSelections: 'Мин. количество выбранных вариантов',
    dateTriggered: 'Дата активации триггера',
    referralBonusName: 'Название реферального бонуса',
    refereesId: 'ID рефералов',
    refereeId: 'ID реферала',
    realWallet: 'Реальный кошелек',
    details: 'Podrobnosti',
    numberOfDepositsInfo: 'Выбрать депозиты, за которые игроки должны получить бонусы в течение периода триггера.',
    numberOfDepositsTabIndex: {
      1: 'ый',
      2: 'ой',
      3: 'ий',
      default: 'ый',
    },
    cloneUnit: 'Клонировать юнит',
    cloneBonus: 'Клонировать бонус',
    cloneSettingsTo: 'Перенести настройки в',
    balanceConfig: 'Настройки баланса',
    usedCount: 'Количество использованных',
    lRule: 'правило',
    referralParticipants: 'Участники реферальной программы',
    theCashback: 'Кешбэк',
    playersCashBack: 'Кешбэк игроков',
    theBonus: 'Бонус',
    wageringTurnover: 'Оборот вейджера по ставкам',
    playersWontBeAble: 'Игроки не смогут вывести или сделать ставки на P2P-игры на сумму полученного бонуса.',
    calculationFrom: 'РАСЧЕТ ОТ',
    lCalculationFrom: 'Расчет от',
    createNewCashback: 'Создать новый кешбэк',
    cashbackFromBetsDesc: 'Предоставляет кешбэк на положительную разницу между ставкой и выигрышем в расчетном периоде.',
    cashbackNetDepositsDesc: 'Предоставляет кешбэк на положительную разницу между депозитами и выведенными средствами в расчетном периоде.',
    netDepositAmount: 'Чистая сумма депозита',
    participateRule: 'Правило участия',
    totalDeposit: 'Всего депозитов',
    totalWithdrawal: 'Всего выведено средств',
    totalBonuses: 'Всего бонусов',
    manageParticipation: 'Управление участием',
    restrictionFor: 'Ограничено для',
    availableFor: 'Доступно для',
    sportWageringBonuses: 'Спортивные вейджеры',
    casinoWageringBonuses: 'Казино вейджеры',
    otherBonuses: 'Другие бонусы',
    finishedBonusesCount: 'Количество завершенных бонусов',
    totalRedeemBonuses: 'Всего использовано бонусов',
    referralCommission: 'Реферальная комиссия',
    maxPossibleTransfer: 'Макс. возможный перевод',
    playThroughRequired: 'Отыгрыш обязателен',
    matchingRegistrationIP: 'У реферера есть рефералы с одинаковыми регистрационными IP-адресами',
    sameRegistrationIP: 'У реферера и реферала одинаковый регистрационный IP-адрес',
    expirationPeriod: 'Срок истечения',
    lengthOfCodes: 'Длина кодов',
    amountColumnInfo: 'Диапазон включает значение левого столбца, до значения правого столбца, но не включая его',
    selectedGames: 'Выбранные игры',
    minAmount: 'Мин. сумма',
    step: 'Шаг',
    gamesInfo: 'Провайдер позволяет выбрать {{type}} игры',
    lSingle: 'однократный',
    lMultiple: 'множественный',
    allowWithdrawal: 'Разрешить вывод средств',
    campaignName: 'Название кампании',
    noTrigger: 'Без триггера',
    cancelBonusWhenWithdrawal: 'Отменить бонус при выводе средств',
    number: 'Номер',
    participant: 'Участник',
    depositsAmountConfigInfo: 'В этой части мы устанавливаем размер бонуса и ограничения по валютам',
    bonusBetConfig: 'Конфигурации бонусной ставки',
    single: 'Однократный',
    ranges: 'Диапазоны',
    nextValue: 'Следующее значение',
    lPrevValue: 'предыдущее значение',
    addRanges: 'Добавить диапазоны',
    lifetimePeriod: 'Жизненный цикл',
    resetRanges: 'Сбросить диапазоны',
    lCampaign: 'кампания',
    multi: 'Мульти',
    option: 'Опция',
    triggers: 'Триггеры',
    viewRanges: 'Посмотреть диапазоны',
    depositNumber: 'Номер депозита',
    bonusResultAreaDesc: 'Вы можете посмотреть бонусы после их добавления и конфигурации в боковой части.',
    participantsResultAreaDesc: 'Вы можете увидеть Участников после их добавления и настройки в боковой части.',
    editTriggerDisabled: 'Вы не можете отредактировать триггер сейчас',
    multiOrSingleBonus: 'Описание мульти- и однократных бонусов',
    editParticipantsDisabled: 'Вы не можете редактировать участников сейчас',
    configureParticipants: 'Настройка участников',
    selectTriggerParticipantsBonuses: 'Выберите триггер, выберите участников, настройте бонусы',
    toMakeSureCampaignSuccessful: 'Для обеспечения успеха вашей кампании',
    participantType: 'Тип участника',
    triggerType: 'Тип триггера',
    cancelPromotion: 'Отменить акцию',
    createCampaign: 'Создать акцию',
    multiOrSinglePromocodeType: 'Описание типов мульти- и одноразовых промокодов',
    missingAmount: 'Недостающая сумма',
    multiSelectionNum: 'Номер выбранного мульти-',
    playThroughRequiredDesc: 'Если опция включена, то значение поля «Отыгрыш» должно быть равно заданному числу, если выключена, то должно быть равно или больше',
    playThroughInputDesc: 'Позволяет определить, должен ли игрок отыграть бонус столько раз, сколько определено в конфигурации отыгрыша, чтобы иметь возможность завершить бонус (кроме 0 в обороте)',
    triggerOption: 'Опции триггера',
    campaign: 'Кампания',
    periodDescription: 'Здесь мы можем установить, в каком периоде определять номер депозита',
    singleCountTypeDesc:
      'Позволяет установить только один бонус, но с разными суммами для каждого номера депозита, используется в случаях, когда нам не нужно настраивать несколько бонусов с одинаковыми типами бонусов',
    multiCountTypeDesc:
      'Позволяет устанавливать различные типы бонусов с разными конфигурациями суммы для каждого номера депозита. В данном случае мы выбираем номер депозита (возможные значения 1, ..., 100) для каждого типа бонуса',
    disconnectTriggerDesc:
      'Если эта функция активирована, и игрок получил хотя бы один бонус, но не удовлетворяет условиям бонуса, то система отключит его от кампании, и игрок больше не будет получать новые бонусы',
    participantsPlayerDesc: 'Позволяет включать игроков путем загрузки CSV или вручную',
    participantsPlayerListAmountsDesc: 'Позволяет включить игроков с индивидуальными суммами бонусов, загрузив список игроков',
    participantsPromoCodeDesc: 'Позволяет включать игроков с помощью сгенерированного промокода',
    countryConditionDesc: 'Проверяет страны игроков',
    verifyConditionDesc: 'Проверяет уровень верификации игроков',
    weekDaysConditionDesc: 'Проверяет игроков в определенные дни',
    accountStatusConditionDesc: 'Проверяет состояние счетов игроков',
    sportStatusConditionDesc: 'Проверяет статусы игроков в Спортсбуке',
    segmentConditionDesc: 'Проверяет сегменты, в которые входят игроки',
    tagConditionDesc: 'Проверяет теги игроков',
    paymentsConditionDesc: 'Проверяет транзакционные платежи игроков',
    configModeAlreadyOpened: 'Вы уже открыли режим настройки',
    bonusBetConfigInfo: 'Позволяет настраивать бонусные ставки. Ставка должна соответствовать сохраненным критериям, чтобы считаться бонусной ставкой',
    amountConfigSingleDesc: 'Позволяет устанавливать конфигурацию отдельных сумм для каждой валюты',
    amountConfigRangesDesc: 'Позволяет устанавливать несколько диапазонов сумм для каждой валюты',
    depositAmountConfigFixedAmountDesc:
      'Позволяет предоставить сумму бонуса, фиксированную для каждой валюты (по валюте). В случае фиксированной суммы мы можем настроить условия депозита, используя опции Однократный или Диапазон',
    amountConfigFromDepositDesc: 'Позволяет рассчитывать размер бонуса в процентах от депозита (общий для всех валют)',
    noDataAlt: 'Без триггера, Участники, Выбранные бонусы',
    successPlayers: 'Игроки могут получить бонус',
    errorPlayers: 'Отсутствующая валюта',
    amountConfigAreaInfo: 'В этой части мы настраиваем сумму бонуса и устанавливаем ограничения по валютам',
    availableCount: 'Доступное количество',
    availablePromoCodes: 'Доступные промокоды',
    downloadAvailableCodes: 'Скачать доступные коды',
    lNextValue: 'следующее значение',
    participantsAllPlayersDesc: 'Позволяет включить всех игроков в качестве участников при активации триггера',
    participantsAllPlayersMainAreaDesc: 'Система включит всех игроков в число участников после активации триггера.',
    freeSpinAmountConfigInfo: 'Выберите провайдера и количество строк, чтобы получить ограничения по сумме',
    freeSpinRequiredAllGames: 'Этот провайдер поддерживает фриспины во всех играх',
    maxWinAmount: 'Макс. сумма выигрыша',
    line: 'Строка',
    casinoBonus: 'Бонус казино',
    campaignStatus: 'Статус кампании',
    spinsAmount: 'Сумма спинов',
    maxTriggerCount: 'Максимальное количество триггеров',
    maxTriggerCountInfo: 'Поле позволяетт установить максимальное количество успешных триггеров на игрока',
    freeSpinCurrencyInfo: 'Система содержит валюты, поддерживаемые брендом и выбранным провайдером',
    amountRanges: 'Диапазон суммы (от-до)',
    amountRangesHint: 'Сумма в поле «От» в «Диапазоне сумм» включена в диапазон, тогда как сумма в поле «До» в диапазон не включена.',
    numberOfPlayers: 'Количество игроков (от-до)',
    numberOfPlayersHint: 'Число в поле «От» в «Количестве игроков» включено в диапазон, тогда как число в поле «До» в диапазон не входит.',
    numberOfReferees: 'Количество рефералов (от-до)',
    numberOfRefereesHint: 'Число в поле «От» в «Количестве рефералов» включено в диапазон, тогда как число в поле «До» в диапазон не входит.',
    campaignStatistics: 'Статистика кампании',
    maxLimitAmount: 'Макс. лимит',
    netDepositAmountHint: 'Число в поле «От» в «Чистая сумма депозита» включено в диапазон, тогда как число в поле «До» в диапазон не включено .',
    gameSegmentInfo: 'Изменения в игровом сегменте не повлияют на созданный ранее субъект',
    lCashbackAmounts: 'суммы кешбэка',
    usedPromoCodes: 'Использованные промокоды',
    createCrossPlatformCampaign: 'Создать кроссплатформенную кампанию',
    amountConfigAreaCrossCampaignInfo: 'В этой области мы устанавливаем ограничения по валюте',
    selectAndConfigureBonuses: 'Выберите и настройте бонусы',
    cashbackStatistics: 'Статистика кешбэка',
    freeSpinAmountConfigInfoForSingle: 'Выберите провайдера, количество строк и игру, чтобы получить ограничения по сумме',
    minMaxProviderLimit: 'Мин.-макс. лимит провайдера',
    spinTotalAmount: 'Общая сумма спинов',
    minMaxProviderLimitInfo: 'Общая сумма спинов, сгенерированная путем умножения количества спинов на сумму спинов, должна быть в рамках указанных пределов',
    maxWageringOddType: 'Тип макс. коэффициента вейджера',
    maxWageringOdd: 'Макс. коэффициент вейджера',
    wageringOdd: 'Коэффициент вейджера',
    winAmountTransferTo: 'Перевести сумму выигрыша',
    allowCashout: 'Разрешить вывод средств',
    allowCashoutInfo: 'Позволяет игрокам использовать функции полного / частичного вывода средств для этого бонуса.',
    sidebarBonusesDescription: 'Здесь мы можем выбрать Спорт, Спины, Казино и специальные доступные типы бонусов и добавить их в кампанию.',
    cancelBonusWhenWithdrawalDesc: 'Позволяет автоматически отменить бонус, если игрок совершит операцию по выводу средств в период активации и истечения срока действия бонуса',
    bonusAbuse: 'Злоупотребление бонусами',
    oneTimeBet: 'Одноразовая ставка',
    oneTimeBetInfo: 'Требует от игроков полного использования бонуса',
    minBetAmountPerCategory: 'Минимальная сумма ставки в каждой категории',
    periodDescriptionEvery:
      'Здесь мы можем установить, в какой период определить максимальное количество триггеров, если оно не настроено, то система не будет ограничивать работу триггеров для игрока',
    totalBets: 'Всего ставок',
    totalWins: 'Всего выигрышей',
    subMethod: 'Подметод',
    paymentConditionPropertiesInfo: 'Меню подметодов отображается только для тех способов оплаты, для которых агрегатор предоставляет список подметодов.',
    verificationTriggerInfo: 'Условие будет работать, если проверены все выбранные параметры, и проверка триггерного поля также включена',
    promoCodesUploadFormatMsg: 'Вы можете загружать промокоды. Допускается только формат CSV',
    amountConfigDepositSingleDesc: 'Позволяет устанавливать единую настройку % для каждой валюты',
    amountConfigDepositRangesDesc: 'Позволяет устанавливать несколько диапазонов % для каждой валюты',
    canceller: 'Отмена',
    awardedBonusesDetails: 'Подробности о начисленных бонусах',
    bonusLowestAmount: 'Наименьшие суммы бонусов',
    bonusHighestAmount: 'Наибольшие суммы бонусов',
    totalBonusAmount: 'Общая сумма бонусов',
    checkTheListOfRecipients: 'Пожалуйста, ознакомьтесь с окончательным списком получателей',
    allGames: 'Все игры',
    allGamesDesc: 'Позволяет установить розыгрыш бонусов на все игры бренда, все изменения в играх бренда будут учтены',
    selectGamesDesc: 'Позволяет установить розыгрыш бонусов на определенных провайдеров и игры',
    contribution: 'Вклад, %',
    addPlayersNote: 'Можно добавлять только новых участников. В обратном случае они будут автоматически исключены из списка участников',
    campaignParticipants: 'Участники кампании',
    autoActivation: 'Автоактивация',
    autoActivationDesc:
      'Позволяет распределить уже активированный бонус между игроками. В случае использования автоактивации рекомендуется настраивать по одному бонусу из каждого типа бонусов (казино, спорт, фриспины). В обратном случае бонусы будут активироваться случайным образом',
    promoCodeCaseSensitiveInfo: 'Позволяет настроить промокод для игроков. При написании кода чувствительность клавиатуры не имеет большого значения, и коды будут преобразованы в заглавные буквы',
    supportPlayerCancellationGamesInfo: 'Провайдер позволяет выбрать {{type}} игры и не позволяет отменить бонус после активации',
    referralStatistics: 'Статистика рефералов',
    campaignWillBeSavedInBgInfo: 'По мере увеличения объема данных кампании они будут сохраняться в фоновом режиме и будут доступны в списке кампаний.',
    contentAndNotification: 'Контент и уведомления',
    contentAndNotificationConfigsRemovedDesc: 'Все конфигурации Бонусного контента и уведомлений были удалены, после сохранения вы потеряете все предыдущие конфигурации.',
    cloneContentFrom: 'Клонировать <0>{{bonusName}}</0> бонусный контент Чтобы',
    contentLanguages: 'Языки контента',
    notificationInfo: 'В этой части мы настраиваем уведомление для игроков о распределении бонусов, если шаблон не выбран, игроки не будут уведомляться с помощью фирменных каналов связи.',
    contentInfo:
      'В этой части мы настраиваем изображения и связанный с бонусами контент на языках бренда, который будет виден игрокам. Если контент не настроен, система будет использовать контент по умолчанию.',
    editContent: 'Редактировать контент',
    bonusStatistics: 'Статистика бонусов',
    sportBonus: 'Спортивный бонус',
    manageContentAndNotification: 'Управление контентом и уведомлениями',
    minCashbackAmount: 'Минимальная сумма кешбэка',
    triggerDeviceTypeDesc: 'Проверяет тип устройства триггера',
    signUpDeviceTypeDesc: 'Проверяет тип устройства, через которое был зарегистрирован игрок',
    viewContentAndNotifications: 'Просмотр Контента и уведомлений',
    winType: 'Тип выигрыша',
    winOptions: 'Тип суммы выигрыша',
    realMoney: 'Реальные деньги',
    availableBonus: 'Доступный бонус',
    wageringBonus: 'Вейджер',
    pauseBonus: 'Бонус за паузу',
    pauseBonusDesc: 'Включив эту опцию, игрок сможет приостановить получение бонуса, а затем возобновить его',
    pausedDate: 'Дата паузы',
    resumedDate: 'Дата возобновления',
    sidebarParticipantsDescription: 'Здесь мы можем выбрать условия отбора участников кампании: Список игроков, Список игроков - Суммы, Промокод, Условия',
    contentAndNotificationSidebarNoBonuses: {
      text1: '',
      text2: 'Часть «Контент и уведомления» станет активной после настройки и сохранения бонусов',
    },
    sidebarTriggerDescription: 'Здесь мы можем задать конфигурацию триггеров кампании: Без триггера, Депозит, Регистрация, Верификация',
    contentAndNotificationSidebarDesc: 'Здесь мы можем выбрать настроенные бонусы, а также добавить контент и уведомления о бонусах',
    contentAndNotificationResultAreaDesc: 'Вы можете увидеть Контент и уведомления для бонусов после их добавления и настройки в боковой области.',
    configAlreadySaved: 'Если у вас уже есть настроенные бонусы или участники, удалите их, чтобы иметь возможность редактировать',
    campaignContent: 'Содержание кампании',
    campaignContentTabInfo: 'Здесь мы настраиваем изображения и контент, связанный с кампанией, на языках бренда, которые будут видны игрокам. Необходимо настроить контент на основном языке бренда',
    signInDate: 'Дата входа',
    remainingBonusAmount: 'Оставшаяся сумма бонуса',
    triggerConditionsResultAreaDesc: 'Вы можете увидеть условия триггеров после их добавления и настройки из бокового раздела.',
    triggerConditions: 'Условия триггера',
    websiteImage: 'Изображение веб-сайта',
    sidebarTriggerConditionDescription: 'Здесь мы можем выбрать условия, характерные для триггера кампании',
    mobileImage: 'Мобильное изображение',
    specificTimePeriod: 'Конкретный период времени',
    weekDays: 'Будни',
    monthlyDatesConditionDesc: 'Проверяет игроков на конкретную дату',
    dates: 'Даты',
    monthlyDates: 'Ежемесячные даты',
    sourceId: 'ID источника',
    sourceName: 'Название источника',
    participationGroupsNote: 'Вы сможете увидеть группы участия после их добавления и настройки из бокового раздела.',
    participationGroupsDesc: 'Вы можете увидеть условия участия после их добавления и настройки из бокового раздела.',
    lParticipationGroups: 'группы участия',
    playerListDesc: 'Позволяет включать игроков, загружая CSV или вручную',
    playerListAmountDesc: 'Позволяет включать игроков с индивидуальными суммами бонусов, загружая список игроков',
    allPlayersDesc: 'Позволяет включить всех игроков в число участников при выполнении триггера',
    promoCodeDesc: 'Позволяет включать игроков, используя сгенерированный промокод',
    additionalConditions: 'Дополнительные условия',
    participationGroups: 'Группы участия',
    participationGroup: 'Группа участия',
    lParticipationGroup: 'группа участия',
    playersAreParticipants: 'Игроки включены в число участников',
    bonusesDesc: 'Вы сможете увидеть бонусы после их добавления и настройки из бокового раздела.',
    gameConfig: 'Конфигурация игры',
    recurringConditionDesc: 'Проверяет триггеры игроков в определенные дни или ежемесячные даты',
    conditionTypes: 'Типы условий',
    lTriggerCondition: 'условие триггера',
    bonusAbuseInfoNote: 'После активации этой опции игроки не смогут делать ставки с бонусного баланса на одно и то же событие более одного раза',
    productSelection: 'Выбор продукта',
    casinoGameConfig: 'Конфигурация игры в казино',
    contents: 'Содержание',
    lCampaignContent: 'содержание кампании',
    lBonusContent: 'бонусный контент',
    units: 'Элементы',
    unitsNote: 'sd',
    triggerCondition: 'Условие триггера',
    wageringLogic: 'Логика вейджеринга',
    wageringBaseAmount: 'Базовая сумма вейджеринга',
    wageringCoefficient: 'Коэффициент вейджеринга',
    wageringCount: 'Количество вейджеров',
    calculationLogic: 'Логика расчетов',
    wageringParticipation: 'Участие в вейджеринге',
    firstWalletDebited: 'Списание средств с 1-го кошелька',
    lockAmount: 'Сумма блокировки',
    allowNonMatchingBets: 'Разрешить несовпадающие ставки',
    triggerBasedConfig: 'Конфигурация на основе триггеров',
    lUnit: 'элемент',
    unitsDesc: 'Вы можете увидеть элементы после их добавления и настройки из бокового раздела.',
    navigationItemsDisabledInfo: 'Элементы навигации станут активными после сохранения раздела «Общие сведения о кампании».',
    sidebarTriggerConditionInfo: 'Вы можете увидеть условия триггеров после их добавления и настройки из бокового раздела',
    summary: 'Краткая информация',
    offers: 'Предложения',
    offersContentTabInfo: 'Здесь мы настраиваем изображения и контент, связанный с кампанией, на языках бренда, которые будут видны игрокам. Необходимо настроить контент на основном языке бренда',
    sidebarUnitInfo: 'Вы можете увидеть элементы после их добавления и настройки из бокового раздела',
    lContent: 'содержание',
    offersContent: 'Содержание элементов (предложений)',
    lOfferContent: 'содержание предложений',
    unit: 'Элемент',
    totalOdds: 'Всего коэффициентов',
    minTotalOdd: 'Минимальный общий коэффициент',
    maxTotalOdd: 'Максимальный общий коэффициент',
    sportEventConfig: 'Конфигурация спортивного события',
    lockType: 'Тип блокировки',
    gamesConditionDesc: 'Проверяет запущенные игры на наличие триггера',
    transactionAmount: 'Сумма транзакции',
    unitName: 'Название элемента',
    productType: 'Тип продукта',
    isUsedInUnit: 'Используется в элементе',
    minBetTriggerAmount: 'Сумма триггера минимальной ставки',
    bonusAmount: 'Бонусная сумма',
    point: 'Пункт',
    contributedFrom: 'Внесено из',
    contributedFromDescription: 'Здесь мы можем задать, какие ставки должны участвовать в совокупном обороте ставок',
    sportBetsConditionDesc: 'Проверяет ставки игроков на конкретные спортивные события',
    casinoBetsConditionDesc: 'Проверяет ставки игроков в определенных играх казино',
    betAmountConfigFixedAmountDesc:
      'Позволяет указать сумму бонуса, фиксированную для каждой валюты («По валюте»). В случае фиксированной суммы мы можем настроить условия ставки, используя опции Single или Range',
    amountConfigFromBetDesc: 'Позволяет рассчитывать сумму бонуса в процентах от ставки (общий для всех валют)',
    fromBet: '% от ставки',
    bonusOptionsDesc5: 'Игроки получат бонусы за все ставки в период действия триггера',
    gameInfo: 'Выбранный тип(ы) поддержки игры: <0>{{type}}</0>',
    freeGameType: 'Тип бесплатной игры',
    combinations: 'Комбинации',
    involvement: 'Вовлеченность',
    sports: 'Спорт',
    tournaments: 'Турниры',
    events: 'События',
    markets: 'Рынки',
    allEventsAreSelected: 'Выбраны все события',
    allMarketsAreSelected: 'Выбраны все рынки',
    customSelection: 'Пользовательский выбор',
    live: 'Лайв',
    lEvents: 'события',
    lMarkets: 'рынки',
    lMarket: 'рынок',
    lEvent: 'событие',
    lTournaments: 'турниры',
    entitiesLimitInfo: 'Максимальное количество субъектов (турниры, события, рынки) равно {{count}}. Выборка учитывается в случае пользовательского выбора.',
    fromBetAmount: '% от суммы ставки',
    gamesCount: 'Подсчет игр',
    freeSpinGamesInfo: 'Выберите провайдера, чтобы получить игры',
    previousUnit: 'Предыдущий элемент',
    previousUnitInfo: 'Текущий элемент будет распределен, как только закончится бонус выбранного элемента. Это применимо только к элементам в одной группе участников',
    eventType: 'Тип события',
    complainer: 'Автор жалобы',
    hashtagDescription: 'Описание хештега',
    lPlayerBonus: 'бонус игрока',
    lPlayersBonuses: 'бонусы игрока',
    playerBonus: 'Бонус игрока',
    playersBonuses: 'Бонусы игроков',
    eligibleBets: 'Допустимые ставки',
    eligibleBetsStatus: 'Статус допустимых ставок',
    betBuilder: 'Bet Builder',
    betBuilderTotalOdds: 'Общий коэффициент Bet Builder',
    betBuilderMultiSelectionNum: 'Номер мультивыбора Bet Builder',
    minBetBuilderTotalOdd: 'Общий минимальный коэффициент Bet Builder',
    maxBetBuilderTotalOdd: 'Общий максмальный коэффициент Bet Builder',
    lUnitBonuses: 'бонусы элемента',
    partialCancel: 'Частичная отмена',
    addPlayers: 'Добавить игроков',
    pointEnhancement: 'Усиление пункта',
    pointEnhancementInfo: 'Включите возможность установить необходимое количество ставок для получения каждого бонусного очка.',
    betCount: 'Количество ставок',
    bonusOptionsDesc6: 'Игроки получают бонусы за выполнение требований по минимальной ставке и счету в одном пункте и за определенный период времени.',
    lobbyWidgetGameSegmentInfo: 'Изменения в игровом сегменте не повлияют на уже созданный субъект. В списке появятся только те игры, которые являются общими для выбранного сегмента и лобби.',
    wageringParticipationInfo: 'Ставки типа «Кешаут» не будут включены в расчет оборота.',
    bonusAbuseInfo: {
      0: 'После активации этой опции игроки не смогут делать ставки с бонусного баланса на одно и то же событие более одного раза',
      1: 'После активации этой опции игроки не смогут делать ставки с бонусного баланса на одно и то же событие более одного раза',
      2:
        'После активации этой опции игроки не смогут делать ставки с бонусного баланса на одно и то же событие более одного раза.'
        + ' В случае Реального вейджеринг-бонуса, если игрок делает ставку с реального баланса более одного раза на одно и то же событие в соответствии с требованиями бонуса, вторая ставка не должна уменьшать оборот от вейджеринга',
    },
    bonusOptionsDesc4: 'Игроки получат бонусы за общую сумму ставок, сделанных за определенный период времени.',
    participantsJoinDesc: "Позволяет включать игроков в качестве участников с помощью действия  'Join' на веб-сайте.",
    bonusContent: 'Бонусный контент',
    code: 'Код',
    dynamicDesc: 'Позволяет начислять комиссии на основе финансовых показателей как для каждого отдельного реферера, так и для всех рефереров в совокупности',
    progressiveDesc: 'Позволяет устанавливать конкретные диапазоны комиссий в зависимости от количества привлеченных игроков',
    prizeDesc: 'Позволяет устанавливать диапазоны комиссий для предоставления единовременного фиксированного вознаграждения новым привлеченным игрокам, выполнившим необходимые условия',
    supportPlayerCancellationGameInfo1: 'Провайдер позволяет отмену',
    supportPlayerCancellationGameInfo2: 'Провайдер не позволяет отмену',
    bonusContentDesc: 'Вы можете увидеть {{type}} для бонусов после их добавления и настройки в боковой панели',
    noUnitWithEmptyContentForLanguage: 'В этом языке нет пустых единиц.',
    noBonusWithEmptyContent: 'Нет бонусов с пустым содержимым',
    currentStage: 'Текущий этап',
    inProcess: 'В процессе',
    placedBetAmount: 'Сумма размещенной ставки',
    totalBetCount: 'Общее количество ставок',
    placedBetCount: 'Количество размещенных ставок',
    periodDate: 'Дата периода',
    grantBonus: 'Начисление бонуса',
    bonusWillBeGrantedAfterWageringCompleted: 'Выбранный бонус будет начислен после завершения текущих отыгрышей бонуса',
    infoMaxRedeemAmount: 'Максимальная сумма погашения: {{value}}',
    infoSpinsAmount: 'Количество спинов: {{value}}',
    infoCombinationValues: 'Значения комбинаций: {{value}}',
    participationType: 'Тип участия',
    resetToDefault: 'Сбросить до значений по умолчанию',
    amountRange: 'Диапазон сумм',
    considerAsBTag: 'Рассматривать как BTAG',
    considerAsBTagInfo: 'Эта опция переопределит поле BTAG, если промокод совпадает с кодом, введенным игроком',
    byPlayerID: 'По ID игрока',
    byTags: 'По тегам',
    bySegments: 'По сегментам',
    dynamicSelection: 'Динамический выбор',
    staticSelection: 'Статический выбор',
    deleted: 'Удалено',
    onJoinUnitInfo: 'Указывает, использует ли данная конфигурация собственные настройки присоединения или нет',
    riskyGameExclusionInfo: 'Изменения в игровых рисках не повлияют на уже созданный объект',
    conditionsInfo: 'Участвовать могут только новые приглашенные игроки. Каждый приглашенный игрок должен выполнить все выбранные условия, чтобы получить комиссию для реферера',
    minWithdrawalAmount: 'Минимальная сумма вывода средств',
    withdrawalAmountConfigFixedAmountDesc: 'Позволяет установить фиксированную сумму бонуса для каждой валюты (по валюте). В случае фиксированной суммы условия вывода можно настроить, используя варианты Единичный или Диапазон',
    fromWithdrawal: '% от вывода средств',
    amountConfigFromWithdrawalDesc: 'Позволяет рассчитывать сумму бонуса в процентах от вывода средств (общее значение для всех валют)',
    fromWithdrawalAmount: '% от суммы вывода средств',
    sourceTypes: 'Типы источников.',
    unitsAllocation: 'Распределение единиц',
    unitsAllocationInfo: 'Выберите Один триггер — Все единицы, если хотите, чтобы игрок получил все созданные единицы по одному триггеру. Убедитесь, что условия для каждой единицы заданы одинаково, чтобы все они были распределены одновременно и прошли все проверки.',
    providers: 'Поставщики',
  },
  pt: {
    maxBonusAmount: 'Quantia Máx. do Bônus',
    minBonusAmount: 'Valor Mín. do Depósito',
    maxRedeemAmount: 'Quantia Máx. do Resgate',
    minBetAmount: 'Quantia Mín. da Aposta',
    contributionPercent: 'Contribuição, %',
    cashbackPercent: 'Cashback, %',
    bonusType: 'Tipo de Bónus',
    currencies: 'Moedas',
    triggerPeriod: 'Período de Ativação',
    activationPeriod: 'Período de Ativação',
    playthrough: 'Playthrough',
    wageringPeriod: 'Período de Aposta',
    issueBonus: 'Emitir Bônus',
    bonusId: 'ID do Bônus',
    promoName: 'Nome da Promoção',
    promoCode: 'Código Promocional',
    promoCodeType: 'Tipo de Código Promocional',
    lPromoCode: 'código promocional',
    maxUseCount: 'Contagem Máxima de Uso',
    dateUsed: 'Data de Uso',
    promotionEndDate: 'Data de Término da Promoção',
    issuedBy: 'Emitido por',
    canceledBy: 'Cancelado por',
    mobileVerified: 'Celular Verificado',
    identityVerified: 'Identidade Verificada',
    emailVerified: 'E-mail Verificado',
    disconnectedBy: 'Desconectado por',
    disconnectTrigger: 'Desligar Ativador',
    turnoverAmount: 'Valor do faturamento',
    remainingTurnover: 'Turnover Restante',
    bonusStatus: 'Estado do Bônus',
    triggeredDate: 'Data de Ativação',
    providerMayDisabled: 'O fornecedor pode ter sido desativado.',
    gameMayDisabled: 'O jogo pode ter sido desativado.',
    maxCashbackAmount: 'Quantia Máximo de Cashback',
    cashbackId: 'ID do Cashback',
    cashbackName: 'Nome do Cashback',
    cashbackType: 'Tipo do Cashback',
    calculationTime: 'Tempo de Cálculo',
    transferType: 'Tipo de Transferência',
    platforms: 'Plataformas',
    platform: 'Plataforma',
    restrictedPlayers: 'Jogadores com Restrições',
    restrictedCountries: 'Países com Restrições',
    totalBet: 'Aposta Total',
    totalWin: 'Ganho Total',
    accumulated: 'Acumulado',
    accumulatedCashBack: 'CashBack Acumulado',
    transferredCashBack: 'CashBack Transferido',
    commission: 'Comissão',
    commissions: 'Comissões',
    lCommissions: 'Comissões',
    commissionPercent: 'Comissão, %',
    manageLimits: 'Gerir Limites',
    referees: 'Indicados',
    setCommissions: 'Definir Comissões',
    referralBonusId: 'ID do Bônus de Indicação',
    lReferralBonus: 'bônus de indicação',
    referralBonus: 'Bônus de Indicação',
    calculationPeriodTime: 'Período de Tempo do Cálculo',
    commissionFrom: 'Comissão de',
    referrerId: 'ID de Indicação',
    accumulatedCommission: 'Comissão Acumulada',
    nextCalculationDate: 'Data do Próximo Cálculo',
    transferredCommission: 'Comissão Transferida',
    commissioningAmount: 'Valor de Comissionamento',
    convertedTo: 'Convertido para',
    convertedAmount: 'Valor Convertido',
    redeemedAmount: 'Valor Resgatado',
    winAmount: 'Valor do Ganho',
    lossAmount: 'Valor das Perdas',
    cashbackAmount: 'Valor do Cashback',
    includeActiveBonuses: 'Incluir Bônus Ativos',
    lBonus: 'bônus',
    bonus: 'Bônus',
    casino: 'Cassino',
    invalidPlayerCount: 'Contagem de jogadores inválidos no relatório',
    totalPlayersUpdated: 'Total de jogadores que serão atualizados',
    lBonusTemplate: 'modelo de bônus',
    bonusTemplate: 'Modelo de Bônus',
    invalidKeys: 'Keys Inválidas',
    playersMissingCurrencyReason: 'A moeda da conta do jogador não está configurada',
    playersRestrictedReason: 'O jogador tem um estado de conta restrito',
    missingCurrency: 'Moeda em Falta',
    missingCurrencyReason: 'A moeda da conta do jogador não está configurada',
    issue: 'Publicar',
    platformType: 'Tipo de Plataforma',
    amountConfig: 'Configurar Quantia',
    paymentMethods: 'Métodos de Pagamento',
    first: 'Primeiro',
    second: 'Segundo',
    third: 'Terceiro',
    fourth: 'Quarto',
    fifth: 'Quinto',
    fromDepositAmount: '% da Quantia do Depósito',
    fromDeposit: '% do Depósito',
    betType: 'Tipo de Aposta',
    minWageringOdd: 'Odds Mín. de Aposta',
    minWageringOddType: 'Tipo de Odds Mín. de Aposta',
    promoCodeTypes: {
      0: 'Permite preencher manualmente o código promocional',
      1: 'Permite que o sistema gere códigos únicos',
      2: 'Permite adicionar manualmente códigos promocionais externos. O sistema excluirá automaticamente os códigos duplicados e os códigos que não tenham entre 3 e 25 caracteres da lista carregada. A verificação será feita entre todas as campanhas de bônus.',
    },
    bonusTemplateName: 'Nome do Modelo de Bônus',
    bonusTemplateId: 'ID do Modelo de Bônus',
    providers: 'Provedores',
    categories: 'Categorias',
    bonusOptionsDesc: 'Um bônus de inscrição é o somatório de dinheiro pago a um novo jogador',
    bonusOptionsDesc1: 'Jogadores receberão bônus por todos os depósitos durante o período de ativação',
    bonusOptionsDesc2: 'O utilizador pode escolher por quantos depósitos durante o período de ativação os jogadores receberão bônus',
    bonusOptionsDesc3: 'Jogadores receberão bônus pelo primeiro depósito de cada dia durante o período de ativação',
    createNewTemplate: 'Criar um Novo Modelo',
    selectBonusType: 'SELECIONE UM TIPO DE BÓNUS',
    selectBonusTrigger: 'SELECIONE UM ATIVADOR DE BÔNUS',
    numberOfDeposits: 'Número de Depósitos',
    fixedAmount: 'Valor Fixo',
    sport: 'Desporto',
    rules: 'Regras',
    rule: 'Regra',
    noRules: 'Sem Regras para Mostrar',
    relatedBonusId: 'ID do Bônus Relacionado',
    endDateTime: 'Data/Hora de Término',
    noEndDate: 'Sem Data de Término',
    selectGames: 'Selecione Jogos',
    activities: 'Atividades',
    discardAccumulatedCommissions: 'Descartar comissões acumuladas',
    playersInAnotherReferral: 'Jogadores já possuem outro Bônus de Indicação',
    allPlayersSelected: 'Todos os jogadores são selecionados',
    datesAndPlayers: 'Datas e Jogadores',
    special: 'Especial',
    highRisk: 'Alto Risco',
    mediumRisk: 'Risco Médio',
    countOfReferees: 'Contagem de indicados',
    playerFromParticipants: 'jogador dos participantes',
    signUp: 'Inscreva-se',
    bonusNameExternal: 'Nome do Bônus (Externo)',
    noEndData: 'Sem Data de Término',
    minNumberOfSelections: 'Número Mín. de Seleções',
    dateTriggered: 'Data de Ativação',
    referralBonusName: 'Nome do Bônus de Indicação',
    refereesId: 'ID dos Indicados',
    refereeId: 'ID do Indicado',
    realWallet: 'Carteira Real',
    details: 'Detalhes',
    numberOfDepositsInfo: 'Selecione os depósitos para os quais os jogadores precisam receber bônus durante o período de ativação.',
    numberOfDepositsTabIndex: {
      1: 'º',
      2: 'º',
      3: 'º',
      default: 'º',
    },
    cloneUnit: 'Unidade Clone',
    cloneBonus: 'Bónus de Clone',
    cloneSettingsTo: 'Clonar Configurações para',
    balanceConfig: 'Configuração do Saldo',
    usedCount: 'Contagem Usada',
    lRule: 'regra',
    referralParticipants: 'Participantes na indicação',
    theCashback: 'O cashback',
    playersCashBack: 'Cashback dos jogadores',
    theBonus: 'O bônus',
    wageringTurnover: 'Turnover das Apostas',
    playersWontBeAble: 'Os jogadores não poderão levantar ou apostar o valor do bônus emitido em jogos P2P.',
    calculationFrom: 'CÁLCULO DE',
    lCalculationFrom: 'Cálculo de',
    createNewCashback: 'Criar Novo Cashback',
    cashbackFromBetsDesc: 'Fornece cashback sobre a diferença positiva de apostas - ganho no período de cálculo.',
    cashbackNetDepositsDesc: 'Fornece cashback sobre a diferença positiva de depósitos - levantamentos no período de cálculo.',
    netDepositAmount: 'Valor Líquido de Depósitos',
    participateRule: 'Regra de Participação',
    totalDeposit: 'Total de Depósito',
    totalWithdrawal: 'Total de Levantamento',
    totalBonuses: 'Total de Bônus',
    manageParticipation: 'Gerir Participação',
    restrictionFor: 'Restrito para',
    availableFor: 'Disponível para',
    sportWageringBonuses: 'Bônus de Apostas Desportivas',
    casinoWageringBonuses: 'Bônus de Apostas de Cassino',
    otherBonuses: 'Outros Bônus',
    finishedBonusesCount: 'Contagem de Bônus Finalizados',
    totalRedeemBonuses: 'Total de Bônus de Resgate',
    referralCommission: 'Comissão de Indicação',
    maxPossibleTransfer: 'Transferência Máx. Possível',
    playThroughRequired: 'Playthrough Necessário',
    matchingRegistrationIP: 'O indicador tem indicados com os mesmos IPs de registo',
    sameRegistrationIP: 'Indicador e indicado tem o mesmo IP de registo',
    amountColumnInfo: 'O intervalo inclui o valor da coluna esquerda, até, mas não incluindo, o valor da coluna direita',
    expirationPeriod: 'Período de vencimento',
    lengthOfCodes: 'Comprimento dos Códigos',
    minDepositAmount: 'Quantia Mín. do Depósito',
    selectedGames: 'Jogos Selecionados',
    minAmount: 'Valor Mín.',
    step: 'Passo',
    gamesInfo: 'O fornecedor permite que selecione jogos de {{type}}',
    lSingle: 'simples',
    lMultiple: 'múltiplos',
    allowWithdrawal: 'Permitir Levantamento',
    campaignName: 'Nome da Campanha',
    noTrigger: 'Sem Ativador',
    cancelBonusWhenWithdrawal: 'Cancelar Bônus (Quando feito um Levantamento)',
    number: 'Número',
    participant: 'Participante',
    depositsAmountConfigInfo: 'Nesta área, configuramos o Valor do Bônus e estabelecemos limites por moeda',
    bonusBetConfig: 'Configuração da Aposta de Bônus',
    single: 'Simples',
    ranges: 'Intervalos',
    nextValue: 'Valor seguinte',
    lPrevValue: 'valor anterior',
    addRanges: 'Adicionar Intervalos',
    lifetimePeriod: 'Período Vitalício',
    resetRanges: 'Repor Intervalos',
    lCampaign: 'campanha',
    multi: 'Múltiplos',
    option: 'Opção',
    triggers: 'Ativadores',
    viewRanges: 'Ver Intervalos',
    depositNumber: 'Número do Depósito',
    bonusResultAreaDesc: 'Pode ver os Bônus após adicioná-los e configurá-los na área lateral.',
    participantsResultAreaDesc: 'Pode ver os Participantes após adicioná-los e configurá-los na área lateral.',
    editTriggerDisabled: 'Pode editar o ativador agora',
    multiOrSingleBonus: 'Descrição de bônus múltiplos e simples',
    editParticipantsDisabled: 'Pode editar os participantes agora mesmo',
    configureParticipants: 'Configurar participantes',
    selectTriggerParticipantsBonuses: 'Selecione o Ativador, Escolha os Participantes, Configure os Bônus',
    toMakeSureCampaignSuccessful: 'Para garantir que a sua campanha é bem-sucedida',
    participantType: 'Tipo de Participante',
    triggerType: 'Tipo de Ativador',
    cancelPromotion: 'Cancelar Promoção',
    createCampaign: 'Criar Campanha',
    multiOrSinglePromocodeType: 'Descrição do tipo de código promocional múltiplo e simples',
    missingAmount: 'Valor em Falta',
    multiSelectionNum: 'Núm. de Seleção Múltipla',
    playThroughRequiredDesc: 'Se esta opção estiver activada, o valor do campo “Playthrough” deve ser igual ao número definido; se estiver desactivada, deve ser igual ou superior a',
    playThroughInputDesc:
      'Permite definir se um jogador tem de apostar o bônus tantas vezes quantas as estabelecidas na configuração do playthrough para poder finalizar o bônus (além de 0 no turnover).',
    cancelBonusWhenWithdrawalDesc: 'Permite cancelar o bônus automaticamente caso o jogador faça um levantamento durante o período de ativação e expiração do bônus',
    triggerOption: 'Opção do Ativador',
    campaign: 'Campanha',
    periodDescription: 'Aqui, podemos definir em que período definir o número do depósito',
    singleCountTypeDesc:
      'Permite definir apenas um bônus, mas com valores diferentes para cada número de depósito, utilizável em casos em que não necessitamos de configurar vários bônus com o mesmo tipo de bônus',
    multiCountTypeDesc:
      'Permite definir tipos diferentes de bônus com configurações de valores diferentes para cada número de depósito. Neste caso, escolhemos o número de depósito (valores possíveis 1, ..., 100) para cada tipo de bônus',
    disconnectTriggerDesc:
      'Se esta funcionalidade estiver ativa e o jogador tiver recebido, pelo menos, um bônus, mas não satisfazer as condições associadas ao bônus, então o sistema desconectá-lo-á da campanha, e o jogador já não receberá novos bônus',
    participantsPlayerDesc: 'Permite incluir jogadores manualmente ou ao carregar um ficheiro CSV',
    participantsPlayerListAmountsDesc: 'Permite incluir jogadores com valores individuais de bônus ao carregar a lista de jogadores',
    participantsPromoCodeDesc: 'Permite incluir jogadores ao utilizar um código promocional gerado',
    countryConditionDesc: 'Verifica o país dos jogadores',
    verifyConditionDesc: 'Verifica o nível de verificação dos jogadores',
    weekDaysConditionDesc: 'Verifica os jogadores em dias específicos',
    accountStatusConditionDesc: 'Verifica o estado da conta dos jogadores',
    sportStatusConditionDesc: 'Verifica o estado dos jogadores no Sportsbook',
    segmentConditionDesc: 'Verifica os segmentos que os jogadores integram',
    tagConditionDesc: 'Verifica as tags que os jogadores têm',
    paymentsConditionDesc: 'Verifica os pagamentos das transações dos jogadores',
    configModeAlreadyOpened: 'Já abriu o modo de configuração',
    bonusBetConfigInfo: 'Permite configurar as apostas de bônus. A aposta deverá corresponder aos critérios guardados para ser considerada uma aposta de bônus',
    amountConfigSingleDesc: 'Permitir definir a configuração relativa aos valores únicos por moeda.',
    amountConfigRangesDesc: 'Permitir definir a configuração relativa aos multi-intervalos de valores para cada moeda',
    depositAmountConfigFixedAmountDesc:
      'Permite fornecer um valor de bônus que é fixo para cada moeda (Por moeda). No caso de um Valor Fixo, podemos configurar as condições de Depósito utilizando as opções Único ou Intervalo',
    amountConfigFromDepositDesc: 'Permite contabilizar o valor de bônus como uma percentagem do depósito (geral para todas as moedas)',
    noDataAlt: 'Sem Ativador, Participantes, Bônus selecionados',
    successPlayers: 'Os jogadores podem receber bônus',
    errorPlayers: 'Moeda em Falta',
    amountConfigAreaInfo: 'Nesta área, configuramos o Valor do Bônus e estabelecemos limites por moeda',
    availableCount: 'Contagem Disponível',
    availablePromoCodes: 'Códigos Promocionais Disponíveis',
    downloadAvailableCodes: 'Descarregar os Códigos Disponíveis',
    lNextValue: 'valor seguinte',
    participantsAllPlayersDesc: 'Permite incluir todos os jogadores como participantes quando o ativador é executado',
    participantsAllPlayersMainAreaDesc: 'O sistema incluirá todos os jogadores como participantes após a execução do ativador.',
    freeSpinAmountConfigInfo: 'Selecione o provedor e o número de linhas para obter restrições de quantidade',
    freeSpinRequiredAllGames: 'Este provedor suporta spins grátis em todos os jogos',
    maxWinAmount: 'Valor Máximo de Ganhos',
    line: 'Linha',
    casinoBonus: 'Bônus de cassino',
    campaignStatus: 'Estado da campanha',
    spinsAmount: 'Quantidade de Spins',
    maxTriggerCount: 'Número Máximo de Disparos',
    maxTriggerCountInfo: 'Este campo permitirá definir o número máximo de disparos bem-sucedidos por jogador',
    freeSpinCurrencyInfo: 'O sistema inclui moedas suportadas por marca e provedor escolhido',
    amountRanges: 'Intervalo de valor (de - até)',
    amountRangesHint: "O valor no campo 'De' do 'Intervalo de valor' está incluído nesse intervalo, enquanto o valor no campo 'Até' não está incluído no intervalo.",
    numberOfPlayers: 'Número de jogadores (de - até)',
    numberOfPlayersHint: "O número no campo 'De' do 'Número de jogadores' está incluído nesse intervalo, enquanto o número no campo 'Até' não está incluído no intervalo.",
    numberOfReferees: 'Número de árbitros (de - até)',
    numberOfRefereesHint: "O número no campo 'De' do 'Número de árbitros' está incluído nesse intervalo, enquanto o número no campo 'Até' não está incluído no intervalo.",
    campaignStatistics: 'Estatísticas da campanha',
    maxLimitAmount: 'Limite máximo',
    netDepositAmountHint: "O número no campo 'De' do 'Valor líquido de depósitos' está incluído nesse intervalo, enquanto o número no campo 'Até' não está incluído no intervalo.",
    gameSegmentInfo: 'As alterações no segmento do jogo não afetarão as entidades já criadas',
    lCashbackAmounts: 'Quantias de cashback',
    usedPromoCodes: 'Códigos promocionais usados',
    createCrossPlatformCampaign: 'Criar uma campanha multiplataforma',
    amountConfigAreaCrossCampaignInfo: 'Nesta área, definimos limitações por moeda',
    selectAndConfigureBonuses: 'Selecione e configure bônus',
    cashbackStatistics: 'Estatísticas de cashback',
    freeSpinAmountConfigInfoForSingle: 'Selecione provedor, contagem de linhas e jogo para obter restrições de quantidade',
    minMaxProviderLimit: 'Limite mínimo-máximo do provedor',
    spinTotalAmount: 'Valor total de spins',
    minMaxProviderLimitInfo: 'O valor total de spins gerado a partir da contagem de spins multiplicado pelo valor dos spins deve estar entre os limites mencionados',
    maxWageringOddType: 'Tipo de Odd de Aposta Máxima',
    maxWageringOdd: 'Odds Máxima de Aposta',
    wageringOdd: 'Odds de Aposta',
    winAmountTransferTo: 'Transferência do valor do prêmio para',
    allowCashout: 'Permitir Cashout',
    allowCashoutInfo: 'Permite que os jogadores usem as funcionalidades de levantamento/levantamento parcial para este bônus',
    sidebarBonusesDescription: 'Aqui podemos escolher os tipos de bônus Esportivo, Giros, Cassino e Especial disponíveis e adicionar à campanha',
    bonusAbuse: 'Abuso de Bônus',
    bonusAbuseInfo: {
      0: 'Após ativar esta caixa de seleção, os jogadores não poderão fazer uma aposta do Saldo de Bônus no mesmo evento mais de uma vez',
      1: 'Após ativar esta caixa de seleção, os jogadores não poderão fazer uma aposta do Saldo de Bônus no mesmo evento mais de uma vez',
      2: 'Após ativar esta caixa de seleção, os jogadores não poderão apostar com o Saldo de Bônus no mesmo evento mais de uma vez. No caso do Bônus de Aposta Real, se o jogador apostar com o Saldo Real mais de uma vez no mesmo evento que atenda aos requisitos do bônus, a segunda aposta não deverá reduzir o volume de apostas.',
    },
    oneTimeBet: 'Aposta Única',
    oneTimeBetInfo: 'Exige que os jogadores utilizem o bônus na totalidade',
    minBetAmountPerCategory: 'Valor Mín. de Aposta por categoria',
    periodDescriptionEvery: 'Aqui podemos definir em que período definir a contagem máxima de disparos, se não for configurado o sistema não limitará o trabalho de disparo para um jogador',
    totalBets: 'Total de Apostas',
    totalWins: 'Total de Ganhos',
    subMethod: 'Submétodo',
    paymentConditionPropertiesInfo: 'O menu “Submétodos” só é visível para os métodos de pagamento para os quais a lista de submétodos é fornecida pelo agregador.',
    verificationTriggerInfo: 'A condição funcionará se todas as opções seleccionadas forem verificadas, a verificação do campo de ativação também está incluída',
    promoCodesUploadFormatMsg: 'Você pode enviar códigos promocionais. Apenas o formato CSV é aceito',
    amountConfigDepositSingleDesc: 'Permite configurar % simples por moeda',
    amountConfigDepositRangesDesc: 'Permite configurar interválos múltiplos de % para cada moeda',
    canceller: 'Cancelador',
    awardedBonusesDetails: 'Detalhes dos Bônus Concedidos',
    bonusLowestAmount: 'Valores de Bônus Mais Baixo',
    bonusHighestAmount: 'Valores de Bônus Mais Altos',
    totalBonusAmount: 'Valor Total de Bônus',
    checkTheListOfRecipients: 'Verifique a lista final de recipientes',
    allGames: 'Todos os Jogos',
    allGamesDesc: 'Permite definir sorteio de bônus na marca de todos os jogos, todas as alterações nas marcas de jogos serão consideradas',
    selectGamesDesc: 'Permite definir sorteio de bônus em provedores e jogos específicos',
    contribution: 'Contribuição, %',
    addPlayersNote: 'Só é possível adicionar novos participantes. Caso contrário, serão automaticamente excluídos da lista de participantes',
    campaignParticipants: 'Campanha de participantes',
    autoActivation: 'Autoativação',
    autoActivationDesc:
      'Permite atribuir ao jogador o bônus já ativado. Recomenda-se a configuração de um bônus de cada tipo de bônus (Casino, Desporto, Free Spin) em caso de utilização da auto-ativação. Caso contrário, os bônus serão activados aleatoriamente',
    promoCodeCaseSensitiveInfo:
      'Permite configurar o código promocional para os jogadores. Os códigos não são sensível à caixa das letras para os jogadores e serão convertidos para o formato maiúsculo',
    supportPlayerCancellationGamesInfo: 'Provedor permite selecionar jogos {{type}} e não permite cancelar o bônus após ativação ',
    referralStatistics: 'Estatísticas de Indicação',
    campaignWillBeSavedInBgInfo: 'À medida que os dados da campanha aumentam, são guardados em modo de fundo e ficam disponíveis na lista de campanhas.',
    contentAndNotification: 'Conteúdo e Notificação',
    contentAndNotificationConfigsRemovedDesc: 'Todas as configurações de conteúdo e notificação de bônus foram removidas, após guardar perderá todas as configurações anteriores.',
    cloneContentFrom: 'Clonar o conteúdo do bônus <0>{{bonusName}}</0> para',
    contentLanguages: 'Idiomas do conteúdo',
    notificationInfo:
      'Nesta área, configuramos uma notificação para os jogadores sobre a atribuição de bônus. Se não for selecionado nenhum modelo, os jogadores não serão notificados através dos canais de comunicação da marca.',
    contentInfo:
      'Nesta área, configuramos imagens e conteúdos relacionados com bônus nos idiomas da marca, que serão visíveis para os jogadores. Se o conteúdo não estiver configurado, o sistema utilizará o conteúdo predefinido.',
    editContent: 'Editar conteúdo',
    bonusStatistics: 'Estatísticas de bônus',
    sportBonus: 'Bônus esportivo',
    manageContentAndNotification: 'Gerir conteúdos e notificações',
    minCashbackAmount: 'Valor mínimo de cashback',
    triggerDeviceTypeDesc: 'Verifica o tipo de dispositivo do ativador',
    signUpDeviceTypeDesc: 'Verifica o tipo de dispositivo através do qual o jogador foi registado',
    viewContentAndNotifications: 'Ver Conteúdo e Notificações',
    winType: 'Tipo de vitória',
    winOptions: 'Tipo de Valor do Prémio',
    realMoney: 'Dinheiro real',
    availableBonus: 'Bônus disponível',
    wageringBonus: 'Bônus de Aposta',
    pauseBonus: 'Bônus de Pausa',
    pauseBonusDesc: 'Ao ativar a opção, o jogador poderá fazer uma pausa no bônus recebido e retomá-lo mais tarde',
    pausedDate: 'Data de pausa',
    resumedDate: 'Data de retomada',
    sidebarParticipantsDescription: 'Aqui, podemos escolher as condições de seleção dos participantes da campanha: Lista de jogadores, Lista de jogadores – Valores, Código Promocional, Condições',
    contentAndNotificationSidebarNoBonuses: {
      text1: '',
      text2: 'A área de conteúdo e notificação ficará ativa depois de configurar e guardar os bónus',
    },
    sidebarTriggerDescription: 'Aqui, podemos definir as configurações de ativação da campanha: Sem Ativador, Depósito, Registo, Verificar',
    contentAndNotificationSidebarDesc: 'Aqui podemos escolher os bônus configurados e adicionar conteúdo e notificação específicos do bônus',
    contentAndNotificationResultAreaDesc: 'Pode ver o conteúdo e a notificação dos bônus depois de os adicionar e configurar a partir da área lateral.',
    configAlreadySaved: 'Já configurou os bônus ou participantes. Remova-os para poder editar',
    bonusOptionsDesc4: 'Os jogadores receberão bônus pelo total de apostas feitas em um período de tempo específico',
    participantsJoinDesc: "Permite incluir jogadores como participantes através da ação 'Participar' no site",
    campaignContent: 'Conteúdo da campanha',
    bonusContent: 'Conteúdo bônus',
    campaignContentTabInfo:
      'Nesta área, configuramos imagens e conteúdo relacionado à campanha nos idiomas da marca, que serão visíveis aos jogadores. É necessário configurar o conteúdo com o idioma principal da marca.',
    signInDate: 'Data de acesso',
    remainingBonusAmount: 'Valor restante do bônus',
    triggerConditionsResultAreaDesc: 'Você pode ver a Condição de Ativação depois de adicioná-la e configurá-la na área lateral.',
    triggerConditions: 'Condições de Ativação',
    websiteImage: 'Imagem do Website',
    sidebarTriggerConditionDescription: 'Aqui podemos escolher as condições específicas para ativar a campanha',
    mobileImage: 'Imagem para Dispositivos Móveis',
    specificTimePeriod: 'Período de tempo específico',
    weekDays: 'Dias da semana',
    monthlyDatesConditionDesc: 'Verifica os jogadores em uma data específica',
    dates: 'Datas',
    monthlyDates: 'Datas mensais',
    sourceId: 'ID da fonte',
    sourceName: 'Nome da fonte',
    participationGroupsNote: 'Você pode ver os Grupos de Participação depois de adicioná-los e configurá-los na área lateral.',
    participationGroupsDesc: 'Você pode ver as Condições de Participação depois de adicioná-las e configurá-las na área lateral.',
    lParticipationGroups: 'grupos de participação',
    playerListDesc: 'Permite incluir jogadores enviando CSV ou manualmente',
    playerListAmountDesc: 'Permite incluir jogadores com valores de bônus individuais, enviando a lista de jogadores',
    allPlayersDesc: 'Permite incluir todos os jogadores como participantes quando o gatilho é executado',
    promoCodeDesc: 'Permite incluir jogadores usando código promocional gerado',
    additionalConditions: 'Condições adicionais',
    participationGroups: 'Grupos de Participação',
    participationGroup: 'Grupo de Participação',
    lParticipationGroup: 'grupo de participação',
    playersAreParticipants: 'Os jogadores são incluídos como participantes',
    bonusesDesc: 'Você pode ver os Bônus depois de adicioná-los e configurá-los na área lateral.',
    gameConfig: 'Configuração do jogo',
    recurringConditionDesc: 'Verifica os gatilhos dos jogadores em dias específicos ou datas mensais',
    conditionTypes: 'Tipos de condição',
    lTriggerCondition: 'condição de ativação',
    bonusAbuseInfoNote: 'Após ativar esta caixa de seleção, os jogadores não poderão fazer uma aposta do Saldo de Bônus no mesmo evento mais de uma vez',
    productSelection: 'Seleção de produtos',
    casinoGameConfig: 'Configuração de jogos de cassino',
    contents: 'Conteúdo',
    lCampaignContent: 'conteúdo da campanha',
    lBonusContent: 'conteúdo de bônus',
    units: 'Unidades',
    unitsNote: 'sd',
    triggerCondition: 'Condição de ativação',
    wageringLogic: 'Lógica de Apostas',
    wageringBaseAmount: 'Valor base da aposta',
    wageringCoefficient: 'Coeficiente de Aposta',
    wageringCount: 'Contagem de Apostas',
    calculationLogic: 'Lógica de Cálculo',
    wageringParticipation: 'Participação em Apostas',
    firstWalletDebited: '1ª Carteira Debitada',
    lockAmount: 'Valor bloqueado',
    allowNonMatchingBets: 'Permitir apostas não correspondentes',
    triggerBasedConfig: 'Configuração baseada em gatilho',
    lUnit: 'unidade',
    unitsDesc: 'Você pode ver as Unidades depois de adicioná-las e configurá-las na área lateral.',
    navigationItemsDisabledInfo: 'Os itens de navegação ficarão ativos após salvar a seção Geral da Campanha.',
    sidebarTriggerConditionInfo: 'Você pode ver as Condições de Ativação após adicioná-las e configurá-las na área lateral',
    summary: 'Resumo',
    offers: 'Ofertas',
    offersContentTabInfo:
      'Nesta área, configuramos imagens e conteúdo relacionado à campanha nos idiomas da marca, que serão visíveis aos jogadores. É necessário configurar o conteúdo com o idioma principal da marca.',
    sidebarUnitInfo: 'Você pode ver as Unidades depois de adicioná-las e configurá-las na área lateral',
    lContent: 'conteúdo',
    offersContent: 'Conteúdo de Unidades (Ofertas)',
    lOfferContent: 'conteúdo de oferta',
    unit: 'Unidade',
    totalOdds: 'Odds Total',
    minTotalOdd: 'Odds total mín.',
    maxTotalOdd: 'Odds total máx.',
    sportEventConfig: 'Configuração de evento esportivo',
    lockType: 'Tipo de Bloqueio',
    gamesConditionDesc: 'Verifica os jogos lançados para o gatilho',
    transactionAmount: 'Valor da Transação',
    unitName: 'Nome da Unidade',
    productType: 'Tipo de Produto',
    isUsedInUnit: 'Usado em unidade',
    minBetTriggerAmount: 'Valor mínimo de ativação da aposta',
    bonusAmount: 'Valor do bônus',
    point: 'Ponto',
    contributedFrom: 'Contribuído desde',
    contributedFromDescription: 'Aqui podemos definir quais apostas devem participar do volume acumulado de apostas.',
    sportBetsConditionDesc: 'Verifica as apostas dos jogadores em eventos esportivos específicos',
    casinoBetsConditionDesc: 'Verifica as apostas dos jogadores em jogos de cassino específicos',
    betAmountConfigFixedAmountDesc:
      'Permite fornecer um valor de bônus fixo para cada moeda (Por moeda). No caso de um Valor Fixo, podemos configurar as condições de Aposta usando as opções Única ou Intervalo.',
    amountConfigFromBetDesc: 'Permite contabilizar o valor do bônus como uma porcentagem da aposta (geral para todas as moedas)',
    fromBet: '% da aposta',
    bonusOptionsDesc5: 'Os jogadores receberão bônus para todas as apostas no período de ativação',
    gameInfo: 'Tipo(s) de suporte de jogo selecionado(s): <0>{{type}}</0>',
    freeGameType: 'Tipo de jogo grátis',
    combinations: 'Combinações',
    involvement: 'Envolvimento',
    sports: 'Esportes',
    tournaments: 'Torneios',
    events: 'Eventos',
    markets: 'Mercados',
    allEventsAreSelected: 'Todos os eventos estão selecionados',
    allMarketsAreSelected: 'Todos os mercados estão selecionados',
    customSelection: 'Seleção personalizada',
    live: 'Ao vivo',
    lEvents: 'eventos',
    lMarkets: 'mercados',
    lMarket: 'mercao',
    lEvent: 'evento',
    lTournaments: 'torneios',
    entitiesLimitInfo: 'A contagem máxima de entidades (torneios, eventos, mercados) é {{count}}. A seleção é contabilizada em caso de seleção personalizada.',
    fromBetAmount: '% do valor de aposa',
    gamesCount: 'Quantidade de jogos',
    freeSpinGamesInfo: 'Selecione o provedor para obter jogos',
    previousUnit: 'Unidade anterior',
    previousUnitInfo: 'A unidade atual será alocada assim que o bônus da unidade selecionada terminar. Isso se aplica apenas a unidades dentro do mesmo grupo de participantes.',
    eventType: 'Tipo de Evento',
    complainer: 'Reclamante',
    hashtagDescription: 'Descrição da hashtag',
    lPlayerBonus: 'bônus de jogador',
    lPlayersBonuses: 'bônus para jogadores',
    playerBonus: 'Bônus do jogador',
    playersBonuses: 'Bônus para jogadores',
    eligibleBets: 'Apostas elegíveis',
    eligibleBetsStatus: 'Status de apostas elegíveis',
    betBuilder: 'Bet Builder',
    betBuilderTotalOdds: 'Odds totais do Bet Builder',
    betBuilderMultiSelectionNum: 'Número de seleção múltipla de Bet Bulder',
    minBetBuilderTotalOdd: 'Odds mín. total de Bet Builder',
    maxBetBuilderTotalOdd: 'Odds máx. total de Bet Builder',
    lUnitBonuses: 'bônus de unidade',
    partialCancel: 'Cancelamento parcial',
    addPlayers: 'Adicionar jogadores',
    pointEnhancement: 'Aprimoramento de pontos',
    pointEnhancementInfo: 'Ative a opção para definir um número necessário de apostas para ganhar cada bônus de ponto.',
    betCount: 'Contagem de apostas',
    bonusOptionsDesc6: 'Os jogadores receberão bônus por cumprir os requisitos mínimos de aposta e contagem dentro de um único ponto e um período de tempo definido.',
    lobbyWidgetGameSegmentInfo: 'As alterações no segmento do jogo não afetarão a entidade já criada. Somente os jogos que forem comuns ao segmento e lobby selecionados aparecerão na lista.',
    wageringParticipationInfo: 'As apostas do tipo Cashout não serão incluídas no cálculo do turnover.',
    code: 'Código',
    dynamicDesc: 'Permite a geração de comissões com base em indicadores financeiros, seja por árbitro individual ou coletivamente, a partir de todos os árbitros.',
    progressiveDesc: 'Permite definir intervalos de comissão específicos com base no número de jogadores indicados.',
    prizeDesc: 'Permite definir intervalos de comissão para conceder uma recompensa fixa única aos jogadores recém-indicados que cumprirem as condições necessárias.',
    supportPlayerCancellationGameInfo1: 'O provedor permite o cancelamento por parte do jogador.',
    supportPlayerCancellationGameInfo2: 'O provedor não permite o cancelamento por parte do jogador.',
    bonusContentDesc: 'Você pode ver o {{type}} dos bônus depois de adicioná-los e configurá-los na área lateral.',
    noUnitWithEmptyContentForLanguage: 'Não existe nenhuma unidade com conteúdo vazio neste idioma.',
    noBonusWithEmptyContent: 'Não há bônus com conteúdo vazio.',
    currentStage: 'Etapa atual',
    inProcess: 'Em andamento',
    placedBetAmount: 'Valor da aposta realizada',
    totalBetCount: 'Total de apostas',
    placedBetCount: 'Número de apostas realizadas',
    periodDate: 'Data do período',
    grantBonus: 'Conceder bônus',
    bonusWillBeGrantedAfterWageringCompleted: 'O bônus selecionado será concedido após a conclusão dos requisitos de aposta do bônus atual.',
    infoMaxRedeemAmount: 'Valor máximo de resgate: {{value}}',
    infoSpinsAmount: 'Quantidade de giros: {{value}}',
    infoCombinationValues: 'Valores de combinação: {{value}}',
    participationType: 'Tipo de participação',
    resetToDefault: 'Redefinir para o padrão',
    amountRange: 'Intervalo de valores',
    considerAsBTag: 'Considerar como BTAG',
    considerAsBTagInfo: 'Esta opção substituirá o campo btag se o código promocional corresponder ao inserido pelo jogador.',
    byPlayerID: 'Por ID do jogador',
    byTags: 'Por etiquetas',
    bySegments: 'Por segmentos',
    dynamicSelection: 'Seleção dinâmica',
    staticSelection: 'Seleção estática',
    deleted: 'Excluido',
    onJoinUnitInfo: 'Especifica se esta configuração usa suas próprias configurações de entrada ou não.',
    riskyGameExclusionInfo: 'As alterações nos riscos do jogo não afetarão as entidades já criadas.',
    conditionsInfo: 'Apenas jogadores recém-indicados são elegíveis. Cada jogador indicado deve cumprir todas as condições selecionadas para gerar uma comissão para quem o indicou.',
    minWithdrawalAmount: 'Valor mínimo de saque',
    withdrawalAmountConfigFixedAmountDesc: 'Permite fornecer um valor de bônus fixo para cada moeda (por moeda). No caso de um valor fixo, podemos configurar as condições de saque usando as opções "Único" ou "Intervalo".',
    fromWithdrawal: '% do saque',
    amountConfigFromWithdrawalDesc: 'Permite calcular o valor do bônus como uma porcentagem do saque (Geral para todas as moedas)',
    fromWithdrawalAmount: '% do valor do saque',
    sourceTypes: 'Tipos de origem',
    unitsAllocation: 'Alocação de unidades',
    unitsAllocationInfo: 'Selecione "Um gatilho - Todas as unidades" se quiser que o jogador receba todas as unidades criadas com um único gatilho. Certifique-se de definir as condições para cada unidade de forma semelhante, para que todas sejam alocadas ao mesmo tempo, passando em todas as verificações.',
  },
  zh: {
    maxBonusAmount: '最高奖金数额',
    minBonusAmount: '最低存款金额',
    maxRedeemAmount: '最大赎回金额',
    minBetAmount: '最低投注金额',
    contributionPercent: '贡献，%',
    cashbackPercent: '现金返还，%',
    bonusType: '奖金类型',
    currencies: '货币',
    triggerPeriod: '触发期间',
    activationPeriod: '激活期限',
    playthrough: '游戏周目',
    wageringPeriod: '投注期间',
    issueBonus: '发放奖金',
    bonusId: '奖金ID',
    promoName: '促销名称',
    promoCode: '促销代码',
    promoCodeType: '促销代码类型',
    lPromoCode: '促销代码',
    maxUseCount: '最高使用次数',
    dateUsed: '使用的日期',
    promotionEndDate: '促销结束日期',
    issuedBy: '发布单位',
    canceledBy: '取消者',
    mobileVerified: '手机被验证了',
    identityVerified: '身份被验证了',
    emailVerified: '电子邮件被验证了',
    disconnectedBy: '谁断开了连接',
    disconnectTrigger: '断开触发器',
    turnoverAmount: '成交金额',
    remainingTurnover: '剩余的营业额',
    bonusStatus: '奖金状态',
    triggeredDate: '触发的日期',
    providerMayDisabled: '供应商可能已被禁用。',
    gameMayDisabled: '游戏可能已被禁用。',
    maxCashbackAmount: '最高返现金额',
    cashbackId: '现金返还ID',
    cashbackName: '现金返还名称',
    cashbackType: '现金返还类型',
    calculationTime: '计算时间',
    transferType: '转账类型',
    platforms: '平台',
    platform: '平台',
    restrictedPlayers: '受限制的玩家',
    restrictedCountries: '受限制的国家',
    totalBet: '总赌注',
    totalWin: '总胜利',
    accumulated: '累计的',
    accumulatedCashBack: '累计现金返还',
    transferredCashBack: '已转账的现金返还',
    commission: '佣金',
    commissions: '佣金',
    lCommissions: '佣金',
    commissionPercent: '佣金，%',
    manageLimits: '限制管理',
    referees: '推荐人',
    setCommissions: '设定的佣金',
    referralBonusId: '推荐奖金ID',
    lReferralBonus: '推荐奖金',
    referralBonus: '推荐奖金',
    calculationPeriodTime: '计算周期时间',
    commissionFrom: '佣金来自',
    referrerId: '推荐人ID',
    accumulatedCommission: '累计佣金',
    nextCalculationDate: '下一计算计算日期',
    transferredCommission: '转账的佣金',
    commissioningAmount: '委托金额',
    convertedTo: '转换至',
    convertedAmount: '转换金额',
    redeemedAmount: '赎回金额',
    winAmount: '胜利金额',
    lossAmount: '损失金额',
    cashbackAmount: '返现总额',
    includeActiveBonuses: '包含活跃奖金',
    lBonus: '奖金',
    bonus: '奖金',
    casino: '娱乐场',
    invalidPlayerCount: '报告中的玩家计数无效',
    totalPlayersUpdated: '将被更新的玩家总数',
    lBonusTemplate: '奖金模板',
    bonusTemplate: '奖金模板',
    invalidKeys: '无效密钥',
    playersMissingCurrencyReason: '玩家的账户货币没有配置好',
    playersRestrictedReason: '该玩家已限制账户状态',
    missingCurrency: '找不到货币',
    missingCurrencyReason: '玩家的账户货币没有配置好',
    issue: '发行',
    platformType: '平台类型',
    amountConfig: '金额配置',
    paymentMethods: '付款方式',
    first: '第一',
    second: '第二',
    third: '第三',
    fourth: '第四',
    fifth: '第五',
    fromDepositAmount: '存款金额的%',
    fromDeposit: '存款的%',
    betType: '投注类型',
    minWageringOdd: '最低投注赔率',
    minWageringOddType: '最小投注赔率类型',
    bonusTemplateName: '奖金模板名称',
    bonusTemplateId: '奖金模板ID',
    providers: '供应商',
    categories: '类别',
    bonusOptionsDesc: '注册奖金是支付给新玩家的一笔钱',
    bonusOptionsDesc1: '玩家在触发期内的所有存款都将获得奖金',
    bonusOptionsDesc2: '用户可以选择在触发期的存款金额数，以获得奖金',
    bonusOptionsDesc3: '玩家将获得触发期内每天第一次存款的奖金',
    createNewTemplate: '创建新模板',
    selectBonusType: '选择奖金类型',
    selectBonusTrigger: '选择奖金触发器',
    numberOfDeposits: '存款数量',
    fixedAmount: '固定金额',
    sport: '体育项目',
    rules: '规则',
    rule: '规则',
    noRules: '无可展示规则',
    relatedBonusId: '相关奖金ID',
    endDateTime: '结束日期/时间',
    noEndDate: '无结束日期',
    selectGames: '选择游戏',
    activities: '活动',
    discardAccumulatedCommissions: '放弃累计的佣金',
    playersInAnotherReferral: '已经在另一个推荐奖金中的玩家',
    allPlayersSelected: '全部玩家被选中',
    datesAndPlayers: '日期和玩家',
    special: '特殊',
    highRisk: '高风险',
    mediumRisk: '中度风险',
    countOfReferees: '推荐人数量',
    playerFromParticipants: '参与者中的球员',
    signUp: '注册',
    bonusNameExternal: '奖金名称（外部）',
    noEndData: '无结束日期',
    minNumberOfSelections: '最低选择数量',
    dateTriggered: '触发日期',
    referralBonusName: '推荐奖金名称',
    refereesId: '推荐人ID',
    refereeId: '推荐人ID',
    realWallet: '真实钱包',
    details: '详情',
    numberOfDepositsInfo: '选择玩家在触发期内必须获得奖金的存款。',
    numberOfDepositsTabIndex: {
      1: '存款数量 TabIndex__1',
      2: '存款数量 TabIndex__2',
      3: '存款数量 TabIndex__3',
      default: '第存款数量 TabIndex__默认',
    },
    cloneUnit: '克隆单位',
    cloneBonus: '克隆奖金',
    cloneSettingsTo: '复制设置至',
    balanceConfig: '余额配置',
    usedCount: '已使用次数',
    lRule: '规则',
    referralParticipants: '推荐的参与者',
    theCashback: '现金返还',
    playersCashBack: '玩家现金返还',
    theBonus: '奖金',
    wageringTurnover: '赌注营业额',
    playersWontBeAble: '玩家将不能提取或投注P2P游戏所发放的奖金数额。',
    calculationFrom: '计算来自',
    lCalculationFrom: '计算来自',
    createNewCashback: '创建新的现金返还',
    cashbackFromBetsDesc: '在计算期内对投注—获胜情况下的正数差额提供现金返还。',
    cashbackNetDepositsDesc: '在计算期内对存款—取款的正数差额提供现金返还。',
    netDepositAmount: '净存款金额',
    participateRule: '参加规则',
    totalDeposit: '总存款',
    totalWithdrawal: '总取款',
    totalBonuses: '奖金总额',
    manageParticipation: '管理参与',
    restrictionFor: '受到限制',
    availableFor: '可用于',
    sportWageringBonuses: '体育投注奖金',
    casinoWageringBonuses: '娱乐场投注奖金',
    otherBonuses: '其他奖金',
    finishedBonusesCount: '已完成奖金计数',
    totalRedeemBonuses: '赎回总奖金',
    referralCommission: '推荐人佣金',
    maxPossibleTransfer: '最大潜在转账',
    playThroughRequired: ' 需进行游戏周目',
    matchingRegistrationIP: '推荐人有被推荐人与之匹配的注册IP',
    sameRegistrationIP: '推荐人和被推荐人有相同的注册IP',
    amountColumnInfo: '该范围包括左列值，一直到但不包括右列值',
    expirationPeriod: '有效期',
    lengthOfCodes: '代码长度',
    minDepositAmount: '最低存款金额',
    selectedGames: '选的游戏',
    minAmount: '最低金额',
    step: '步',
    gamesInfo: '供应商允许选择{{type}}游戏',
    lSingle: '单',
    lMultiple: '多重',
    allowWithdrawal: '允许提取',
    campaignName: '广告系列名称',
    noTrigger: '没有触发',
    cancelBonusWhenWithdrawal: '取款时取消奖金',
    number: '数量',
    participant: '参与者',
    depositsAmountConfigInfo: '在这个区域可以配置奖金数额并设置每种货币的限制。',
    bonusBetConfig: '奖金投注配置',
    single: '单',
    ranges: '范围',
    nextValue: '下一个值',
    lPrevValue: '以前的值',
    addRanges: '增加量程',
    lifetimePeriod: '终身使用期',
    resetRanges: '重置范围',
    lCampaign: ' 广告系列',
    multi: ' 多重',
    option: '选项',
    triggers: '触发',
    viewRanges: '查看范围',
    depositNumber: '存款编号',
    participantsAllPlayersDesc: '允许在执行触发器时将所有玩家作为参与者。',
    participantsAllPlayersMainAreaDesc: '执行触发后，系统会将所有玩家都列为参与者。',
    bonusResultAreaDesc: '您可以从侧面区域看到添加和配置后的奖金。',
    participantsResultAreaDesc: '添加和配置参与者后，您可以从侧面区域看到他们。',
    editTriggerDisabled: '您现在无法编辑触发器',
    multiOrSingleBonus: '多项和单项奖金说明',
    editParticipantsDisabled: '您现在无法编辑参与者',
    configureParticipants: '配置参与者',
    selectTriggerParticipantsBonuses: '选择触发器，选择参与者，配置奖金',
    toMakeSureCampaignSuccessful: '确保您的活动成功',
    participantType: '参与者类型',
    triggerType: '触发类型',
    cancelPromotion: '取消促销',
    createCampaign: '创建活动',
    multiOrSinglePromocodeType: '多重和单一促销代码类型描述',
    missingAmount: '缺少金额',
    multiSelectionNum: '多选数字',
    playThroughRequiredDesc: '如果这个选项被打开，那么游戏周目字段的值应该等于设定的数字，如果它被关闭，它应该等于或大于这个数字。',
    playThroughInputDesc: '允许定义玩家是否必须按照游戏周目配置中定义的次数下注奖金才能完成奖金（除了营业额中的0）',
    cancelBonusWhenWithdrawalDesc: '取款时取消奖金说明',
    triggerOption: '触发器选项',
    campaign: '活动',
    periodDescription: '这里可以设置在哪个时期定义存款的数量',
    singleCountTypeDesc: '允许只设置一个奖金，但每个存款号码有不同的金额，当我们不需要配置相同奖金类型的几个奖金时，可以使用。',
    multiCountTypeDesc: '允许设置不同类型的奖金，对每笔存款的数量进行不同的配置。在这种情况下，我们为每个奖金类型选择存款数量（可能的值为1，...，100）。',
    disconnectTriggerDesc: '如果这个功能被激活，并且玩家获得了至少一个奖金，但不满足奖金条件，那么系统将把他从活动中断开，并且玩家将不再获得新的奖金。',
    participantsPlayerDesc: '允许通过上传CSV或手动方式加入球员',
    participantsPlayerListAmountsDesc: '允许通过上传球员名单来包括具有个人奖金数额的球员。',
    participantsPromoCodeDesc: '允许通过使用生成的促销代码将玩家包括在内',
    countryConditionDesc: '检查玩家的国家/地区',
    verifyConditionDesc: '检查玩家的验证级别',
    weekDaysConditionDesc: '在特定的日子里检查球员的',
    accountStatusConditionDesc: '检查玩家的账户状态',
    sportStatusConditionDesc: '检查玩家在体育博彩上的状态',
    segmentConditionDesc: '检查玩家所处的段位',
    tagConditionDesc: '检查玩家拥有的标签',
    paymentsConditionDesc: '检查球员的交易付款',
    configModeAlreadyOpened: '您已打开配置模式',
    bonusBetConfigInfo: '允许配置奖金投注。赌注应符合保存的标准，才能被视为奖金赌注',
    amountConfigSingleDesc: '允许设置每种货币的单一金额配置',
    amountConfigRangesDesc: '允许为每种货币设置多范围金额配置',
    depositAmountConfigFixedAmountDesc: '允许提供对每种货币固定的奖金数额（按货币）。在固定金额的情况下，我们可以使用单个或范围选项配置存款条件',
    amountConfigFromDepositDesc: '允许以存款的百分比来计算奖金数额（所有货币都适用）。',
    noDataAlt: '没有选择触发器、参与者、奖金',
    successPlayers: '玩家可以获得奖金',
    errorPlayers: '缺少货币',
    amountConfigAreaInfo: '在该区域里可以配置奖金金额并设置每种货币的限制',
    availableCount: '可用数',
    availablePromoCodes: '可用的促销代码',
    downloadAvailableCodes: '下载可用代码',
    lNextValue: '下一个值',
    freeSpinAmountConfigInfo: '选择提供商和行数以获取金额限制',
    freeSpinRequiredAllGames: '该供应商支持所有游戏的免费旋转',
    maxWinAmount: '最大赢利金额',
    line: '线路',
    casinoBonus: '娱乐场奖金',
    campaignStatus: '活动状态',
    spinsAmount: '转盘数量',
    maxTriggerCount: '最大触发器计数',
    maxTriggerCountInfo: '此字段允许设置每个玩家的最大成功触发次数',
    freeSpinCurrencyInfo: '该系统包括由品牌和所选供应商支持的货币',
    amountRanges: '金额范围(从-到)',
    amountRangesHint: '金额范围 "的 "自 "字段中的金额包括在该范围内，而 "至 "字段中的金额则不包括在该范围内。',
    numberOfPlayers: '玩家数量（从-到）',
    numberOfPlayersHint: '球员人数 "的 "从 "字段中的数字包括在该范围内，而 "到 "字段中的数字则不包括在该范围内。',
    numberOfReferees: '推荐人数(从-到)。',
    numberOfRefereesHint: '推荐人数 "的 "从 "字段中的数字包括在该范围内，而 "到 "字段中的数字则不包括在该范围内。',
    campaignStatistics: '活动统计',
    maxLimitAmount: '最高限额金额',
    netDepositAmountHint: '存款净额 "的 "自 "字段中的数字包括在该范围内，而 "至 "字段中的数字则不包括在该范围内。',
    gameSegmentInfo: '游戏分段中的更改不会影响已创建的实体',
    lCashbackAmounts: '现金返还金额',
    usedPromoCodes: '使用的促销代码',
    createCrossPlatformCampaign: '创建跨平台活动',
    amountConfigAreaCrossCampaignInfo: '这个领域里可以为每种货币设定了限制',
    selectAndConfigureBonuses: '选择和配置奖金',
    cashbackStatistics: '现金返还统计',
    freeSpinAmountConfigInfoForSingle: '选择提供商、行数和游戏以获得金额限制',
    minMaxProviderLimit: '最小-最大提供程序限制',
    spinTotalAmount: '旋转总金额',
    minMaxProviderLimitInfo: '由转盘数量乘以转盘金额产生的转盘总金额应在上述限额之间。',
    maxWageringOddType: '最大赌注的奇数类型',
    maxWageringOdd: '最大赌注奇数',
    wageringOdd: '投注赔率',
    winAmountTransferTo: '赢取金额转至',
    allowCashout: '允许提现',
    allowCashoutInfo: '允许玩家对该奖金使用提现/部分提现功能',
    bonusAbuse: '奖金滥用',
    bonusAbuseInfo: {
      0: '激活该复选框后，玩家将不能在同一赛事中多次使用奖金余额下注。',
      1: '激活该复选框后，玩家将不能在同一赛事中多次使用奖金余额下注。',
      2: '激活该复选框后，玩家将不能用奖金余额对同一赛事进行多次投注。在真实投注奖金的情况下，如果玩家用真实余额对符合奖金要求的同一赛事进行多次投注，则第二次投注不会减少投注周转。',
    },
    oneTimeBet: '一次投注',
    oneTimeBetInfo: '要求玩家充分使用奖金',
    minBetAmountPerCategory: '每个类别的最小投注额',
    periodDescriptionEvery: '在这里，我们可以设置在哪个时段定义最大触发次数，如果没有设置，系统将不会限制玩家的触发次数。',
    totalBets: '总投注额',
    totalWins: '总获胜',
    subMethod: '子方法',
    paymentConditionPropertiesInfo: '子方法菜单仅适用于聚合器提供子方法列表的支付方法。',
    verificationTriggerInfo: '如果所有选定选项都已验证，则条件将起作用，触发器字段验证也包括在内',
    promoCodesUploadFormatMsg: '您可以上传促销代码。只接受CSV格式',
    amountConfigDepositSingleDesc: '允许为每种货币设置单一的%配置',
    amountConfigDepositRangesDesc: '允许为每种货币设置多范围%配置',
    canceller: '取消方',
    awardedBonusesDetails: '已获奖金详情',
    bonusLowestAmount: '最低奖金额',
    bonusHighestAmount: '最高奖金额',
    totalBonusAmount: '奖金总额',
    checkTheListOfRecipients: '请查看最终获奖者名单',
    allGames: '所有游戏',
    allGamesDesc: '允许在品牌的所有游戏上设置奖金抽奖，品牌游戏上的所有更改都将被考虑在内',
    selectGamesDesc: '允许在特定提供商和游戏上设置奖金抽奖',
    contribution: '贡献，%',
    addPlayersNote: '可以只添加新参与者。否则，他们将自动从参与者列表中排除',
    campaignParticipants: '活动参与者',
    autoActivation: '自动激活',
    autoActivationDesc: '允许将已激活的奖金分配给玩家。如果使用自动激活功能，建议从每种奖金类型（娱乐场、体育、免费旋转）中配置一种奖金。否则，奖金将随机激活。',
    promoCodeCaseSensitiveInfo: '允许为玩家配置促销代码。这些代码对玩家不敏感，会被转换为大写格式',
    supportPlayerCancellationGamesInfo: '提供商允许选择 {{type}} 游戏，但不允许在激活后取消奖励',
    referralStatistics: '推荐统计',
    campaignWillBeSavedInBgInfo: '活动数据越大，将在后台模式下保存，并在活动列表中提供。',
    contentAndNotification: '内容和通知',
    contentAndNotificationConfigsRemovedDesc: '删除了所有奖金内容和通知配置，保存后将丢失之前的所有配置。',
    cloneContentFrom: '克隆 <0>{{bonusName}}</0> 奖金内容到',
    contentLanguages: '内容语言',
    notificationInfo: '在此区域，我们为玩家配置了奖金分配通知，如果没有选择模板，玩家将不会收到品牌传播渠道的通知。',
    contentInfo: '在这一区域，我们用品牌语言配置图片和奖金相关内容，玩家将看到这些内容。如果未配置内容，系统将使用默认内容。',
    editContent: '内容编辑',
    bonusStatistics: '奖金统计',
    sportBonus: '体育奖金',
    manageContentAndNotification: '管理内容和通知',
    minCashbackAmount: '最小返现金额',
    triggerDeviceTypeDesc: '检查触发器的设备类型',
    signUpDeviceTypeDesc: '检查注册播放器的设备类型',
    viewContentAndNotifications: '查看内容和通知',
    winType: '赢的类型',
    winOptions: '赢得金额类型',
    realMoney: '真钱',
    availableBonus: '可用奖金',
    wageringBonus: '投注奖金',
    pauseBonus: '暂停奖金',
    pauseBonusDesc: '启用该选项后，玩家可以暂停已收到的奖金，稍后再继续',
    pausedDate: '暂停日期',
    resumedDate: '恢复继续日期',
    sidebarParticipantsDescription: '这里可以选择活动参与者的选择条件： 玩家名单，玩家名单-金额，促销代码，条件',
    contentAndNotificationSidebarNoBonuses: {
      text1: '',
      text2: '配置和保存奖金后，“内容和通知”区域将处于活跃状态',
    },
    sidebarTriggerDescription: '这里可以设置活动触发器配置：无触发器、存款、注册、验证',
    contentAndNotificationSidebarDesc: '在这里，我们可以选择已配置的奖金，并添加奖金的具体内容和通知',
    contentAndNotificationResultAreaDesc: '在侧边区域添加和配置奖金后，您可以看到奖金的内容和通知。',
    configAlreadySaved: '您已经配置了奖金或参与者，请删除它们以便进行编辑',
    promoCodeTypes: {
      0: '允许手动填写促销代码',
      1: '允许系统生成唯一代码',
      2: '允许手动添加外部促销代码。系统将自动从上传列表中排除重复代码和长度不在3-25之间的代码，检查将在所有奖励活动之间进行',
    },
    bonusOptionsDesc4: '玩家将根据特定时间段内的总投注额获得奖金',
    participantsJoinDesc: '允许通过网站上的“加入”操作将玩家纳入参与者',
    campaignContent: '活动内容',
    bonusContent: '奖金内容',
    campaignContentTabInfo: '在此区域，我们将使用品牌语言配置图片和活动相关内容，以便玩家查看。需要使用品牌的主要语言配置内容。',
    signInDate: '登录日期',
    remainingBonusAmount: '剩余奖金额',
    triggerConditionsResultAreaDesc: '您可以在侧边区域看到添加和配置后的触发条件。',
    triggerConditions: '触发条件',
    websiteImage: '网站图像',
    sidebarTriggerConditionDescription: '在这里我们可以选择活动触发的具体条件',
    mobileImage: '移动图像',
    specificTimePeriod: '特定时间段',
    weekDays: '工作日',
    monthlyDatesConditionDesc: '检查特定日期的玩家',
    dates: '日期',
    monthlyDates: '每月日期',
    sourceId: '源ID',
    sourceName: '源名称',
    participationGroupsNote: '从侧面区域添加并配置参与组后，您就可以看到它们。',
    participationGroupsDesc: '添加并配置参与条件后，您可以在侧面区域看到。',
    lParticipationGroups: '参与组',
    playerListDesc: '允许通过上传CSV或手动添加玩家',
    playerListAmountDesc: '允许上传玩家名单，包括玩家的个人奖金金额',
    allPlayersDesc: '允许在触发器执行时将所有玩家纳入参与者',
    promoCodeDesc: '允许使用生成的促销代码来包含玩家',
    additionalConditions: '附加条件',
    participationGroups: '参与组',
    participationGroup: '参与组',
    lParticipationGroup: '参与组',
    playersAreParticipants: '玩家也算作参与者',
    bonusesDesc: '您可以从侧面区域看到添加和配置后的奖金。',
    gameConfig: '游戏配置',
    recurringConditionDesc: '检查玩家在特定日期或每月的触发情况',
    conditionTypes: '条件类型',
    lTriggerCondition: '触发条件',
    bonusAbuseInfoNote: '激活此复选框后，玩家将无法使用奖金余额对同一事件进行多次下注',
    productSelection: '产品选择',
    casinoGameConfig: '赌场游戏配置',
    contents: '内容',
    lCampaignContent: '活动内容',
    lBonusContent: '奖金内容',
    units: '单元',
    unitsNote: 'sd',
    triggerCondition: '触发条件',
    wageringLogic: '赌注逻辑',
    wageringBaseAmount: '赌注基础金额',
    wageringCoefficient: '赌注系数',
    wageringCount: '赌注计数',
    calculationLogic: '计算逻辑',
    wageringParticipation: '赌注参与',
    firstWalletDebited: '借记的第1个钱包',
    lockAmount: '锁定额',
    allowNonMatchingBets: '允许非匹配投注',
    triggerBasedConfig: '基于触发的配置',
    lUnit: '单元',
    unitsDesc: '您可以在侧边区域看到添加和配置后的单元。',
    navigationItemsDisabledInfo: '保存活动常规部分后，导航项目将被激活。',
    sidebarTriggerConditionInfo: '您可以在侧边区域看到添加和配置后的触发条件',
    summary: '摘要',
    offers: '优惠',
    offersContentTabInfo: '在此区域，我们将使用品牌语言配置图片和活动相关内容，以便玩家查看。需要使用品牌的主要语言配置内容。',
    sidebarUnitInfo: '您可以在侧边区域看到添加和配置后的单元',
    lContent: '内容',
    offersContent: '单元(优惠)内容',
    lOfferContent: '优惠内容',
    unit: '单元',
    totalOdds: '总赔率',
    minTotalOdd: '最小总赔率',
    maxTotalOdd: '最大总赔率',
    sportEventConfig: '体育赛事活动配置',
    lockType: '锁定类型',
    gamesConditionDesc: '检查已启动游戏的触发',
    transactionAmount: '交易额',
    unitName: '单元名称',
    productType: '产品类型',
    isUsedInUnit: '用于单元',
    minBetTriggerAmount: '最小投注触发额',
    bonusAmount: '奖金额',
    point: '积分',
    contributedFrom: '贡献者',
    contributedFromDescription: '在这里我们可以设置哪些投注应该参与累计投注周转',
    sportBetsConditionDesc: '检查玩家对特定体育赛事的投注',
    casinoBetsConditionDesc: '检查玩家在特定赌场游戏中的投注',
    betAmountConfigFixedAmountDesc: '允许为每种货币提供固定的奖金金额（按货币）。如果是固定金额，我们可以使用单一或范围选项配置投注条件',
    amountConfigFromBetDesc: '允许以投注额的百分比计算奖金（所有货币通用）',
    fromBet: '%来自投注',
    bonusOptionsDesc5: '玩家在触发期内的所有投注都将获得奖金',
    gameInfo: '已选的游戏支持类型： <0>{{type}}</0>',
    freeGameType: '免费游戏类型',
    combinations: '组合',
    involvement: '参与',
    sports: '体育',
    tournaments: '锦标赛',
    events: '赛事活动',
    markets: '市场',
    allEventsAreSelected: '所有活动均已选定',
    allMarketsAreSelected: '所有市场均已选定',
    customSelection: '自定义选择',
    live: '直播',
    lEvents: '赛事活动',
    lMarkets: '市场',
    lMarket: '市场',
    lEvent: '赛事活动',
    lTournaments: '锦标赛',
    entitiesLimitInfo: '实体（锦标赛、活动、市场）的最大数量为 {{count}}。自定义选择时，选择将计数。',
    fromBetAmount: '%从投注额',
    gamesCount: '游戏数量',
    freeSpinGamesInfo: '选择提供商获取游戏',
    previousUnit: '上一单元',
    previousUnitInfo: '一旦选定单位的奖金发放完毕，当前单元将被分配。这只适用于同一参与组内的单元',
    eventType: '活动类型',
    complainer: '投诉者',
    hashtagDescription: '标签说明',
    lPlayerBonus: '玩家奖金',
    lPlayersBonuses: '玩家奖金',
    playerBonus: '玩家奖金',
    playersBonuses: '玩家奖金',
    eligibleBets: '合格投注',
    eligibleBetsStatus: '合格投注状态',
    betBuilder: '投注生成器',
    betBuilderTotalOdds: '投注生成器总赔率',
    betBuilderMultiSelectionNum: '投注生成器多选号码',
    minBetBuilderTotalOdd: '最小投注生成器总赔率',
    maxBetBuilderTotalOdd: '最大投注生成器总赔率',
    lUnitBonuses: '单元奖金',
    partialCancel: '部分取消',
    addPlayers: '添加玩家',
    pointEnhancement: '积分增强',
    pointEnhancementInfo: '启用选项，设置获得每个积分奖金所需的投注次数。',
    betCount: '投注计数',
    bonusOptionsDesc6: '玩家只要在一个点和规定时间内达到最低投注额和计数要求，就能获得奖金。',
    lobbyWidgetGameSegmentInfo: '游戏分区的更改不会影响已创建的实体，只有那些与所选分区和大厅通用的游戏才会出现在列表中。',
    wageringParticipationInfo: '兑现类型的投注不计入周转计算。',
    sidebarBonusesDescription: '在这里，我们可以选择体育、老虎机、赌场和特别的可用奖金类型，并将其添加到活动中。',
    code: '代码',
    dynamicDesc: '启用基于财务指标生成佣金（可按单个被推荐人或全部被推荐人合并计算）',
    progressiveDesc: '允许根据推荐玩家数量设置特定佣金区间',
    prizeDesc: '允许设置佣金区间，为完成条件的新推荐玩家提供一次性固定奖励',
    supportPlayerCancellationGameInfo1: '该提供商允许玩家取销',
    supportPlayerCancellationGameInfo2: '该提供商不允许玩家取销',
    bonusContentDesc: '在侧边区域添加并配置后，可查看奖金的 {{type}}',
    noUnitWithEmptyContentForLanguage: '该语言下不存在内容为空的单元',
    noBonusWithEmptyContent: '不存在内容为空的奖金',
    currentStage: '当前阶段',
    inProcess: '处理中',
    placedBetAmount: '已下注金额',
    totalBetCount: '总投注次数',
    placedBetCount: '已下注次数',
    periodDate: '周期日期',
    grantBonus: '发放奖金',
    bonusWillBeGrantedAfterWageringCompleted: '当前奖金流水完成后将发放所选奖金',
    infoMaxRedeemAmount: '最高可兑换金额为 {{value}}',
    infoSpinsAmount: '免费旋转次数为 {{value}}',
    infoCombinationValues: '组合数值为 {{value}}',
    participationType: '参与类型',
    resetToDefault: '重置为默认',
    amountRange: '金额区间',
    considerAsBTag: '视为 BTAG',
    considerAsBTagInfo: '若促销码与玩家输入一致，此选项将覆盖 btag 字段',
    byPlayerID: '按玩家 ID',
    byTags: '按标签',
    bySegments: '按分组',
    dynamicSelection: '动态选择',
    staticSelection: '静态选择',
    deleted: '已删除',
    onJoinUnitInfo: '指定此配置是否使用自身的加入设置',
    riskyGameExclusionInfo: '游戏风险变更不会影响已创建的实体',
    conditionsInfo: '仅新推荐玩家可获得资格。每位推荐玩家必须完成所有所选条件，推荐人才能获得佣金',
    minWithdrawalAmount: '最低取现金额',
    withdrawalAmountConfigFixedAmountDesc: '允许为每种货币设置固定奖金金额（按货币）。在固定金额情况下，可通过单一或区间方式配置取现条件',
    fromWithdrawal: '按取现百分比',
    amountConfigFromWithdrawalDesc: '允许将奖金金额按取现金额百分比计算（适用于所有货币）',
    fromWithdrawalAmount: '按取现金额百分比',
    sourceTypes: '来源类型',
    unitsAllocation: '单元分配',
    unitsAllocationInfo: '如需玩家通过一次触发获得所有已创建单元，请选择“单一触发-全部单元”。请确保每个单元条件设置一致，以便同时通过所有校验',
  },
  ro: {
    maxBonusAmount: 'Suma maximă de bonus',
    maxRedeemAmount: 'Valoarea maximă de rambursare',
    minBetAmount: 'Suma minimă de pariu',
    contributionPercent: 'Contribuție, %',
    cashbackPercent: 'Cashback, %',
    bonusType: 'Tip de bonus',
    currencies: 'Valute',
    triggerPeriod: 'Perioadă de declanșare',
    activationPeriod: 'Perioadă de activare',
    playthrough: 'Rulaj',
    wageringPeriod: 'Perioadă de pariere',
    issueBonus: 'Emite bonusul',
    bonusId: 'ID de bonus',
    promoName: 'Numele promoției',
    promoCode: 'Cod promoțional',
    promoCodeType: 'Tip de cod promoțional',
    lPromoCode: 'cod promoțional',
    maxUseCount: 'Numărul maxim de utilizare',
    dateUsed: 'Data de utilizare',
    promotionEndDate: 'Data de încheiere a promoției',
    issuedBy: 'Acordat de către',
    canceledBy: 'Anulat de către',
    mobileVerified: 'Telefon mobil verificat',
    identityVerified: 'Identitate verificată',
    emailVerified: 'E-mail verifiat',
    disconnectedBy: 'Deconectat de către',
    disconnectTrigger: 'Deconecta declanșatorul',
    turnoverAmount: 'Valoarea cifrei de afaceri',
    remainingTurnover: 'Cifra rămasă de rulat',
    bonusStatus: 'Stare de bonus',
    triggeredDate: 'Data de declanșare',
    providerMayDisabled: 'Furnizorul poate fi dezactivat.',
    gameMayDisabled: 'Jocul poate fi dezactivat.',
    maxCashbackAmount: 'Suma maximă a Cashback-ului',
    cashbackId: 'ID de Cashback',
    cashbackName: 'Numele de Cashback',
    cashbackType: 'Tip de Cashback',
    calculationTime: 'Timp de calcul',
    transferType: 'Tip de transfer',
    platforms: 'Platforme',
    platform: 'Platformă',
    restrictedPlayers: 'Jucători restricționați',
    restrictedCountries: 'Țări restricționate',
    totalBet: 'Pariu total',
    totalWin: 'Câștig total',
    accumulated: 'Acumulat',
    accumulatedCashBack: 'Cashback acumulat',
    transferredCashBack: 'CashBack transferat',
    commission: 'Comision',
    commissions: 'Comisioane',
    lCommissions: 'Comisioane',
    commissionPercent: 'Comision, %',
    manageLimits: 'Administrare de limită',
    referees: 'Recomandații/Referințe',
    setCommissions: 'Setare comisioane',
    referralBonusId: 'ID bonus de recomandare',
    lReferralBonus: 'bonus de recomandare',
    referralBonus: 'ID bonus de recomandare',
    calculationPeriodTime: 'Timpul perioadei de calcul',
    commissionFrom: 'Comision de la',
    referrerId: 'ID de referitor',
    accumulatedCommission: 'Comision acumulat',
    nextCalculationDate: 'Următoarea dată de calcul',
    transferredCommission: 'Comision transferat',
    commissioningAmount: 'Suma de comision',
    convertedTo: 'Convertit la',
    convertedAmount: 'Convertit la',
    redeemedAmount: 'Suma rambursată',
    winAmount: 'Suma de câștig',
    lossAmount: 'Suma pierdută',
    cashbackAmount: 'Suma de cashback',
    includeActiveBonuses: 'Include bonusuri active',
    lBonus: 'bonus',
    bonus: 'Bonus',
    casino: 'Casino',
    invalidPlayerCount: 'Numărul de jucători nevalid în raport',
    totalPlayersUpdated: 'Numărul total de jucători de actualizat',
    lBonusTemplate: 'șablon de bonus',
    bonusTemplate: 'Șablon de bonus',
    invalidKeys: 'Chei nevalide',
    playersMissingCurrencyReason: 'Valuta contului de jucător nu este configurată',
    playersRestrictedReason: 'Jucătorul are un cont cu acces restricționat',
    missingCurrency: 'Valută incompletă',
    missingCurrencyReason: 'Moneda contului de jucător nu este configurată',
    issue: 'Problemă',
    platformType: 'Tipul de platformă',
    amountConfig: 'Suma de configurare',
    paymentMethods: 'Metode de plată',
    first: 'Primul',
    second: 'Al doilea',
    third: 'Al treilea',
    fourth: 'Al patrulea',
    fifth: 'Al cincilea',
    fromDepositAmount: '% din suma depunerii',
    fromDeposit: '% din depozit',
    betType: 'Tipul de pariu',
    minWageringOdd: 'Pariere minimă de cotă',
    minWageringOddType: 'Tip de pariere minimă de cotă',
    bonusTemplateName: 'Numele de șablon bonus',
    bonusTemplateId: 'ID de șablon bonus',
    categories: 'Categorii',
    bonusOptionsDesc: 'Un bonus de înscriere este o sumă de bani plătită unui nou jucător',
    bonusOptionsDesc1: 'Jucătorii vor primi bonusuri pentru toate depunerile din perioada de declanșare',
    bonusOptionsDesc2: 'Utilizatorul poate alege numărul de depuneri în perioada de declanșare pentru care jucătorii vor primi bonusuri',
    bonusOptionsDesc3: 'Jucătorii vor primi bonusuri pentru prima depunere a fiecărei zile în perioada de declanșare',
    createNewTemplate: 'Creează un șablon nou',
    selectBonusType: 'SELECTEAZĂ UN TIP DE BONUS',
    selectBonusTrigger: 'SELECTEAZĂ UN DECLANȘATOR DE BONUS',
    numberOfDeposits: 'Numărul depunerilor',
    fixedAmount: 'Cantitate fixă',
    sport: 'Sport',
    rules: 'Regule',
    rule: 'Regulă',
    noRules: 'Nicio regulă de afișat',
    relatedBonusId: 'ID de bonus asociat',
    endDateTime: 'Data/Ora de încheiere',
    noEndDate: 'Fără dată de încheiere',
    selectGames: 'Selectare jocuri',
    activities: 'Activități',
    discardAccumulatedCommissions: 'Eliminează comisioanele acumulate',
    playersInAnotherReferral: 'Jucători deja în alt bonus de recomandare',
    allPlayersSelected: 'Toți jucătorii sunt selectați',
    datesAndPlayers: 'Date și jucători',
    special: 'Special',
    highRisk: 'Risc ridicat',
    mediumRisk: 'Risc mediu',
    countOfReferees: 'Număr de recomandat',
    playerFromParticipants: 'jucător din lista de participanți',
    signUp: 'Înregistrează-te',
    bonusNameExternal: 'Numele bonusului (extern)',
    noEndData: 'Nu sunt date de încheiere',
    minNumberOfSelections: 'Numărul minim de selecții',
    dateTriggered: 'Data de declanșare',
    referralBonusName: 'Numele bonusului de recomandare',
    refereesId: 'ID de recomandat/referință',
    refereeId: 'ID de recomandat',
    realWallet: 'Portofel real',
    details: 'Detalii',
    numberOfDepositsInfo: 'Selectează depunerile pentru care jucătorii trebuie să primească bonusuri în perioada de declanșare.',
    cloneUnit: 'Unitate clonată',
    cloneBonus: 'Bonus de clonă',
    cloneSettingsTo: 'Clonează setările către',
    balanceConfig: 'Setări de sold',
    usedCount: 'Numărul folosit',
    lRule: 'regulă',
    referralParticipants: 'Participanții de referință',
    theCashback: 'Cashback-ul',
    playersCashBack: 'Cashback de jucători',
    theBonus: 'Bonusul',
    wageringTurnover: 'Cifra de afacere de pariuri',
    playersWontBeAble: 'Jucătorii nu vor putea să retragă sau să parieze pe jocurile P2P valoarea bonusului emis.',
    calculationFrom: 'CALCULUL DIN',
    lCalculationFrom: 'Calculul din',
    createNewCashback: 'Creează un nou Cashback',
    cashbackFromBetsDesc: 'Oferă un Cashback pe diferența pozitivă de pariu - câștig în perioada de calcul.',
    cashbackNetDepositsDesc: 'Oferă Cashback pe diferența pozitivă de depozite - retrageri în perioada de calcul.',
    netDepositAmount: 'Sumă netă de depunere',
    participateRule: 'Regulă de participare',
    totalDeposit: 'Depunere totală',
    totalWithdrawal: 'Retragere totală',
    totalBonuses: 'Bonusuri totale',
    manageParticipation: 'Gestiona participarea',
    restrictionFor: 'Restricţionat pentru',
    availableFor: 'Disponibil pentru',
    sportWageringBonuses: 'Bonusuri la pariuri sportive',
    casinoWageringBonuses: 'Bonusuri la pariuri de casino',
    otherBonuses: 'Alte bonusuri',
    finishedBonusesCount: 'Număr de bonusuri finalizate',
    totalRedeemBonuses: 'Rambursare totală a bonusurilor',
    referralCommission: 'Comision de recomandare',
    maxPossibleTransfer: 'Transfer maxim posibil',
    playThroughRequired: 'Rulaj necesar',
    matchingRegistrationIP: 'Referitorul are persoane recomandate cu IP-uri de înregistrare potrivite',
    sameRegistrationIP: 'Referitorul și recomandatul au același IP de înregistrare',
    amountColumnInfo: 'Intervalul include valoarea coloanei din stânga, până la dar fără să includă valoarea coloanei din dreapta',
    selectedGames: 'Jocuri selectate',
    minAmount: 'Suma minimă',
    step: 'Etapă',
    gamesInfo: 'Furnizorul permite selectarea jocurilor {{type}}',
    lSingle: 'simplu',
    lMultiple: 'multiplu',
    allowWithdrawal: 'Permite retragerea',
    expirationPeriod: 'Perioadă de pariere',
    lengthOfCodes: 'Lungime de coduri',
    participantsAllPlayersDesc: 'Permite includerea tuturor jucătorilor ca participant/participanți, atunci când declanșatorul (trigger-ul) este executat',
    participantsAllPlayersMainAreaDesc: 'Sistemul va include toți jucătorii ca jucător participant după executarea declanșatorului.',
    triggerOption: 'Opțiunea de declanșare',
    participantType: 'Tipul de participant',
    campaignName: 'Denumirea campaniei',
    campaignStatus: 'Starea campaniei',
    availableCount: 'Număr disponibil',
    cancelBonusWhenWithdrawal: 'Anulați bonusul la retragere',
    minDepositAmount: 'Suma min. de depunere',
    number: 'număr',
    participant: 'participant ',
    depositsAmountConfigInfo: 'În această zonă configurăm Suma Bonusului și stabilim limitări pentru fiecare monedă.',
    bonusBetConfig: 'Configurare Bonus de pariu ',
    single: 'simplu ',
    ranges: 'Intervale',
    nextValue: 'Valoarea următoare',
    lPrevValue: 'valoarea anterioară',
    addRanges: 'Adaugă Intervale',
    lifetimePeriod: 'Întregul ciclu de viață',
    resetRanges: 'Resetare a intervalelor',
    lCampaign: 'campanie',
    multi: 'Multi',
    option: 'Opțiune',
    triggers: 'Declanșatori',
    viewRanges: 'Vizualizare intervale',
    depositNumber: 'Numărul depunerii',
    bonusResultAreaDesc: 'Poți vedea Bonusurile după adăugarea și configurarea lor din partea laterală.',
    participantsResultAreaDesc: 'Poți vedea Participanții după adăugarea și configurarea lor din partea laterală.',
    editTriggerDisabled: 'Nu poți edita declanșatorul acum ',
    multiOrSingleBonus: 'Descrierea bonusului multi și simplu',
    editParticipantsDisabled: 'Nu poți edita participanții acum',
    configureParticipants: 'Setările participanților',
    selectTriggerParticipantsBonuses: 'Selectează Declanșatorul (Triggerul), Alege Participanții, Configurează Bonusurile',
    toMakeSureCampaignSuccessful: 'Pentru a asigura succesul campaniei tale',
    triggerType: 'Tipul declanșatorului',
    cancelPromotion: 'Anulează promoția',
    createCampaign: 'Crează o campanie',
    multiOrSinglePromocodeType: 'Descrierea tipului de cod promoțional multi și simplu',
    missingAmount: 'Sumă lipsă',
    multiSelectionNum: 'Număr de selecție multiplă',
    playThroughRequiredDesc:
      'În cazul în care această opțiune este activată, valoarea câmpului Playthrough trebuie să fie egală cu numărul setat, iar în cazul dezactivării, aceasta trebuie să fie egală sau mai mare decât',
    playThroughInputDesc:
      "Permite definirea dacă un jucător trebuie să parieze bonusul de atâtea ori, cât este definit în configurația ''playthrough'' pentru a putea termina bonusul (în afară de 0 în rulaj).",
    cancelBonusWhenWithdrawalDesc: 'Descriere de Anulare Bonus la Retragere',
    campaign: 'Campanie',
    periodDescription: 'Aici putem stabili în ce perioadă să definim numărul depunerii',
    singleCountTypeDesc:
      'Permite configurarea unui singur bonus, însă cu sume diferite pentru fiecare număr de depunere, utilizabilă în cazurile în care nu este nevoie de configurare a mai multor bonusuri cu același tip de bonus.',
    multiCountTypeDesc:
      'Permite setarea diferitelor tipuri de bonusuri cu diferite configurații de sume pentru fiecare număr de depunere. În acest caz, alegem numărul depunerii/depozitului (valori posibile 1, ..., 100) pentru fiecare tip de bonus',
    disconnectTriggerDesc:
      'În cazul în care această funcționalitate este activată și jucătorul a primit cel puțin un bonus, dar nu îndeplinește condițiile de acordare a bonusurilor, atunci sistemul îl va deconecta din campanie, iar jucătorul nu va mai primi bonusuri noi.',
    participantsPlayerDesc: 'Permite includerea jucătorilor prin încărcare CSV sau manuală ',
    participantsPlayerListAmountsDesc: 'Permite includerea jucătorilor împreună cu sume de bonus individuale prin încărcarea listei de jucători',
    participantsPromoCodeDesc: 'Permite includerea jucătorilor prin utilizarea codului promoțional generat',
    participantsConditionsDesc: 'Permite includerea jucătorilor prin declanșarea unor condiții specifice',
    countryConditionDesc: 'Verifică țara jucătorilor',
    verifyConditionDesc: 'Verifică nivelul de verificare al jucătorilor',
    weekDaysConditionDesc: 'Verifică jucătorii în anumite zile',
    accountStatusConditionDesc: 'Verifică statusul conturilor jucătorilor',
    sportStatusConditionDesc: 'Verifică statusurile jucătorilor pe Sportsbook',
    segmentConditionDesc: 'Verifică segmentele din care fac parte jucătorii',
    tagConditionDesc: 'Verifică etichetele pe care le au jucătorii',
    paymentsConditionDesc: 'Verifică plățile tranzacțiilor jucătorilor',
    configModeAlreadyOpened: 'Ai deschis deja modul de configurare',
    bonusBetConfigInfo: 'Permite configurarea pariurilor de bonus. Pariul trebuie să corespundă criteriilor salvate pentru a fi considerat ca fiind un pariu bonus.',
    amountConfigSingleDesc: 'Permite configurarea unor sume unice pentru fiecare monedă',
    amountConfigRangesDesc: 'Permite configurarea sumelor din mai multe intervale pentru fiecare valută',
    depositAmountConfigFixedAmountDesc:
      'Permite furnizarea unei sume de bonus care este fixă pentru fiecare valută (Prin monedă). În cazul unei sume fixe, putem configura condițiile de depunere folosind opțiunile Simplu sau interval',
    amountConfigFromDepositDesc: 'Permite numărarea sumei bonusului ca procent din depunere (general pentru toate valutele)',
    noDataAlt: 'Fără Declanșator, Participanți, Bonusuri selectate',
    successPlayers: 'Jucătorii pot obține un bonus',
    errorPlayers: 'Lipsa de valută ',
    amountConfigAreaInfo: 'În această parte configurăm suma bonusului și stabilim limitări pentru fiecare monedă',
    availablePromoCodes: 'Coduri promoționale disponibile',
    downloadAvailableCodes: 'Descarcă codurile disponibile',
    lNextValue: 'Valoarea următoare',
    freeSpinAmountConfigInfo: 'Selectează furnizorul și numărul de linii pentru a obține restricțiile de sumă',
    freeSpinRequiredAllGames: 'Acest furnizor acceptă rotiri gratuite la toate jocurile',
    maxWinAmount: 'Valoarea maximă de câștig',
    line: 'Linie',
    casinoBonus: 'Bonus de Casino',
    spinsAmount: 'Suma de rotiri',
    maxTriggerCount: 'Numărul maxim de declanșare',
    maxTriggerCountInfo: 'Acest câmp va permite setarea numărului maxim de declanșări reușite pentru fiecare jucător',
    freeSpinCurrencyInfo: 'Sistemul include monedele acceptate de marca (metodă de plată) și de furnizorul ales',
    amountRanges: 'Intervalul sumei (de la - până la)',
    amountRangesHint: 'Suma din câmpul "De la" al "Intervalului de sume" este inclusă în intervalul respectiv, în timp ce suma din câmpul "La" nu este inclusă în interval.',
    numberOfPlayers: 'Numărul de jucători (de la - la)',
    numberOfPlayersHint: 'Numărul din câmpul "De la" al "Număr de jucători" este inclus în acel interval, în timp ce numărul din câmpul "Până la" nu este inclus în interval.',
    numberOfReferees: 'Numărul de arbitri (de la - până la)',
    numberOfRefereesHint: 'Numărul din câmpul "De la" al "Număr de arbitri" este inclus în intervalul respectiv, în timp ce numărul din câmpul "Până la" nu este inclus în acest interval.',
    campaignStatistics: 'Statisticile campaniei',
    maxLimitAmount: 'Suma maximă de limită',
    netDepositAmountHint: 'Numărul din câmpul "De la" al "Sumei nete a depozitului" este inclus în intervalul respectiv, în timp ce numărul din câmpul "La" nu este inclus în interval.',
    gameSegmentInfo: 'Modificările din segmentul de joc nu vor afecta o entitate deja creată.',
    lCashbackAmounts: 'Sume de Cashback',
    usedPromoCodes: 'Coduri promoționale utilizate',
    createCrossPlatformCampaign: 'Crează campania Cross-Platform',
    amountConfigAreaCrossCampaignInfo: 'În acest domeniu stabilim limitări pentru fiecare valută',
    selectAndConfigureBonuses: 'Selectează și configurează bonusuri',
    cashbackStatistics: 'Statisticile CashBack',
    freeSpinAmountConfigInfoForSingle: 'Selectează furnizorul, numărul de linii și jocul pentru a obține restricțiile de sumă',
    minMaxProviderLimit: 'Limita furnizorului Min-Max',
    spinTotalAmount: 'Suma totală de rotiri',
    minMaxProviderLimitInfo: 'Suma totală a rotiri generată de numărul de rotiri înmulțit cu suma învârtirilor trebuie să fie între limitele menționate',
    maxWageringOddType: 'Miza maximă de Tip Odd',
    maxWageringOdd: 'Miza maximă de Odd',
    wageringOdd: 'Pariuri Odd',
    winAmountTransferTo: 'Suma de câștig transferată către',
    allowCashout: 'Permite Cashout-ul',
    allowCashoutInfo: 'Permite jucătorilor să folosească funcțiile de retragere (Cashout)/încasare parțială pentru acest bonus',
    sidebarParticipantsDescription: 'Aici putem alege condițiile de selecție a participanților la campanie: Lista de jucători, Lista de jucători - Sume, Cod promoțional, Condiții',
    sidebarTriggerDescription: 'Aici putem seta configurațiile de declanșare a campaniei: Fără declanșare, Depunere, Înregistrare, Verificare',
    configAlreadySaved: 'Ai configurat deja bonusuri sau participanți, elimină-i pentru a putea edita',
    bonusOptionsDesc4: 'Jucătorii vor primi bonusuri pentru totalul pariurilor efectuate într-o anumită perioadă de timp',
    noTrigger: 'Niciun declanșator',
    sidebarBonusesDescription: 'Aici putem să alegem tipurile de bonus disponibile (Sport, Rotiri, Cazinou și Special) și să le adăugăm la campanie',
    bonusAbuse: 'Abuzarea bonusului',
    oneTimeBet: 'Pariu unic',
    oneTimeBetInfo: 'Le solicită jucătorilor să utilizeze complet bonusul',
    minBetAmountPerCategory: 'Valoare minimă pariu după categorie',
    periodDescriptionEvery: 'Aici putem seta perioada pentru definirea „Numărului maxim de declanșări“. Dacă nu este configurat, sistemul nu va limita numărul de declanșări pentru un jucător',
    totalBets: 'Pariuri totale',
    totalWins: 'Câștiguri totale',
    subMethod: 'Metodă secundară',
    paymentConditionPropertiesInfo: 'Meniul cu metode secundare este vizibil doar pentru metodele de plată unde agregatorul a furnizat o listă cu metode secundare.',
    verificationTriggerInfo: 'Condiția va funcționa dacă toate opțiunile selectate sunt verificate. De asemenea, este inclusă și verificarea câmpului de declanșare',
    promoCodesUploadFormatMsg: 'Poți să încarci coduri promoționale. Se acceptă doar formatul CSV',
    amountConfigDepositSingleDesc: 'Permite setarea config % simplă după unitate monetară',
    amountConfigDepositRangesDesc: 'Permite setarea config % cu intervale multiple după fiecare unitate monetară',
    canceller: 'Anulator',
    awardedBonusesDetails: 'Detaliile bonusurilor acordate',
    bonusLowestAmount: 'Valorile cele mai mici ale bonusului',
    bonusHighestAmount: 'Valorile cele mai mari ale bonusului',
    totalBonusAmount: 'Valoarea totală a bonusului',
    checkTheListOfRecipients: 'Te rugăm să verifici lista finală a destinatarilor',
    allGames: 'Toate jocurile',
    allGamesDesc: 'Permite setarea unei loterii bonus pentru toate jocurile de marcă. Se vor lua în considerare toate modificările asupra jocurilor de marcă',
    selectGamesDesc: 'Permite setarea unei loterii bonus pentru anumiți furnizori și anumite jocuri',
    contribution: 'Contribuție, %',
    addPlayersNote: 'Se pot adăuga doar participanți noi. Altfel, aceștia vor fi excluși automat din lista participanților',
    campaignParticipants: 'Participanții la campanie',
    autoActivation: 'Activare automată',
    autoActivationDesc:
      'Permite alocarea bonusului deja activat către jucător. Se recomandă configurarea unui bonus pentru fiecare tip de bonus (Cazinou, Sport, Rotire gratuită) în cazul utilizării activării automate. Altfel, bonusurile vor fi activate aleatoriu',
    promoCodeCaseSensitiveInfo: 'Permite configurarea codului promoțional pentru jucători. Codurile nu conțin cont de scrierea cu majuscule sau minuscule și vor fi convertite în majuscule',
    supportPlayerCancellationGamesInfo: 'Furnizorul permite selectarea jocurilor {{type}} și interzice anularea bonusului după activare',
    referralStatistics: 'Statistici privind recomandările',
    campaignWillBeSavedInBgInfo: 'Pe măsură ce datele campaniei sporesc cantitativ, acestea vor fi salvate în fundal și pot fi accesate în lista cu campanii.',
    contentAndNotification: 'Conținut și notificări',
    contentAndNotificationConfigsRemovedDesc: 'Toate configurările privind conținutul și notificările privind bonusul au fost eliminate. După salvare veți pierde toate configurările anterioare.',
    cloneContentFrom: 'Creați o copie după conținutul bonusului <0>{{bonusName}}</0> în',
    contentLanguages: 'Limbile conținutului',
    notificationInfo:
      'În această zonă, configurăm o notificare pentru jucători legată de alocarea bonusului. Dacă nu se selectează niciun model, jucătorii nu vor primi notificări de pe canalele de comunicare ale brandului.',
    contentInfo:
      'În această zonă, configurăm imaginile și conținutul legat de bonus, utilizând stilul mărcii, care va fi vizibil pentru jucători. Dacă conținutul nu este configurat, sistemul va utiliza conținutul implicit.',
    editContent: 'Editare conținut',
    bonusStatistics: 'Statistici bonus',
    sportBonus: 'Bonus Sport',
    manageContentAndNotification: 'Gestionare conținut și notificări',
    minCashbackAmount: 'Valoare minimă cashback',
    triggerDeviceTypeDesc: 'Verifică tipul de dispozitiv al declanșatorului',
    signUpDeviceTypeDesc: 'Verifică tipul de dispozitiv prin care s-a înregistrat jucătorul',
    viewContentAndNotifications: 'Vizualizare conținut și notificări',
    winType: 'Tip câștig',
    winOptions: 'Tip valoare câștig',
    realMoney: 'Bani reali',
    availableBonus: 'Bonus disponibil',
    wageringBonus: 'Bonus de rulat',
    pauseBonus: 'Întrerupere bonus',
    pauseBonusDesc: 'Dacă opțiunea este activată, jucătorul va putea întrerupe bonusul primit și îl va putea relua mai târziu',
    pausedDate: 'Dată întrerupere',
    resumedDate: 'Dată reluare',
    participantsJoinDesc: 'Permite includerea jucătorilor ca participanți prin acțiunea „Alăturare” pe site-ul web',
    contentAndNotificationSidebarDesc: 'Aici putem alege bonusurile configurate și putem adăuga conținuturi și notificări specifice bonusurilor',
    contentAndNotificationResultAreaDesc: 'Poți vedea conținutul și notificările pentru bonusuri după ce le adaugi și le configurezi în partea laterală.',
    campaignContent: 'Conținut campanie',
    bonusContent: 'Conținut bonusuri',
    campaignContentTabInfo:
      'În această zonă, configurăm imaginile și conținutul legat de campanie, care vor fi vizibile pentru jucători, utilizând limbile mărcii. Conținutul trebuie configurat în limba principală a mărcii.',
    signInDate: 'Data conectării',
    remainingBonusAmount: 'Valoare rămasă a bonusului',
    triggerConditionsResultAreaDesc: 'Puteți vedea Condiția de declanșare după adăugarea și configurarea lor din zona laterală.',
    triggerConditions: 'Condiții de declanșare',
    websiteImage: 'Imagine site web',
    sidebarTriggerConditionDescription: 'Aici putem alege condițiile specifice de declanșare a campaniilor',
    mobileImage: 'Imagine telefon mobil',
    specificTimePeriod: 'Perioadă de verificare specifică',
    weekDays: 'Zile săptămână',
    monthlyDatesConditionDesc: 'Verifică jucătorii la o anumită dată',
    dates: 'Date',
    monthlyDates: 'Date lunare',
    sourceId: 'ID sursă',
    sourceName: 'Nume sursă',
    participationGroupsNote: 'Puteți vedea Grupurile de participare după adăugarea și configurarea lor din zona laterală.',
    participationGroupsDesc: 'Puteți vedea Condițiile de participare după adăugarea și configurarea lor din zona laterală.',
    lParticipationGroups: 'grupuri de participare',
    playerListDesc: 'Permite includerea jucătorilor manual sau prin încărcarea unui CSV',
    playerListAmountDesc: 'Permite includerea jucătorilor cu sume de bonus individuale prin încărcarea listei de jucători',
    allPlayersDesc: 'Permite includerea tuturor jucătorilor ca participant, atunci când declanșatorul este executat',
    promoCodeDesc: 'Permite includerea jucătorilor prin utilizarea codului promoțional generat',
    additionalConditions: 'Condiții suplimentare',
    participationGroups: 'Grupuri de participare',
    participationGroup: 'Grup de participare',
    lParticipationGroup: 'grup de participare',
    playersAreParticipants: 'Jucătorii sunt incluși ca participanți',
    bonusesDesc: 'Poți vedea Bonusurile după adăugarea și configurarea lor din zona laterală.',
    gameConfig: 'Configurație joc',
    recurringConditionDesc: 'Verifică declanșatorii jucătorilor în anumite zile sau date ale lunii',
    conditionTypes: 'Tipuri de condiții',
    lTriggerCondition: 'condiție de declanșare',
    bonusAbuseInfoNote: 'După activarea acestei casete de selectare, jucătorii nu vor putea să plaseze decât un singur pariu concomitent din soldul bonus pentru evenimentul respectiv',
    productSelection: 'Selecție de produse',
    casinoGameConfig: 'Configurație jocuri de cazinou',
    contents: 'Conținut',
    lCampaignContent: 'conținut campanie',
    lBonusContent: 'conținut bonusuri',
    units: 'Unități',
    triggerCondition: 'Condiție de declanșare',
    wageringLogic: 'Logică de rulare',
    wageringBaseAmount: 'Valoare de bază de rulat',
    wageringCoefficient: 'Coeficient rulare',
    wageringCount: 'Contor rulare',
    calculationLogic: 'Logică de calcul',
    wageringParticipation: 'Participare la rulare',
    firstWalletDebited: 'Primul portofel debitat',
    lockAmount: 'Blocare sumă',
    allowNonMatchingBets: 'Permitere Pariuri neconfirmate',
    triggerBasedConfig: 'Configurație pe bază de declanșator',
    lUnit: 'unitate',
    unitsDesc: 'Puteți vedea Unitățile după adăugarea și configurarea lor din zona laterală.',
    navigationItemsDisabledInfo: 'Elementele de navigare vor deveni active după salvarea secțiunii generale a campaniei.',
    sidebarTriggerConditionInfo: 'Puteți vedea Condițiile de declanșare după adăugarea și configurarea lor din zona laterală',
    summary: 'Rezumat',
    offers: 'Oferte',
    offersContentTabInfo:
      'În această zonă, configurăm imaginile și conținutul legat de campanie, care vor fi vizibile pentru jucători, utilizând limbile mărcii. Conținutul trebuie configurat în limba principală a mărcii.',
    sidebarUnitInfo: 'Puteți vedea Unitățile după adăugarea și configurarea lor din zona laterală',
    lContent: 'conținut',
    offersContent: 'Conținut unități (oferte)',
    lOfferContent: 'conținut ofertă',
    unit: 'Unitate',
    totalOdds: 'Total cote',
    minTotalOdd: 'Total cote minime',
    maxTotalOdd: 'Total cote maxime',
    sportEventConfig: 'Configurație eveniment sportiv',
    lockType: 'Tip de blocare',
    gamesConditionDesc: 'Verifică declanșatorul jocurilor lansate',
    transactionAmount: 'Valoare tranzacție',
    unitName: 'Denumire unitate',
    productType: 'Tip de produs',
    isUsedInUnit: 'Utilizat în unitate',
    minBetTriggerAmount: 'Valoare minimă a pariului pentru declanșare',
    bonusAmount: 'Valoare bonus',
    point: 'Punct',
    contributedFrom: 'Contribuit de la',
    contributedFromDescription: 'Aici putem stabili ce pariuri trebuie să participe la cifra de rulat cumulată a pariurilor',
    sportBetsConditionDesc: 'Verifică pariurile jucătorilor pe anumite evenimente sportive',
    casinoBetsConditionDesc: 'Verifică pariurile jucătorilor pe anumite jocuri de cazinou',
    betAmountConfigFixedAmountDesc:
      'Permite furnizarea unei sume de bonus care este fixă, pentru fiecare valută (După valută). În cazul unei Sume fixe, putem configura condițiile Pariului folosind opțiunile Simplu sau Interval',
    amountConfigFromBetDesc: 'Permite calcularea valorii bonusului ca procent din pariu (valabil pentru toate valutele)',
    fromBet: '% din pariu',
    bonusOptionsDesc5: 'Jucătorii vor primi bonusuri pentru toate pariurile din perioada de declanșare',
    gameInfo: 'Tip(uri) de asistență selectat(e) pentru joc: <0>{{tip}}</0>',
    freeGameType: 'Tip de joc gratuit',
    combinations: 'Combinații',
    involvement: 'Implicare',
    sports: 'Sporturi',
    tournaments: 'Turnee',
    events: 'Evenimente',
    markets: 'Piețe',
    allEventsAreSelected: 'Toate evenimentele sunt selectate',
    allMarketsAreSelected: 'Toate piețele sunt selectate',
    customSelection: 'Selecție personalizată',
    live: 'Live',
    lEvents: 'evenimente',
    lMarkets: 'piețe',
    lMarket: 'piață',
    lEvent: 'eveniment',
    lTournaments: 'turnee',
    entitiesLimitInfo: 'Numărul max. de entități (turnee, evenimente, piețe) este {{număr}}. Selecția contorizează în cazul unei selecții personalizate.',
    fromBetAmount: '% din valoarea pariului',
    gamesCount: 'Număr jocuri',
    freeSpinGamesInfo: 'Selectare furnizor pentru a obține jocuri',
    previousUnit: 'Unitate anterioară',
    previousUnitInfo: 'Unitatea curentă va fi alocată de îndată ce bonusul unității selectate este epuizat. Acest lucru se aplică numai unităților din același grup de participanți',
    eventType: 'Tipul evenimentului',
    complainer: 'Reclamant',
    hashtagDescription: 'Descrierea hashtag-ului',
    lPlayerBonus: 'bonus jucător',
    lPlayersBonuses: 'bonusuri jucători',
    playerBonus: 'Bonus jucător',
    playersBonuses: 'Bonusuri jucători',
    eligibleBets: 'Pariuri eligibile',
    eligibleBetsStatus: 'Stare pariuri eligibile',
    betBuilder: 'Proiectant pariu',
    betBuilderTotalOdds: 'Total cote proiectant pariu',
    betBuilderMultiSelectionNum: 'Nr. selecție multiplă proiectant pariu',
    minBetBuilderTotalOdd: 'Total min. cote proiectant pariu',
    maxBetBuilderTotalOdd: 'Total max. cote proiectant pariu',
    lUnitBonuses: 'bonusuri unitate',
    partialCancel: 'Anulare parțială',
    addPlayers: 'Adăugare jucători',
    pointEnhancement: 'Amplificare puncte',
    pointEnhancementInfo: 'Activați această opțiune pentru stabilirea numărului de pariuri pentru a câștiga bonus pentru fiecare punct.',
    betCount: 'Număr pariu',
    bonusOptionsDesc6: 'Jucătorii vor obține bonusuri pentru întrunirea pariului minim și a cerințelor de calcul pentru un singur punct și o perioadă de timp stabilită.',
    lobbyWidgetGameSegmentInfo: 'Modificările din segmentul de joc nu vor afecta entitatea deja creată. În listă vor apărea doar acele jocuri care sunt comune pentru segmentul și lobby-ul selectate',
    wageringParticipationInfo: 'Pariurile de tip Retragere nu vor fi incluse în calculul cifrei de rulat.',
    bonusAbuseInfo: {
      1: 'După activarea acestei casete de validare, jucătorii nu vor mai putea paria din soldul bonus pe același eveniment de mai multe ori',
      2: 'După activarea acestei casete de validare, jucătorii nu vor mai putea paria din soldul bonus pe același eveniment de mai multe ori.'
          + ' În cazul bonusului cu miză reală, dacă jucătorul plasează un pariu din soldul real de mai multe ori pe același eveniment care îndeplinește cerințele bonusului, al doilea pariu nu ar trebui să fie reducă rulajul parierii',
    },
    code: 'Cod',
    dynamicDesc: 'Permite generarea unui comision pe baza unor indicatori financiari, fie pentru fiecare referent în parte, fie în mod colectiv pentru toți referenții',
    progressiveDesc: 'Permite stabilirea unor intervale specifice de comision în funcție de numărul de jucători recomandați',
    prizeDesc: 'Permite stabilirea unor intervale de comision pentru a acorda o recompensă unică fixă jucătorilor nou recomandați care îndeplinesc condițiile necesare.',
    supportPlayerCancellationGameInfo1: 'Furnizorul permite anularea de către jucător',
    supportPlayerCancellationGameInfo2: 'Furnizorul nu permite anularea de către jucător',
    bonusContentDesc: 'Puteți vedea {{type}}pentru bonusuri după ce le-ați adăugat și configurat din zona laterală.',
    noUnitWithEmptyContentForLanguage: 'În această limbă nu există nicio unitate cu conținut gol.',
    noBonusWithEmptyContent: 'Nu există bonus cu conținutul gol.',
    currentStage: 'Etapă curentă',
    inProcess: 'În curs de procesare',
    placedBetAmount: 'Suma pariului plasat',
    totalBetCount: 'Număr de pariuri totale',
    placedBetCount: 'Număr de pariuri plasate',
    periodDate: 'Datele perioadei',
    grantBonus: 'Acordare bonus',
    bonusWillBeGrantedAfterWageringCompleted: 'Bonusul selectat va fi acordat după ce vor fi îndeplinite cerințele de pariere pentru bonusul actual',
    infoMaxRedeemAmount: 'Suma maximă care poate fi valorificată este {{value}}',
    infoSpinsAmount: 'Suma rotirilor este {{value}}',
    infoCombinationValues: 'Valorile combinate sunt {{value}}',
    participationType: 'Tip de participare',
    resetToDefault: 'Resetare la setările implicite',
    amountRange: 'Interval sumă',
    considerAsBTag: 'Considerare drept BTAG',
    considerAsBTagInfo: 'Această opțiune va suprascrie câmpul „btag” dacă codul promoțional corespunde celui introdus de jucător',
    byPlayerID: 'În funcție de ID-ul jucătorului',
    byTags: 'În funcție de etichete',
    bySegments: 'În funcție de segmente',
    dynamicSelection: 'Selecție dinamică',
    staticSelection: 'Selecție statică',
    deleted: 'Șters',
    onJoinUnitInfo: 'Precizează dacă această configurație utilizează sau nu propriile setări de participare',
    riskyGameExclusionInfo: 'Modificările aduse riscurilor din joc nu vor afecta entitățile deja create',
    conditionsInfo: 'Sunt eligibili doar jucătorii nou recomandați. Fiecare jucător recomandat trebuie să îndeplinească toate condițiile selectate pentru a genera un comision referentului.',
    minWithdrawalAmount: 'Suma minimă de retragere',
    withdrawalAmountConfigFixedAmountDesc: 'Permite stabilirea unei sume fixe pentru bonus pentru fiecare monedă (în funcție de monedă). În cazul unei sume fixe, putem configura condițiile de retragere folosind opțiunile „Individual” sau „Interval”',
    fromWithdrawal: '% din retragere',
    amountConfigFromWithdrawalDesc: 'Permite calcularea valorii bonusului ca procent din suma retrasă (valabil pentru toate monedele)',
    fromWithdrawalAmount: '% din suma retrasă',
    sourceTypes: 'Tipuri de surse',
    unitsAllocation: 'Alocarea unităților',
    unitsAllocationInfo: 'Selectați opțiunea „Un singur declanșator – toate unitățile” dacă doriți ca jucătorul să primească toate unitățile create cu singur declanșator. Asigurați-vă că setați condițiile pentru fiecare unitate în mod similar, astfel încât să fie toate alocate simultan și să treacă toate verificările.',
    providers: 'Furnizori',
  },
  bg: {},
  el: {
    maxBonusAmount: 'Μέγ. ποσό μπόνους',
    minDepositAmount: 'Ελάχ. ποσό κατάθεσης',
    maxRedeemAmount: 'Μέγ. ποσό εξαργύρωσης',
    minBetAmount: 'Ελάχ. ποσό στοιχήματος',
    contributionPercent: 'Συνεισφορά, %',
    cashbackPercent: 'Επιστροφή μετρητών, %',
    bonusType: 'Τύπος μπόνους',
    currencies: 'Νομίσματα',
    triggerPeriod: 'Περίοδος ενεργοποίησης',
    activationPeriod: 'Περίοδος ενεργοποίησης',
    playthrough: 'Playthrough',
    wageringPeriod: 'Περίοδος στοιχηματισμού',
    issueBonus: 'Έκδοση μπόνους',
    bonusId: 'Αναγνωριστικό μπόνους',
    promoName: 'Όνομα προωθητικής ενέργειας',
    promoCode: 'Κωδικός προώθησης',
    promoCodeType: 'Τύπος κωδικού προώθησης',
    lPromoCode: 'κωδικός προώθησης',
    maxUseCount: 'Αριθμός μέγ. χρήσης',
    dateUsed: 'Ημερομηνία σε χρήση',
    promotionEndDate: 'Ημερομηνία λήξης προωθητικής ενέργειας',
    issuedBy: 'Εκδόθηκε από',
    canceledBy: 'Ακυρώθηκε από',
    mobileVerified: 'Επαληθευμένο κινητό',
    identityVerified: 'Επαληθευμένη ταυτότητα',
    emailVerified: 'Επαληθευμένο email',
    disconnectedBy: 'Αποσυνδέθηκε από',
    disconnectTrigger: 'Αποσύνδεση ενεργοποίησης',
    turnoverAmount: 'Ποσό κύκλου εργασιών',
    remainingTurnover: 'Υπολειπόμενο τζιράρισμα',
    bonusStatus: 'Κατάσταση μπόνους',
    triggeredDate: 'Ημερομηνία ενεργοποίησης',
    providerMayDisabled: 'Ο πάροχος μπορεί να έχει απενεργοποιηθεί.',
    gameMayDisabled: 'Το παιχνίδι μπορεί να έχει απενεργοποιηθεί.',
    maxCashbackAmount: 'Μέγ. ποσό επιστροφής μετρητών',
    cashbackId: 'Αναγνωριστικό επιστροφής μετρητών',
    cashbackName: 'Όνομα επιστροφής μετρητών',
    cashbackType: 'Τύπος επιστροφής μετρητών',
    calculationTime: 'Χρόνος υπολογισμού',
    transferType: 'Τύπος μεταφοράς',
    platforms: 'Πλατφόρμες',
    platform: 'Πλατφόρμα',
    restrictedPlayers: 'Παίκτες υπό περιορισμό',
    restrictedCountries: 'Χώρες υπό περιορισμό',
    totalBet: 'Συνολικό στοίχημα',
    totalWin: 'Συνολικό κέρδος',
    accumulated: 'Συσσωρευμένο',
    accumulatedCashBack: 'Συσσωρευμένη επιστροφή μετρητών',
    transferredCashBack: 'Επιστροφή μετρητών που μεταφέρθηκε',
    commission: 'Προμήθεια',
    commissions: 'Προμήθειες',
    lCommissions: 'Προμήθειες',
    commissionPercent: 'Προμήθεια, %',
    manageLimits: 'Διαχείριση ορίων',
    referees: 'Παραπεμπόμενοι',
    setCommissions: 'Ορισμός προμηθειών',
    referralBonusId: 'Αναγνωριστικό μπόνους παραπομπής',
    lReferralBonus: 'μπόνους παραπομπής',
    referralBonus: 'Μπόνους παραπομπής',
    calculationPeriodTime: 'Χρόνος περιόδου υπολογισμού',
    commissionFrom: 'Προμήθεια από',
    referrerId: 'Αναγνωριστικό παραπέμποντος',
    accumulatedCommission: 'Συσσωρευμένη προμήθεια',
    nextCalculationDate: 'Ημερομηνία επόμενου υπολογισμού',
    transferredCommission: 'Προμήθεια που μεταφέρθηκε',
    commissioningAmount: 'Ποσό προμήθειας',
    convertedTo: 'Μετατράπηκε σε',
    convertedAmount: 'Μετατραπέν ποσό',
    redeemedAmount: 'Εξαργυρωμένο ποσό',
    winAmount: 'Ποσό κέρδους',
    lossAmount: 'Ποσό απώλειας',
    cashbackAmount: 'Ποσό επιστροφής μετρητών',
    includeActiveBonuses: 'Να συμπεριληφθούν ενεργά μπόνους',
    lBonus: 'μπόνους',
    bonus: 'Μπόνους',
    casino: 'Καζίνο',
    invalidPlayerCount: 'Μη έγκυρος αριθμός παικτών στην αναφορά',
    totalPlayersUpdated: 'Σύνολο παικτών που θα ενημερωθούν',
    lBonusTemplate: 'πρότυπο μπόνους',
    bonusTemplate: 'Πρότυπο μπόνους',
    invalidKeys: 'Μη έγκυρα κλειδιά',
    playersMissingCurrencyReason: 'Το νόμισμα λογαριασμού παίκτη δεν έχει διαμορφωθεί',
    playersRestrictedReason: 'Ο παίκτης βρίσκεται σε κατάσταση περιορισμένου λογαριασμού',
    missingCurrency: 'Δεν έχει οριστεί νόμισμα',
    missingCurrencyReason: 'Το νόμισμα λογαριασμού παίκτη δεν έχει διαμορφωθεί',
    issue: 'Έκδοση',
    platformType: 'Τύπος πλατφόρμας',
    amountConfig: 'Διαμόρφωση ποσού',
    paymentMethods: 'Μέθοδοι πληρωμής',
    first: 'Πρώτο',
    second: 'Δεύτερο',
    third: 'Τρίτο',
    fourth: 'Τέταρτο',
    fifth: 'Πέμπτο',
    fromDepositAmount: '% από το ποσό κατάθεσης',
    fromDeposit: '% από την κατάθεση',
    betType: 'Τύπος στοιχήματος',
    minWageringOdd: 'Ελάχ. απόδοση στοιχηματισμού',
    minWageringOddType: 'Τύπος ελάχ. απόδοσης στοιχηματισμού',
    bonusTemplateName: 'Όνομα προτύπου μπόνους',
    bonusTemplateId: 'Αναγνωριστικό προτύπου μπόνους',
    categories: 'Κατηγορίες',
    bonusOptionsDesc: 'Το μπόνους εγγραφής είναι ένα ποσό που καταβάλλεται σε έναν νέο παίκτη',
    bonusOptionsDesc1: 'Οι παίκτες θα λάβουν μπόνους για όλες τις καταθέσεις στην περίοδο ενεργοποίησης',
    bonusOptionsDesc2: 'Ο χρήστης μπορεί να επιλέξει για πόσες καταθέσεις στην περίοδο ενεργοποίησης θα λάβουν οι παίκτες μπόνους',
    bonusOptionsDesc3: 'Οι παίκτες θα λάβουν μπόνους για την πρώτη κατάθεση κάθε ημέρας στην περίοδο ενεργοποίησης',
    createNewTemplate: 'Δημιουργία νέου προτύπου',
    selectBonusType: 'ΕΠΙΛΟΓΗ ΤΥΠΟΥ ΜΠΟΝΟΥΣ',
    selectBonusTrigger: 'ΕΠΙΛΟΓΗ ΕΝΕΡΓΟΠΟΙΗΣΗΣ ΜΠΟΝΟΥΣ',
    numberOfDeposits: 'Αριθμός καταθέσεων',
    fixedAmount: 'Σταθερό ποσό',
    sport: 'Άθλημα',
    rules: 'Κανόνες',
    rule: 'Κανόνας',
    noRules: 'Δεν υπάρχουν κανόνες για εμφάνιση',
    relatedBonusId: 'Αναγνωριστικό σχετικού μπόνους',
    endDateTime: 'Ημερομηνία/ώρα λήξης',
    noEndDate: 'Δεν υπάρχει ημερομηνία λήξης',
    selectGames: 'Επιλογή παιχνιδιών',
    activities: 'Δραστηριότητες',
    discardAccumulatedCommissions: 'Απόρριψη συσσωρευμένων προμηθειών',
    playersInAnotherReferral: 'Οι παίκτες έχουν ήδη άλλο μπόνους παραπομπής',
    allPlayersSelected: 'Όλοι οι παίκτες έχουν επιλεγεί',
    datesAndPlayers: 'Ημερομηνίες και παίκτες',
    special: 'Ειδικό',
    highRisk: 'Υψηλού κινδύνου',
    mediumRisk: 'Μετρίου κινδύνου',
    countOfReferees: 'Αριθμός παραπεμπόμενων',
    playerFromParticipants: 'παίκτης από συμμετέχοντες',
    signUp: 'Εγγραφή',
    bonusNameExternal: 'Όνομα μπόνους (Εξωτερικό)',
    noEndData: 'Δεν υπάρχει ημερομηνία λήξης',
    minNumberOfSelections: 'Ελάχ. αριθμός επιλογών',
    dateTriggered: 'Ημερομηνία ενεργοποίησης',
    referralBonusName: 'Όνομα μπόνους παραπομπής',
    refereesId: 'Αναγνωριστικό παραπεμπόμενων',
    refereeId: 'Αναγνωριστικό παραπεμπόμενου',
    realWallet: 'Πορτοφόλι πραγματικών χρημάτων',
    details: 'Στοιχεία',
    numberOfDepositsInfo: 'Επιλέξτε τις καταθέσεις για τις οποίες οι παίκτες πρέπει να λάβουν μπόνους κατά την περίοδο ενεργοποίησης.',
    numberOfDepositsTabIndex: {
      1: 'η',
      2: 'η',
      3: 'η',
      default: 'η',
    },
    cloneUnit: 'Κλωνοποίηση μονάδας',
    cloneBonus: 'Μπόνους κλωνοποίησης',
    cloneSettingsTo: 'Κλωνοποίηση ρυθμίσεων σε',
    balanceConfig: 'Διαμόρφωση υπολοίπου',
    usedCount: 'Αριθμός χρησιμοποιημένων',
    lRule: 'κανόνας',
    referralParticipants: 'Συμμετέχοντες παραπομπής',
    theCashback: 'Η επιστροφή μετρητών',
    playersCashBack: 'Επιστροφή μετρητών παικτών',
    theBonus: 'Το μπόνους',
    wageringTurnover: 'Τζιράρισμα στοιχηματισμού',
    playersWontBeAble: 'Οι παίκτες δεν θα μπορούν να κάνουν ανάληψη ή να ποντάρουν το εκδοθέν ποσό μπόνους σε παιχνίδια P2P.',
    calculationFrom: 'ΥΠΟΛΟΓΙΣΜΟΣ ΑΠΟ',
    lCalculationFrom: 'Υπολογισμός από',
    createNewCashback: 'Δημιουργία νέας επιστροφής μετρητών',
    cashbackFromBetsDesc: 'Δίνει επιστροφή μετρητών στο θετικό αποτέλεσμα της διαφοράς στοιχήματος - κέρδους στην περίοδο υπολογισμού.',
    cashbackNetDepositsDesc: 'Δίνει επιστροφή μετρητών στο θετικό αποτέλεσμα της διαφοράς καταθέσεων - αναλήψεων στην περίοδο υπολογισμού.',
    netDepositAmount: 'Καθαρό ποσό κατάθεσης',
    participateRule: 'Κανόνας συμμετοχής',
    totalDeposit: 'Συνολική κατάθεση',
    totalWithdrawal: 'Συνολική ανάληψη',
    totalBonuses: 'Συνολικά μπόνους',
    manageParticipation: 'Διαχείριση συμμετοχής',
    restrictionFor: 'Υπό περιορισμό για',
    availableFor: 'Διαθέσιμο για',
    sportWageringBonuses: 'Μπόνους αθλητικού στοιχηματισμού',
    casinoWageringBonuses: 'Μπόνους στοιχηματισμού καζίνο',
    otherBonuses: 'Άλλα μπόνους',
    finishedBonusesCount: 'Aριθμός μπόνους που τελείωσαν',
    totalRedeemBonuses: 'Συνολικά εξαργυρωμένα μπόνους',
    referralCommission: 'Προμήθεια παραπομπής',
    maxPossibleTransfer: 'Μέγ. πιθανή μεταφορά',
    playThroughRequired: 'Απαιτείται playthrough',
    matchingRegistrationIP: 'Ο παραπέμπων έχει παραπεμπόμενους με ίδιες IP εγγραφής',
    sameRegistrationIP: 'Ο παραπέμπων και ο παραπεμπόμενος έχουν την ίδια IP εγγραφής',
    amountColumnInfo: 'Το εύρος κυμαίνεται από την τιμή της αριστερής στήλης, έως την τιμή της δεξιάς στήλης, αλλά δεν περιλαμβάνει την τιμή της δεξιάς στήλης',
    selectedGames: 'Επιλεγμένα παιχνίδια',
    minAmount: 'Ελάχ. Ποσό',
    step: 'Βήμα',
    gamesInfo: 'Ο πάροχος επιτρέπει την επιλογή παιχνιδιών {{type}}',
    lSingle: 'μονό',
    lMultiple: 'πολλαπλό',
    allowWithdrawal: 'Να επιτρέπεται η ανάληψη',
    campaignName: 'Όνομα καμπάνιας',
    noTrigger: 'Χωρίς ενεργοποίηση',
    cancelBonusWhenWithdrawal: 'Ακύρωση μπόνους (Κατά την ανάληψη)',
    number: 'Αριθμός',
    participant: 'Συμμετέχων',
    depositsAmountConfigInfo: 'Σε αυτή την περιοχή, διαμορφώνουμε το ποσό μπόνους και ορίζουμε περιορισμούς ανά νόμισμα',
    bonusBetConfig: 'Διαμόρφωση στοιχήματος μπόνους',
    single: 'Μονό',
    ranges: 'Εύρη',
    nextValue: 'Επόμενη τιμή',
    lPrevValue: 'προηγούμενη τιμή',
    addRanges: 'Προσθήκη εύρους',
    lifetimePeriod: 'Περίοδος διάρκειας ζωής',
    resetRanges: 'Επαναφορά εύρους',
    lCampaign: 'καμπάνια',
    multi: 'Πολλαπλό',
    option: 'Επιλογή',
    triggers: 'Ενεργοποιήσεις',
    viewRanges: 'Προβολή εύρους',
    depositNumber: 'Αριθμός κατάθεσης',
    bonusResultAreaDesc: 'Μπορείτε να δείτε τα Μπόνους αφού τα προσθέσετε και τα διαμορφώσετε από την πλαϊνή περιοχή.',
    participantsResultAreaDesc: 'Μπορείτε να δείτε τους Συμμετέχοντες αφού τους προσθέσετε και τους διαμορφώσετε από την πλαϊνή περιοχή.',
    editTriggerDisabled: 'Δεν μπορείτε να επεξεργαστείτε την ενεργοποίηση τώρα',
    multiOrSingleBonus: 'Περιγραφή μονού και πολλαπλού μπόνους',
    editParticipantsDisabled: 'Δεν μπορείτε να επεξεργαστείτε τους συμμετέχοντες τώρα',
    configureParticipants: 'Διαμόρφωση συμμετεχόντων',
    selectTriggerParticipantsBonuses: 'Επιλέξτε την ενεργοποίηση, Επιλέξτε συμμετέχοντες, Διαμορφώστε τα μπόνους',
    toMakeSureCampaignSuccessful: 'Για να βεβαιωθείτε ότι η καμπάνια σας είναι επιτυχημένη',
    participantType: 'Τύπος συμμετέχοντος',
    triggerType: 'Τύπος ενεργοποίησης',
    cancelPromotion: 'Ακύρωση προωθητικής ενέργειας',
    createCampaign: 'Δημιουργία καμπάνιας',
    multiOrSinglePromocodeType: 'Περιγραφή τύπου μονού και πολλαπλού κωδικού προώθησης',
    missingAmount: 'Δεν έχει οριστεί ποσό',
    multiSelectionNum: 'Αριθμός επιλογής πολλαπλών',
    playThroughRequiredDesc:
      'Σε περίπτωση που αυτή η επιλογή είναι ενεργοποιημένη, η τιμή του πεδίου Playthrough θα πρέπει να είναι ίση με τον αριθμό που έχει οριστεί. Εάν είναι απενεργοποιημένη, θα πρέπει να είναι ίση ή μεγαλύτερη από',
    playThroughInputDesc:
      'Επιτρέπει να καθοριστεί εάν ένας παίκτης πρέπει να στοιχηματίσει το μπόνους όσες φορές ορίζεται στη διαμόρφωση του playthrough για να μπορέσει να τελειώσει το μπόνους (εκτός από 0 στο τζιράρισμα)',
    cancelBonusWhenWithdrawalDesc: 'Επιτρέπει την αυτόματη ακύρωση του μπόνους εάν ο παίκτης κάνει τη συναλλαγή ανάληψης κατά τη διάρκεια των περιόδων ενεργοποίησης και λήξης του μπόνους',
    triggerOption: 'Επιλογή ενεργοποίησης',
    campaign: 'Καμπάνια',
    periodDescription: 'Εδώ μπορούμε να ορίσουμε σε ποια περίοδο θα καθορίσουμε τον αριθμό κατάθεσης',
    singleCountTypeDesc:
      'Επιτρέπει τον ορισμό μόνο ενός μπόνους αλλά με διαφορετικά ποσά για κάθε αριθμό κατάθεσης, που είναι χρήσιμο σε περιπτώσεις που δεν χρειάζεται να διαμορφώσουμε διάφορα μπόνους με τον ίδιο τύπο μπόνους',
    multiCountTypeDesc:
      'Επιτρέπει τον ορισμό διαφορετικών τύπων μπόνους με διαφορετικές διαμορφώσεις ποσών για κάθε αριθμό κατάθεσης. Σε αυτή την περίπτωση, επιλέγουμε τον αριθμό κατάθεσης (πιθανές τιμές 1, â€¦, 100) για κάθε τύπο μπόνους',
    disconnectTriggerDesc:
      'Εάν αυτή η λειτουργία είναι ενεργοποιημένη και ο παίκτης έχει λάβει τουλάχιστον ένα μπόνους αλλά δεν πληροί τις προϋποθέσεις μπόνους, τότε το σύστημα θα τον αποσυνδέσει από την καμπάνια και ο παίκτης δεν θα λαμβάνει πλέον νέα μπόνους',
    participantsPlayerDesc: 'Επιτρέπει τη συμπερίληψη παικτών μεταφορτώνοντας CSV ή μη αυτόματα',
    participantsPlayerListAmountsDesc: 'Επιτρέπει τη συμπερίληψη παικτών με ατομικά ποσά μπόνους μεταφορτώνοντας τη λίστα παικτών',
    participantsPromoCodeDesc: 'Επιτρέπει τη συμπερίληψη παικτών χρησιμοποιώντας τον κωδικό προώθησης που δημιουργήθηκε',
    participantsConditionsDesc: 'Επιτρέπει τη συμπερίληψη παικτών ενεργοποιώντας συγκεκριμένες προϋποθέσεις',
    countryConditionDesc: 'Ελέγχει τη χώρα των παικτών',
    verifyConditionDesc: 'Ελέγχει το επίπεδο επαλήθευσης των παικτών',
    weekDaysConditionDesc: 'Ελέγχει τους παίκτες σε συγκεκριμένες ημέρες',
    accountStatusConditionDesc: 'Ελέγχει την κατάσταση του λογαριασμού των παικτών',
    sportStatusConditionDesc: 'Ελέγχει την κατάσταση των παικτών στο Sportsbook',
    segmentConditionDesc: 'Ελέγχει τα τμήματα των οποίων αποτελούν μέρη οι παίκτες',
    tagConditionDesc: 'Ελέγχει τις ετικέτες που έχουν ανατεθεί στους παίκτες',
    paymentsConditionDesc: 'Ελέγχει τις πληρωμές συναλλαγών των παικτών',
    configModeAlreadyOpened: 'Έχετε ανοίξει ήδη τη λειτουργία διαμόρφωσης',
    bonusBetConfigInfo: 'Επιτρέπει τη διαμόρφωση των στοιχημάτων μπόνους. Το στοίχημα θα πρέπει να αντιστοιχίζεται στα αποθηκευμένα κριτήρια για να θεωρείται στοίχημα μπόνους',
    amountConfigSingleDesc: 'Να επιτρέπεται η ρύθμιση παραμέτρων μεμονωμένων ποσών ανά νόμισμα',
    amountConfigRangesDesc: 'Να επιτρέπεται η ρύθμιση παραμέτρων ποσών πολλαπλού εύρους για κάθε νόμισμα',
    depositAmountConfigFixedAmountDesc:
      'Επιτρέπει την παροχή ενός ποσού μπόνους που είναι σταθερό για κάθε νόμισμα (Ανά νόμισμα). Στην περίπτωση ενός σταθερού ποσού, μπορούμε να διαμορφώσουμε τις προϋποθέσεις κατάθεσης χρησιμοποιώντας τις επιλογές Μονό ή Εύρος',
    amountConfigFromDepositDesc: 'Επιτρέπει την καταμέτρηση του ποσού του μπόνους ως ποσοστό από την κατάθεση (Γενικά για όλα τα νομίσματα)',
    expirationPeriod: 'Περίοδος λήξης',
    noDataAlt: 'Χωρίς ενεργοποίηση, Συμμετέχοντες, Μπόνους επιλέχτηκαν',
    successPlayers: 'Οι παίκτες μπορούν να λάβουν μπόνους',
    errorPlayers: 'Δεν έχει οριστεί νόμισμα',
    amountConfigAreaInfo: 'Σε αυτή την περιοχή, διαμορφώνουμε το ποσό μπόνους και ορίζουμε περιορισμούς ανά νόμισμα',
    availableCount: 'Διαθέσιμο πλήθος',
    availablePromoCodes: 'Διαθέσιμοι κωδικοί προώθησης',
    downloadAvailableCodes: 'Λήψη διαθέσιμων κωδικών',
    lengthOfCodes: 'Μήκος κωδικών',
    lNextValue: 'επόμενη τιμή',
    freeSpinAmountConfigInfo: 'Επιλογή παρόχου και πλήθους γραμμών για λήψη περιορισμών ποσού',
    freeSpinRequiredAllGames: 'Αυτός ο πάροχος υποστηρίζει δωρεάν περιστροφή σε όλα τα παιχνίδια',
    maxWinAmount: 'Ποσό μέγ. κέρδους',
    line: 'Γραμμή',
    casinoBonus: 'Μπόνους καζίνο',
    campaignStatus: 'Κατάσταση καμπάνιας',
    participantsAllPlayersDesc: 'Επιτρέπει τη συμπερίληψη όλων των παικτών ως συμμετέχοντες όταν εκτελείται η ενεργοποίηση',
    participantsAllPlayersMainAreaDesc: 'Το σύστημα θα συμπεριλάβει όλους τους παίκτες ως συμμετέχοντες μετά την εκτέλεση της ενεργοποίησης.',
    spinsAmount: 'Ποσό περιστροφών',
    maxTriggerCount: 'Μέγιστο πλήθος ενεργοποιήσεων',
    maxTriggerCountInfo: 'Αυτό το πεδίο θα επιτρέψει τον ορισμό του μέγιστου πλήθους επιτυχημένων ενεργοποιήσεων ανά παίκτη',
    freeSpinCurrencyInfo: 'Το σύστημα περιλαμβάνει νομίσματα που υποστηρίζονται από την επωνυμία και τον επιλεγμένο πάροχο',
    amountRanges: 'Εύρος ποσού (Από - Έως)',
    amountRangesHint: 'Το ποσό στο πεδίο «Από» στο «Εύρος ποσού» περιλαμβάνεται σε αυτό το εύρος, ενώ το ποσό στο πεδίο «Έως» δεν περιλαμβάνεται στο εύρος.',
    numberOfPlayers: 'Αριθμός παικτών (Από - Έως)',
    numberOfPlayersHint: 'Ο αριθμός στο πεδίο «Από» στο «Αριθμός παικτών» περιλαμβάνεται σε αυτό το εύρος, ενώ ο αριθμός στο πεδίο «Έως» δεν περιλαμβάνεται στο εύρος.',
    numberOfReferees: 'Αριθμός παραπεμπόμενων (Από - Έως)',
    numberOfRefereesHint: 'Ο αριθμός στο πεδίο «Από» στο «Αριθμός παραπεμπόμενων» περιλαμβάνεται σε αυτό το εύρος, ενώ ο αριθμός στο πεδίο «Έως» δεν περιλαμβάνεται στο εύρος.',
    campaignStatistics: 'Στατιστικά καμπάνιας',
    maxLimitAmount: 'Μέγ. ποσό ορίου',
    netDepositAmountHint: 'Ο αριθμός στο πεδίο «Από» στο «Καθαρό ποσό κατάθεσης» περιλαμβάνεται σε αυτό το εύρος, ενώ ο αριθμός στο πεδίο «Έως» δεν περιλαμβάνεται στο εύρος.',
    gameSegmentInfo: 'Οι αλλαγές στο τμήμα του παιχνιδιού δεν θα επηρεάσουν την ήδη δημιουργημένη οντότητα',
    lCashbackAmounts: 'ποσά επιστροφής μετρητών',
    usedPromoCodes: 'Χρησιμοποιημένοι κωδικοί προώθησης',
    createCrossPlatformCampaign: 'Δημιουργία καμπάνιας μεταξύ πλατφορμών',
    amountConfigAreaCrossCampaignInfo: 'Σε αυτή την περιοχή, ορίζουμε περιορισμούς ανά νόμισμα',
    selectAndConfigureBonuses: 'Επιλογή και διαμόρφωση μπόνους',
    cashbackStatistics: 'Στατιστικά επιστροφής μετρητών',
    freeSpinAmountConfigInfoForSingle: 'Επιλογή παρόχου, πλήθους γραμμών και παιχνιδιού για λήψη περιορισμών ποσού',
    minMaxProviderLimit: 'Ελάχ.-Μέγ. όριο παρόχου',
    spinTotalAmount: 'Συνολικό ποσό περιστροφών',
    minMaxProviderLimitInfo:
      'Το συνολικό ποσό περιστροφών που δημιουργείται από το πλήθος των περιστροφών πολλαπλασιασμένο επί το ποσό των περιστροφών θα πρέπει να βρίσκεται μεταξύ των αναφερόμενων ορίων',
    maxWageringOddType: 'Τύπος μέγ. απόδοσης στοιχηματισμού',
    maxWageringOdd: 'Μέγ. απόδοση στοιχηματισμού',
    wageringOdd: 'Απόδοση στοιχηματισμού',
    winAmountTransferTo: 'Μεταφορά ποσού κέρδους σε',
    allowCashout: 'Να επιτρέπεται η εξαργύρωση',
    allowCashoutInfo: 'Να επιτρέπεται στους παίκτες να χρησιμοποιούν τις λειτουργίες εξαργύρωσης/μερικής εξαργύρωσης για αυτό το μπόνους',
    bonusAbuse: 'Κατάχρηση μπόνους',
    bonusAbuseInfo: {
      0: 'Μετά την ενεργοποίηση αυτού του πλαισίου ελέγχου, οι παίκτες δεν θα μπορούν να στοιχηματίσουν από το Υπόλοιπο μπόνους στο ίδιο γεγονός περισσότερες από μία φορές',
      1: 'Μετά την ενεργοποίηση αυτού του πλαισίου ελέγχου, οι παίκτες δεν θα μπορούν να στοιχηματίσουν από το Υπόλοιπο μπόνους στο ίδιο γεγονός περισσότερες από μία φορές',
      2:
        'Μετά την ενεργοποίηση αυτού του πλαισίου ελέγχου, οι παίκτες δεν θα μπορούν να στοιχηματίσουν από το Υπόλοιπο μπόνους στο ίδιο γεγονός περισσότερες από μία φορές.'
        + ' Στην περίπτωση του Μπόνους πραγματικού στοιχήματος, εάν ο παίκτης στοιχηματίσει από το Πραγματικό υπόλοιπο περισσότερες από μία φορές στο ίδιο γεγονός που ικανοποιεί τις απαιτήσεις του μπόνους, το δεύτερο ποντάρισμα δεν θα πρέπει να μειώνει το τζιράρισμα στοιχηματισμού',
    },
    oneTimeBet: 'Στοίχημα μίας φοράς',
    oneTimeBetInfo: 'Απαιτεί από τους παίκτες να χρησιμοποιήσουν πλήρως το μπόνους',
    minBetAmountPerCategory: 'Ελάχ. ποσό στοιχήματος ανά κατηγορία',
    periodDescriptionEvery:
      'Εδώ μπορούμε να ορίσουμε σε ποια περίοδο θα καθορίσουμε το Μέγιστο πλήθος ενεργοποιήσεων. Εάν δεν έχει διαμορφωθεί, το σύστημα δεν θα περιορίσει την εργασία ενεργοποίησης για έναν παίκτη',
    totalBets: 'Συνολικά στοιχήματα',
    totalWins: 'Συνολικά κέρδη',
    subMethod: 'Δευτερεύουσα μέθοδος',
    paymentConditionPropertiesInfo: 'Το μενού δευτερευόντων μεθόδων είναι ορατό μόνο για τους τρόπους πληρωμής για τους οποίους παρέχεται η λίστα δευτερευόντων μεθόδων από τον σωρευτή.',
    verificationTriggerInfo: 'Η προϋπόθεση θα λειτουργήσει εάν επαληθευτούν όλες οι επιλεγμένες επιλογές, περιλαμβάνεται επίσης η επαλήθευση του πεδίου ενεργοποίησης',
    promoCodesUploadFormatMsg: 'Μπορείτε να μεταφορτώσετε κωδικούς προώθησης. Μόνο η μορφή CSV είναι αποδεκτή',
    amountConfigDepositSingleDesc: 'Να επιτρέπεται η ρύθμιση παραμέτρων μονών % ανά νόμισμα',
    amountConfigDepositRangesDesc: 'Να επιτρέπεται η ρύθμιση παραμέτρων πολλαπλού εύρους % για κάθε νόμισμα',
    canceller: 'Ακυρωτής',
    awardedBonusesDetails: 'Στοιχεία απονεμηθέντων μπόνους',
    bonusLowestAmount: 'Τα χαμηλότερα ποσά μπόνους',
    bonusHighestAmount: 'Τα υψηλότερα ποσά μπόνους',
    totalBonusAmount: 'Συνολικά ποσά μπόνους',
    checkTheListOfRecipients: 'Ελέγξτε την τελική λίστα των παραληπτών',
    allGames: 'Όλα τα παιχνίδια',
    allGamesDesc: 'Επιτρέπει τον ορισμό λοταρίας μπόνους σε όλα τα παιχνίδια της επωνυμίας, όλες οι αλλαγές στα παιχνίδια της επωνυμίας θα ληφθούν υπόψη',
    selectGamesDesc: 'Επιτρέπει τον ορισμό λοταρίας μπόνους σε συγκεκριμένους παρόχους και παιχνίδια',
    contribution: 'Συνεισφορά, %',
    addPlayersNote: 'Είναι δυνατή η προσθήκη μόνο νέων συμμετεχόντων. Διαφορετικά, θα αποκλειστούν αυτόματα από τη λίστα συμμετεχόντων',
    campaignParticipants: 'Συμμετέχοντες καμπάνιας',
    autoActivation: 'Αυτόματη ενεργοποίηση',
    autoActivationDesc:
      'Επιτρέπει την εκχώρηση του μπόνους που έχει ήδη ενεργοποιηθεί στον παίκτη. Συνιστάται η διαμόρφωση ενός μπόνους από κάθε τύπο μπόνους (Καζίνο, Αθλητικά, Δωρεάν Περιστροφή) σε περίπτωση χρήσης της αυτόματης ενεργοποίησης. Διαφορετικά, τα μπόνους θα ενεργοποιηθούν τυχαία',
    promoCodeCaseSensitiveInfo: 'Επιτρέπει τη διαμόρφωση του κωδικού προώθησης για παίκτες. Οι κωδικοί δεν επηρεάζονται από τα πλήκτρα για τους παίκτες και θα μετατραπούν σε κεφαλαία',
    supportPlayerCancellationGamesInfo: 'Ο πάροχος επιτρέπει την επιλογή παιχνιδιών {{type}} και δεν επιτρέπει την ακύρωση του μπόνους μετά την ενεργοποίηση',
    referralStatistics: 'Στατιστικά παραπομπής',
    campaignWillBeSavedInBgInfo: 'Καθώς τα δεδομένα της καμπάνιας είναι μεγαλύτερα, θα αποθηκευτούν στη λειτουργία παρασκηνίου και είναι διαθέσιμα στη λίστα των Καμπανιών.',
    contentAndNotification: 'Περιεχόμενο και ειδοποίηση',
    contentAndNotificationConfigsRemovedDesc: 'Όλες οι διαμορφώσεις Περιεχομένου και ειδοποιήσεων μπόνους αφαιρέθηκαν. Μετά την αποθήκευση, θα χάσετε όλες τις προηγούμενες διαμορφώσεις.',
    cloneContentFrom: 'Κλωνοποίηση περιεχομένου μπόνους <0>{{bonusName}}</0> σε',
    contentLanguages: 'Γλώσσες περιεχομένου',
    notificationInfo:
      'Σε αυτή την περιοχή, διαμορφώνουμε μια ειδοποίηση για τους παίκτες σχετικά με την κατανομή μπόνους. Εάν δεν επιλεγεί κανένα πρότυπο, οι παίκτες δεν θα ειδοποιηθούν με κανάλια επικοινωνίας της επωνυμίας.',
    contentInfo:
      'Σε αυτή την περιοχή, διαμορφώνουμε εικόνες και περιεχόμενο σχετικό με το μπόνους με τις γλώσσες της επωνυμίας, που θα μπορούν να βλέπουν οι παίκτες. Εάν το περιεχόμενο δεν έχει διαμορφωθεί, το σύστημα θα χρησιμοποιήσει το προεπιλεγμένο περιεχόμενο.',
    editContent: 'Επεξεργασία περιεχομένου',
    sidebarParticipantsDescription: 'Εδώ μπορούμε να επιλέξουμε τις προϋποθέσεις επιλογής των συμμετεχόντων στην καμπάνια: Λίστα παικτών, Ποσά λίστας παικτών, Κωδικός προώθησης, Προϋποθέσεις',
    contentAndNotificationSidebarNoBonuses: {
      text1: '',
      text2: 'Η περιοχή Περιεχομένου και ειδοποίησης θα ενεργοποιηθεί μετά τη διαμόρφωση και την αποθήκευση των μπόνους',
    },
    sidebarTriggerDescription: 'Εδώ μπορούμε να ορίσουμε διαμορφώσεις ενεργοποίησης καμπάνιας: Χωρίς ενεργοποίηση, κατάθεση, εγγραφή, επαλήθευση',
    contentAndNotificationSidebarDesc: 'Εδώ μπορούμε να επιλέξουμε διαμορφωμένα μπόνους και να προσθέσουμε συγκεκριμένο περιεχόμενο και ειδοποίηση για το μπόνους',
    contentAndNotificationResultAreaDesc: 'Μπορείτε να δείτε Περιεχόμενο και ειδοποίηση για μπόνους αφού τα προσθέσετε και τα διαμορφώσετε από την πλαϊνή περιοχή.',
    configAlreadySaved: 'Έχετε διαμορφώσει ήδη τα μπόνους ή τους συμμετέχοντες, αφαιρέστε τους για να μπορέσετε να τους επεξεργαστείτε',
    bonusOptionsDesc4: 'Οι παίκτες θα λαμβάνουν μπόνους για συνολικά στοιχήματα που τοποθετήθηκαν σε συγκεκριμένη χρονική περίοδο',
    sidebarBonusesDescription: 'Εδώ μπορούμε να επιλέξουμε διαθέσιμους τύπους μπόνους στις κατηγορίες Αθλητικά, Περιστροφές, Καζίνο και Ειδικά και να τα προσθέσουμε στην καμπάνια',
    bonusStatistics: 'Στατιστικά μπόνους',
    sportBonus: 'Αθλητικό μπόνους',
    manageContentAndNotification: 'Διαχείριση περιεχόμενου και ειδοποιήσεων',
    minCashbackAmount: 'Ελάχ. ποσό επιστροφής μετρητών',
    triggerDeviceTypeDesc: 'Ελέγχει τον τύπο συσκευής της ενεργοποίησης',
    signUpDeviceTypeDesc: 'Ελέγχει τον τύπο συσκευής μέσω της οποίας έκανε εγγραφή ο παίκτης',
    viewContentAndNotifications: 'Προβολή περιεχόμενου και ειδοποιήσεων',
    winType: 'Τύπος κέρδους',
    winOptions: 'Τύπος ποσού κέρδους',
    realMoney: 'Πραγματικά χρήματα',
    availableBonus: 'Διαθέσιμο Μπόνους',
    wageringBonus: 'Μπόνους στοιχηματισμού',
    pauseBonus: 'Διακοπή μπόνους',
    pauseBonusDesc: 'Ενεργοποιώντας την επιλογή, ο παίκτης θα μπορεί να διακόψει το μπόνους που έλαβε και να το συνεχίσει αργότερα',
    pausedDate: 'Ημερομηνία διακοπής',
    resumedDate: 'Ημερομηνία συνέχισης',
    participantsJoinDesc: 'Με αυτόν τον τρόπο οι παίκτες περιλαμβάνονται ως συμμετέχοντες μέσω της ενέργειας «Εγγραφή» στον ιστότοπο',
    campaignContent: 'Περιεχόμενο καμπάνιας',
    bonusContent: 'Μπόνους περιεχόμενο',
    campaignContentTabInfo:
      'Σε αυτή την περιοχή, διαμορφώνουμε εικόνες και περιεχόμενο σχετικό με την καμπάνια με τις γλώσσες της επωνυμίας, που θα μπορούν να βλέπουν οι παίκτες. Είναι υποχρεωτικό να διαμορφωθεί το περιεχόμενο με τη βασική γλώσσα της επωνυμίας',
    signInDate: 'Ημερομηνία σύνδεσης',
    remainingBonusAmount: 'Υπολειπόμενο ποσό μπόνους',
    triggerConditionsResultAreaDesc: 'Μπορείτε να δείτε την Προϋπόθεση Ενεργοποίησης αφού τα προσθέσετε και τα διαμορφώσετε από την πλαϊνή περιοχή.',
    triggerConditions: 'Προϋποθέσεις ενεργοποίησης',
    websiteImage: 'Εικόνα ιστότοπου',
    sidebarTriggerConditionDescription: 'Εδώ μπορούμε να επιλέξουμε τις συγκεκριμένες προϋποθέσεις ενεργοποίησης της καμπάνιας:',
    mobileImage: 'Εικόνα κινητού τηλεφώνου',
    specificTimePeriod: 'Συγκεκριμένη χρονική περίοδος',
    weekDays: 'Καθημερινές',
    monthlyDatesConditionDesc: 'Ελέγχει τη συγκεκριμένη ημερομηνία των παικτών',
    dates: 'Ημερομηνίες',
    monthlyDates: 'Μηνιαίες ημερομηνίες',
    sourceId: 'Αναγνωριστικό πηγής',
    sourceName: 'Όνομα πηγής',
    participationGroupsNote: 'Μπορείτε να δείτε τις Ομάδες Συμμετοχής αφού τις προσθέσετε και τις διαμορφώσετε από την πλαϊνή περιοχή.',
    participationGroupsDesc: 'Μπορείτε να δείτε τις Προϋποθέσεις Συμμετοχής αφού τις προσθέσετε και τις διαμορφώσετε από την πλαϊνή περιοχή.',
    lParticipationGroups: 'ομάδες συμμετοχής',
    playerListDesc: 'Επιτρέπει τη συμπερίληψη παικτών μεταφορτώνοντας CSV ή μη αυτόματα',
    playerListAmountDesc: 'Επιτρέπει τη συμπερίληψη παικτών με ατομικά ποσά μπόνους μεταφορτώνοντας τη λίστα παικτών',
    allPlayersDesc: 'Επιτρέπει τη συμπερίληψη όλων των παικτών ως συμμετέχοντες όταν εκτελείται η ενεργοποίηση',
    promoCodeDesc: 'Επιτρέπει τη συμπερίληψη παικτών χρησιμοποιώντας τον κωδικό προώθησης που δημιουργήθηκε',
    additionalConditions: 'Πρόσθετες Προϋποθέσεις',
    participationGroups: 'Ομάδες Συμμετοχής',
    participationGroup: 'Ομάδα Συμμετοχής',
    lParticipationGroup: 'ομάδα συμμετοχής',
    playersAreParticipants: 'Οι παίκτες περιλαμβάνονται ως συμμετέχοντες',
    bonusesDesc: 'Μπορείτε να δείτε τα Μπόνους αφού τα προσθέσετε και τα διαμορφώσετε από την πλαϊνή περιοχή.',
    gameConfig: 'διαμόρφωση παιχνιδιού',
    recurringConditionDesc: 'Ελέγχει τις ενεργοποιήσεις των παικτών σε συγκεκριμένες ημέρες ή σε μηνιαίες ημερομηνίες',
    conditionTypes: 'Τύποι προϋποθέσεων',
    lTriggerCondition: 'προϋπόθεση ενεργοποίησης',
    bonusAbuseInfoNote: 'Μετά την ενεργοποίηση αυτού του πλαισίου ελέγχου, οι παίκτες δεν θα μπορούν να στοιχηματίσουν από το Υπόλοιπο μπόνους στο ίδιο γεγονός περισσότερες από μία φορές',
    productSelection: 'Επιλογή προϊόντων',
    casinoGameConfig: 'Διαμόρφωση παιχνιδιού καζίνο',
    contents: 'Περιεχόμενα',
    lCampaignContent: 'περιεχόμενο καμπάνιας',
    lBonusContent: 'μπόνους περιεχόμενο',
    units: 'Μονάδες',
    triggerCondition: 'Προϋπόθεση ενεργοποίησης',
    wageringLogic: 'Λογική στοιχηματισμού',
    wageringBaseAmount: 'Βασικό ποσό στοιχηματισμού',
    wageringCoefficient: 'Συντελεστής στοιχηματισμού',
    wageringCount: 'Αριθμός στοιχηματισμού',
    calculationLogic: 'Λογική υπολογισμού',
    wageringParticipation: 'Συμμετοχή σε στοιχηματισμό',
    firstWalletDebited: '1ο πορτοφόλι που χρεώθηκε',
    lockAmount: 'Ποσό κλειδώματος',
    allowNonMatchingBets: 'Να επιτρέπονται στοιχήματα που δεν ταιριάζουν',
    triggerBasedConfig: 'Ενεργοποίηση βάσει διαμόρφωσης',
    lUnit: 'μονάδα',
    unitsDesc: 'Μπορείτε να δείτε τις Μονάδες αφού τις προσθέσετε και τις διαμορφώσετε από την πλαϊνή περιοχή.',
    navigationItemsDisabledInfo: 'Τα στοιχεία πλοήγησης θα ενεργοποιηθούν μετά την αποθήκευση της ενότητας Γενικά Καμπάνιας.',
    sidebarTriggerConditionInfo: 'Μπορείτε να δείτε τις Προϋποθέσεις Ενεργοποίησης αφού τις προσθέσετε και τις διαμορφώσετε από την πλαϊνή περιοχή.',
    summary: 'Σύνοψη',
    offers: 'Προσφορές',
    offersContentTabInfo:
      'Σε αυτή την περιοχή, διαμορφώνουμε εικόνες και περιεχόμενο σχετικό με την καμπάνια με τις γλώσσες της επωνυμίας, που θα μπορούν να βλέπουν οι παίκτες. Είναι υποχρεωτικό να διαμορφωθεί το περιεχόμενο με τη βασική γλώσσα της επωνυμίας',
    sidebarUnitInfo: 'Μπορείτε να δείτε τις Μονάδες αφού τις προσθέσετε και τις διαμορφώσετε από την πλαϊνή περιοχή.',
    lContent: 'περιεχόμενο',
    offersContent: 'Περιεχόμενο Μονάδων (προσφορών)',
    lOfferContent: 'περιεχόμενο προσφοράς',
    unit: 'Μονάδα',
    totalOdds: 'Συνολική απόδοση',
    minTotalOdd: 'Ελάχ. συνολικές αποδόσεις',
    maxTotalOdd: 'Μεγ. συνολικές αποδόσεις',
    sportEventConfig: 'Διαμόρφωση αθλητικού γεγονότος',
    lockType: 'Τύπος κλειδώματος',
    gamesConditionDesc: 'Ελέγχει τα παιχνίδια που έχουν ξεκινήσει για την ενεργοποίηση',
    transactionAmount: 'Ποσό συναλλαγής',
    unitName: 'Όνομα μονάδας',
    productType: 'Τύπος προϊόντος',
    isUsedInUnit: 'Χρησιμοποιήθηκε σε μονάδα',
    minBetTriggerAmount: 'Ελάχιστο ποσό ενεργοποίησης στοιχήματος',
    bonusAmount: 'Ποσό μπόνους',
    point: 'Πόντος',
    contributedFrom: 'Η συνεισφορά έγινε από',
    contributedFromDescription: 'Εδώ μπορούμε να ορίσουμε ποια στοιχήματα θα συμμετέχουν στο συνολικό τζιράρισμα των στοιχημάτων',
    sportBetsConditionDesc: 'Ελέγχει τα στοιχήματα των παικτών σε συγκεκριμένα αθλητικά γεγονότα',
    casinoBetsConditionDesc: 'Ελέγχει τα στοιχήματα των παικτών σε συγκεκριμένα παιχνίδια καζίνο',
    betAmountConfigFixedAmountDesc:
      'Επιτρέπει την παροχή ενός ποσού μπόνους που είναι σταθερό για κάθε νόμισμα (Ανά νόμισμα). Στην περίπτωση ενός σταθερού ποσού, μπορούμε να διαμορφώσουμε τις προϋποθέσεις στοιχήματος χρησιμοποιώντας τις επιλογές Μονό ή Εύρος',
    amountConfigFromBetDesc: 'Επιτρέπει την καταμέτρηση του ποσού του μπόνους ως ποσοστό από το στοίχημα (Γενικά για όλα τα νομίσματα)',
    fromBet: '% από το ποντάρισμα',
    bonusOptionsDesc5: 'Οι παίκτες θα λάβουν μπόνους για όλα τα στοιχήματα στην περίοδο ενεργοποίησης',
    gameInfo: 'Επιλεγμένοι τύποι υποστήριξης παιχνιδιού: <0>{{type}}</0>',
    freeGameType: 'Τύπος δωρεάν παιχνιδιού',
    combinations: 'Συνδυασμοί',
    involvement: 'Εμπλοκή',
    sports: 'Αθλήματα',
    tournaments: 'Τουρνουά',
    events: 'Γεγονότα',
    markets: 'Αγορές',
    allEventsAreSelected: 'Έχουν επιλεγεί όλα τα γεγονότα',
    allMarketsAreSelected: 'Έχουν επιλεγεί όλες οι αγορές',
    customSelection: 'Προσαρμοσμένη επιλογή',
    live: 'Live',
    lEvents: 'γεγονότα',
    lMarkets: 'αγορές',
    lMarket: 'αγορά',
    lEvent: 'γεγονός',
    lTournaments: 'τουρνουά',
    entitiesLimitInfo: 'Ο αριθμός μέγιστων οντοτήτων (τουρνουά, γεγονότα, αγορές) είναι {{count}}. Η επιλογή μετράει σε περίπτωση προσαρμοσμένης επιλογής',
    fromBetAmount: '% από το ποσό στοιχήματος',
    gamesCount: 'Αριθμός παιχνιδιών',
    freeSpinGamesInfo: 'Επιλέξτε πάροχο για να πάρετε παιχνίδια',
    previousUnit: 'Προηγούμενη μονάδα',
    previousUnitInfo: 'Η τρέχουσα μονάδα θα ανατεθεί μόλις τελειώσει το μπόνους της επιλεγμένης μονάδας. Αυτό ισχύει μόνο για μονάδες εντός της ίδιας ομάδας συμμετεχόντων',
    eventType: 'Τύπος γεγονότος',
    complainer: 'Παραπονούμενος',
    hashtagDescription: 'Περιγραφή hashtag',
    lPlayerBonus: 'μπόνους παίκτη',
    lPlayersBonuses: 'μπόνους παίκτη',
    playerBonus: 'Μπόνους παίκτη',
    playersBonuses: 'Μπόνους παίκτη',
    eligibleBets: 'Στοιχήματα που πληρούν τις προϋποθέσεις',
    eligibleBetsStatus: 'Κατάσταση στοιχημάτων που πληρούν τις προϋποθέσεις',
    betBuilder: 'Bet Builder',
    betBuilderTotalOdds: 'Συνολικές αποδόσεις Bet Builder',
    betBuilderMultiSelectionNum: 'Αριθμός πολλαπλών επιλογών Bet Builder',
    minBetBuilderTotalOdd: 'Ελάχιστες συνολικές αποδόσεις Bet Builder',
    maxBetBuilderTotalOdd: 'Μέγιστες συνολικές αποδόσεις Bet Builder',
    lUnitBonuses: 'μπόνους μονάδας',
    partialCancel: 'Μερική ακύρωση',
    addPlayers: 'Προσθήκη παικτών',
    pointEnhancement: 'Ενίσχυση πόντων',
    pointEnhancementInfo: 'Ενεργοποιήστε αυτήν την επιλογή για να ορίζετε έναν απαιτούμενο αριθμό στοιχημάτων για την απόκτηση κάθε μπόνους πόντου.',
    betCount: 'Αριθμός στοιχημάτων',
    bonusOptionsDesc6: 'Θα δίνονται μπόνους στους παίκτες αν καλύπτουν τις ελάχιστες απαιτήσεις στοιχημάτων και αριθμών εντός ενός πόντου και μιας καθορισμένης χρονικής περιόδου.',
    lobbyWidgetGameSegmentInfo:
      'Οι αλλαγές στο τμήμα του παιχνιδιού δεν θα επηρεάζουν την ήδη δημιουργημένη οντότητα. Θα εμφανίζονται στη λίστα μόνο τα παιχνίδια που είναι κοινά για το επιλεγμένο τμήμα και το λόμπι',
    wageringParticipationInfo: 'Τα στοιχήματα τύπου Εξαργύρωσης δεν θα περιλαμβάνονται στον υπολογισμό του τζιραρίσματος.',
    code: 'Κώδικας',
    dynamicDesc: 'Επιτρέπει τη δημιουργία προμηθειών με βάση οικονομικούς δείκτες, είτε ανά μεμονωμένο προτείνοντα είτε συνολικά από όλους τους προτείνοντες',
    progressiveDesc: 'Επιτρέπει τον καθορισμό συγκεκριμένων κλιμάκων προμήθειας με βάση τον αριθμό των προτεινόμενων παικτών',
    prizeDesc: 'Επιτρέπει τον καθορισμό ορίων προμήθειας για τη χορήγηση μιας εφάπαξ σταθερής ανταμοιβής σε νέους προτεινόμενους παίκτες και πληρούν τις απαιτούμενες προϋποθέσεις.',
    supportPlayerCancellationGameInfo1: 'Ο πάροχος επιτρέπει την ακύρωση από τον παίκτη',
    supportPlayerCancellationGameInfo2: 'Ο πάροχος δεν επιτρέπει την ακύρωση από τον παίκτη',
    bonusContentDesc: 'Μπορείτε να δείτε το {{type}} για τα μπόνους αφού τα προσθέσετε και τα ρυθμίσετε από την πλαϊνή περιοχή.',
    noUnitWithEmptyContentForLanguage: 'Δεν υπάρχει μονάδα με κενό περιεχόμενο σε αυτήν τη γλώσσα.',
    noBonusWithEmptyContent: 'Δεν υπάρχει μπόνους με κενό περιεχόμενο.',
    currentStage: 'Τρέχον στάδιο',
    inProcess: 'Σε εξέλιξη',
    placedBetAmount: 'Ποσό δηλωμένου πονταρίσματος',
    totalBetCount: 'Αριθμός συνολικού πονταρίσματος',
    placedBetCount: 'Αριθμός δηλωμένων πονταρισμάτων',
    periodDate: 'Ημερομηνία περιόδου',
    grantBonus: 'Χορήγηση μπόνους',
    bonusWillBeGrantedAfterWageringCompleted: 'Το επιλεγμένο μπόνους θα χορηγηθεί μόλις ολοκληρωθούν οι απαιτήσεις στοιχημάτων του τρέχοντος μπόνους',
    infoMaxRedeemAmount: 'Το μέγιστο ποσό εξαργύρωσης είναι {{value}}',
    infoSpinsAmount: 'Το ποσό των περιστροφών είναι {{value}}',
    infoCombinationValues: 'Οι τιμές των συνδυασμών είναι {{value}}',
    participationType: 'Τύπος συμμετοχής',
    resetToDefault: 'Επαναφορά στις προεπιλεγμένες ρυθμίσεις',
    amountRange: 'Εύρος ποσών',
    considerAsBTag: 'Θεωρήστε το ως BTAG',
    considerAsBTagInfo: 'Αυτή η επιλογή θα αντικαταστήσει το πεδίο btag εάν ο κωδικός προσφοράς ταιριάζει με αυτόν που εισήγαγε ο παίκτης',
    byPlayerID: 'Με βάση το αναγνωριστικό παίκτη',
    byTags: 'Κατά ετικέτες',
    bySegments: 'Ανά πεδία',
    dynamicSelection: 'Δυναμική επιλογή',
    staticSelection: 'Στατική επιλογή',
    deleted: 'Διαγραμμένα',
    onJoinUnitInfo: 'Καθορίζει αν αυτή η διαμόρφωση χρησιμοποιεί τις δικές της ρυθμίσεις σύνδεσης ή όχι',
    riskyGameExclusionInfo: 'Οι αλλαγές στους κινδύνους του παιχνιδιού δεν θα επηρεάσουν τις οντότητες που έχουν ήδη δημιουργηθεί',
    conditionsInfo: 'Δικαίωμα συμμετοχής έχουν μόνο οι παίκτες που έχουν προταθεί πρόσφατα. Κάθε προτεινόμενος παίκτης πρέπει να πληροί όλες τις καθορισμένες προϋποθέσεις, ώστε ο προτείνων να λάβει προμήθεια.',
    minWithdrawalAmount: 'Ελάχιστο ποσό ανάληψης',
    withdrawalAmountConfigFixedAmountDesc: 'Επιτρέπει τον καθορισμό ενός σταθερού ποσού μπόνους για κάθε νόμισμα (ανά νόμισμα). Στην περίπτωση ενός σταθερού ποσού, μπορούμε να ρυθμίσουμε τους όρους ανάληψης χρησιμοποιώντας τις επιλογές «Μία φορά» ή «Εύρος»',
    fromWithdrawal: '% από την ανάληψη',
    amountConfigFromWithdrawalDesc: 'Επιτρέπει τον υπολογισμό του ποσού του μπόνους ως ποσοστό της ανάληψης (Γενική ρύθμιση για όλα τα νομίσματα)',
    fromWithdrawalAmount: '% επί του ποσού ανάληψης',
    sourceTypes: 'Τύποι πηγών',
    unitsAllocation: 'Κατανομή μονάδων',
    unitsAllocationInfo: 'Επιλέξτε «Μία ενεργοποίηση – Όλες οι μονάδες» αν θέλετε ο παίκτης να λάβει όλες τις μονάδες που δημιουργήθηκαν με μία μόνο ενεργοποίηση. Φροντίστε να ορίσετε τις προϋποθέσεις για κάθε μονάδα με τον ίδιο τρόπο, ώστε να εκχωρηθούν όλες ταυτόχρονα, αφού περάσουν όλους τους ελέγχους.',
    providers: 'Πάροχοι',
  },
};
